import React, { useMemo, useState,useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { Typography,Card, CardContent,CardOverflow } from '@mui/joy';
import {  Box, Grid, Button, TextField, Dialog, DialogContent, DialogActions,
        Alert, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Tooltip,
        FormControl, FormControlLabel, RadioGroup, Radio , InputLabel , Select , MenuItem ,Modal, Checkbox,} from '@mui/material';
import formatPhoneNumber from '../Formats/PhoneNumberValidation';
import config from '../../AppConfig';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { fetchData, postData } from '../../redux/apiSlice';
import Loader from '../../Components/Loader/Loader';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PropTypes from 'prop-types';
import swal from "sweetalert";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ExportToCsv } from 'export-to-csv'; //or use your library of choice here
import AuthUser from '../../Components/Auth/AuthUser';
import DeleteIcon from '@mui/icons-material/Delete';
import useMediaQuery from '@mui/material/useMediaQuery';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Moment from 'moment';
import CheckIcon from '@mui/icons-material/Check';
import Switch from '@mui/material/Switch';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#E8E8E8',
      color: theme.palette.common.black,
      fontWeight: 'bold',
      fontSize: 18,
  },
  [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function truncateLongStrings(obj, maxLength = 100) {
  if (typeof obj === "string") {
    return obj.length > maxLength ? obj.slice(0, maxLength) + "..." : obj;
  } else if (Array.isArray(obj)) {
    return obj.map((item) => truncateLongStrings(item, maxLength));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = truncateLongStrings(obj[key], maxLength);
      return acc;
    }, {});
  }
  return obj;
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function ApiUser(props) {
  const [columnVisibility, setColumnVisibility] = React.useState({});
  const [rowSelection, setRowSelection] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [disableUserId, setDisableUserId] = useState();
  const [operation, setOperation] = useState("");
  const { http, httpFormData , company, user } = AuthUser();
  const [open4, setOpen4] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [data1, setData1] = useState([]);
  const [secretKeydata, setSecretKeyData] = useState([]);
  const [generated, setGenerated] = useState();
  const [isKeyGenerated, setIsKeyGenerated] = useState(false);
  const [selectedOption, setSelectedOption] = useState("immediate");
  const [alertVisible, setAlertVisible] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [isBtnDisable, setIsBtnDisable] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [software, setSoftware] = useState([]);
  const [aselectedSoftware, setaselectedSoftware] = useState([]);
  const [selectedSoftware, setSelectedSoftware] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  
  const [popupSelections1, setPopupSelections1] = useState([]);
  const [popupSelections, setPopupSelections] = useState([]);
  const [usersApiAccess, setUsersApiAccess] = useState([]);
  const [APIAccessFlag, setAPIAccessFlag] = useState('');
  const [UserId, setUserId] = useState();
  const [Status, setStatus] = useState();
  const [APIAccessOpen, setAPIAccess] = useState(false);
  const handleOpenPopup = () => {
    setPopupSelections(selectedSoftware); // Preload current selections in the popup
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const loginUser1 = JSON.parse(localStorage.getItem('user'));

  const handlePopupSelectionChange = (linkName) => {
    setPopupSelections1((prevSelections) => {
      if (prevSelections.includes(linkName)) {
        // Remove if already selected
        return prevSelections.filter((item) => item !== linkName);
      } else {
        // Add if not already selected
        return [...prevSelections, linkName];
      }
    });
  };

  const handleSaveSelections = async () => {
    handleClosePopup();
    console.log("Selected Software:", popupSelections1);
    setSelectedSoftware(popupSelections1);
    setIsLoading(true);
    const apiUrl = '/addAPIAcessSoftwares';
    const args = {
      api_access: popupSelections1
    }
    const res = await dispatch(postData({ apiUrl, args })).unwrap(); // Assuming no data payload is needed
    if (res) {
        if (res.success == true) {
            setIsLoading(false)
            swal({
              title: "Success",
              text: res.message,
              icon: "success",
              button: "Ok",
          })
        }
        else {
            setIsLoading(false)
            swal({
                title: "Failed",
                text: res.message || 'Failed to generate private key',
                icon: "error",
                button: "Ok",
            })
        }

    } else {
        setIsLoading(false)
        swal({
            title: "Failed",
            text: res?.message || 'Failed to generate private key',
            icon: "error",
            button: "Ok",
        })
    }
    fetchAPISoftware();
   
  };

  const handleChangeSwitch = (userId , status) => {
    setAPIAccessFlag(status == 1 ? false : true);
    setUserId(userId);
    setStatus(status);
    setAPIAccess(true);
  }

  const NotificationHandleClose = () => {
    setAPIAccess(false);
  };

  const changeAPIAccessStatus = () => {
    setAPIAccess(false);
    setIsLoading(true);
    const apiUrl = "/affiliate/APIAcess";
    const args = {
        id : UserId,
        status: Status
    }
    const res = dispatch(postData({ apiUrl, args })).unwrap()
    if (res) {
        // fetchUserList()
        var sta =  Status ? " Activated " : "De-activated " ;
        
        if (res) {
          console.log(res);
          swal({
            title: "Success",
            text: `API access ${sta} successfully.`,
            icon: "success",
            button: "Ok",
          })
          setIsLoading(false);
          getApiUser();
        } else {
        setIsLoading(false);
          swal({
            title: "Failed",
            text: res.message,
            icon: "error",
            button: "Ok",
          })
        }
    }
  }

  let expired = false 
  
  const checkAdminoRAffiliate = () => {
    var check = 1;
    const loginUser = JSON.parse(localStorage.getItem('user'));
    if (loginUser.roles_id != 3 && loginUser.roles_id != 9) {
      check = 0;
    }
    if (check == 0) {
      navigate('/login');
      return false;
    }
    return true;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
      setOpen(true);
  };

  const handleClickOpen4 = () => {
    setOpen4(true);
  };
  const handleClickClose4 = () => {
      setOpen4(true);
  };

  const handleClickOpen1 = () => {
      setOpen1(true);
  };

  const handleClickOpen2 = () => {
      setOpen2(true);
  };
  const handleClickClose2 = () => {
      setOpen2(false);
  };

  //Fetch software name
  const fetchSoftware = () => {
    http.get('/getAPIAcessSoftwares').then((res) => {
        if (res.data.success === true) {
            setSoftware(res.data.data)
        }
    })
  }

  const fetchAPISoftware = async () => {

    setIsLoading(true)
    const apiUrl = '/affiliate/APIAcessSoftwares';
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
        if (res.data != null) {
            setaselectedSoftware(res.data.api_access ? res.data.api_access : []);
            setPopupSelections1(res.data.api_access ? res.data.api_access : []);
            setIsLoading(false)
        }
    }
}
  

  const handleChange = (event) => {
    // handleFreezStart();
    // aidVal = event.target.value;
    // setAid(aidVal);
    // getLinks();
  }

  const generatePrivateKey = async () => {
    setIsLoading(true);
    const apiUrl = '/affiliate/createPrivateKey';
    const args = {
        expired: expired
    }
    const res = await dispatch(postData({ apiUrl, args })).unwrap(); // Assuming no data payload is needed
    if (res) {
        if (res.success == true) {
            setIsLoading(false)
            setIsKeyGenerated(true);
            setSecretKeyData(res);
            handleClickOpen4();
        }
        else {
            setIsLoading(false)
            setIsKeyGenerated(false);
            swal({
                title: "Failed",
                text: res.message || 'Failed to generate private key',
                icon: "error",
                button: "Ok",
            })
        }

    } else {
        setIsLoading(false)
        swal({
            title: "Failed",
            text: res?.message || 'Failed to generate private key',
            icon: "error",
            button: "Ok",
        })
    }
    fetchPrivateKey();
    expired = false
};
useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem('user'));
    if (loginUser.roles_id === 3 || loginUser.roles_id === 9) {
        fetchPrivateKey();
    }

    fetchAPISoftware();
    fetchSoftware();
   

}, [])

//post api end here
//fetch api start here
const fetchPrivateKey = async () => {

    setIsLoading(true)
    const apiUrl = '/affiliate/privateKey';
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
        if (res.data != null) {
            setData1(res.data);
            setIsLoading(false)
        }
        setGenerated(res.generated);
    }
}
//fetch api end here
const handleRegeneratePrivateKey = () => {
    // expired = false
    setGenerated(true);
    generatePrivateKey();

};

// Function to handle radio button change
const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
};

// Function to handle dialog confirm action
const handleConfirmDeactivate = () => {
    setIsBtnDisable(true);
    setOpen2(false);
    if (selectedOption === "immediate") {
        handleRegeneratePrivateKey();
    } else {
        expired = true
        setGenerated(true);
        generatePrivateKey();
    }
};
// Email send function start here
const handleEmail = async () => {
    const apiUrl = '/affiliate/emailPrivateKey';
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res && res.success == true) {
        setEmailSuccess(true);
        setButtonDisabled(true);
    }
}
// Email send function end here

const handleDeleteKey = async (id) => {
const loginUser = JSON.parse(localStorage.getItem('user'));
if (loginUser.roles_id != 3 && loginUser.roles_id != 9) {
  window.location.href = config.API_URL + 'login';
  return false;
}
setDeleteId(id)
setDeleteOpen(true);
}

const closeDeleteKey = () => {
const loginUser = JSON.parse(localStorage.getItem('user'));
if (loginUser.roles_id != 3 && loginUser.roles_id != 9) {
  navigate('/login');
  return false;
}
setDeleteOpen(false)
}

const handleOk = () => {
    setOpen1(false); 
    setOpen4(false); 
}

const deleteKey = async() => {
    closeDeleteKey();
    setIsLoading(true);
    const apiUrl = '/delete-client-key';
    const args = {
      id: deleteId,
    }
    const res = await dispatch(postData({apiUrl,args})).unwrap();
    if(res) {
      if (res.success === true) {
        swal({
          title: "Success",
          text: res.message,
          icon: "success",
          button: "Ok",
        })
        setIsLoading(false);
        fetchPrivateKey();
     
      } else {
        swal({
                title: "Failed",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
        if(res.message == "This action is unauthorized.") {
          navigate('/login');
        }else{
            fetchPrivateKey();
            setIsLoading(false);
        }
      }
    }
    setDeleteId('');
  };

  const csvOptions1 = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    fileName: 'Company Client Key and Secret',
    headers: ['Client Key', 'Client Secret'],
};

  const csvExporter1 = new ExportToCsv(csvOptions1);
  const handleExportRows1 = () => {
      const exportedData1 = [
          {
              'Client Key': secretKeydata.seceretId,
              'Client Secret': secretKeydata.seceretKey,
          }
      ];
    const csvContent1 = convertToCSV1(exportedData1);
    const blob = new Blob([csvContent1], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = csvOptions1.fileName + '.csv';
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
    setAlertVisible(true);
};

const convertToCSV1 = (data) => {
    const headers = csvOptions1.headers.join(',') + '\n';
    const rows = data.map((row) => Object.values(row).join(',')).join('\n');
    return headers + rows;
};

  const apiData = [
    {
      "id": "1",
      "title": "Authentication",
      "method": "POST",
      "url": `${config.API_URL}` + "/api/auth/login",
      "description": "Login as an user with API Access to generate authorization token.",
      "queryParams": [
        { "name": "email", "required": true, "description": "A unique email address for login." },
        { "name": "password", "required": true, "description": "Password for login." },
      ],
      "request": {
        "email": "example@example.com",
        "password" : "123456"
      },
      "response": {
        "success": true,
        "data": {
          "token" : "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9......."
        },
      }
    },
    {
      "id": "2",
      "title": "3B Report of member",
      // "method": "POST",
      // "url": "/v1/signup/create",
      "description": "Get member 3B report",
      "subApis": [
        {
          "id": "2-1",
          "title": "Get member 3B json",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/3B/report.json",
          "description": "Get member 3B json.",
          "queryParams": [
            { "name": "username", "required": true, "description": "Email address of the member." },
            { "name": "password", "required": true, "description": "Password of the member to login of member site." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
            // { "name": "secretKey", "required": true, "description": "The secret key for additional authorization." },
          ],
          "request": {
            "username": "example@example.com",
            "password": "123456"
          },
          "response": {
            "success": true,
            "data": {
                "BundleComponent": [
                    {
                        "Type": "TUCReportV6"
                    },
                    {
                        "Type": "EQFReportV6"
                    },
                    {
                        "Type": "EXPReportV6"
                    },
                    {
                        "Type": "TUCVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "607",
                            "scoreName": "VantageScore3",
                            "populationRank": "34",
                            "inquiriesAffectedScore": "true",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "98",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "98",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Bankruptcy is a proven indicator of risk with future payments and causes a significant drop to your credit score over an extended period of time."
                                        },
                                        {
                                            "FactorText": "factor: There is a bankruptcy on your credit report"
                                        },
                                        {
                                            "FactorText": "cando: Make all future payments on time. The impact on your credit score from the bankruptcy will diminish over time."
                                        }
                                    ]
                                }                        
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "00W40",
                                "rank": "10000"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            }
                        }
                    },
                    {
                        "Type": "EQFVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "554",
                            "scoreName": "VantageScore3",
                            "populationRank": "25",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "P32",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P32",
                                        "rank": "100000"
                                    },
                                    "FactorText": "Balances on bankcard or revolving accts not too high compared to limits"
                                }
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "05215",
                                "rank": "199"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": ""
                            }
                        }
                    },
                    {
                        "Type": "EXPVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "568",
                            "scoreName": "VantageScore3",
                            "populationRank": "27",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "98",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "98",
                                        "rank": "100000"
                                    },
                                    "FactorText": "There is a bankruptcy on your credit report"
                                }
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "VP",
                                "rank": "199"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": ""
                            }
                        }
                    },
                    {
                        "Type": "MergeCreditReports",
                        "TrueLinkCreditReportType": {
                            "FraudIndicator": "false",
                            "DeceasedIndicator": "false",
                            "SB168Frozen": {
                                "equifax": "false",
                                "experian": "false",
                                "transunion": "false"
                            },
                            "Borrower": {
                                "SocialSecurityNumber": "525993415",
                                "BorrowerAddress": [
                                    {
                                        "dateReported": "2020-10-10",
                                        "addressOrder": "0",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CEDAR CREST",
                                            "direction": "",
                                            "houseNumber": "12345",
                                            "postDirection": "",
                                            "stateCode": "NY",
                                            "streetName": "PO BOX 12345",
                                            "streetType": "",
                                            "unit": "",
                                            "postalCode": "87008"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "dateReported": "2022-09-01",
                                        "addressOrder": "2",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CEDAR CREST",
                                            "stateCode": "NY",
                                            "unparsedStreet": "1925 MONROE DR NE APT 1226 ",
                                            "postalCode": "87008"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "PreviousAddress": [
                                    {
                                        "dateReported": "2009-01-22",
                                        "addressOrder": "0",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "ST PETERSBURG",
                                            "direction": "S",
                                            "houseNumber": "6136",
                                            "stateCode": "FL",
                                            "streetName": "LYNN LAKE",
                                            "streetType": "DR",
                                            "unit": "D",
                                            "postalCode": "33712"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "dateReported": "2019-09-01",
                                        "dateUpdated": "2022-09-01",
                                        "addressOrder": "2",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "BELEN",
                                            "stateCode": "NY",
                                            "unparsedStreet": "3212 HIGHLAND PARC PL SE # 3212",
                                            "postalCode": "87002"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "Birth": [
                                    {
                                        "age": "0",
                                        "date": "1987-09-16",
                                        "partitionSet": "0",
                                        "BirthDate": {
                                            "year": "1987",
                                            "month": "9",
                                            "day": "16"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "age": "0",
                                        "date": "1987-01-01",
                                        "partitionSet": "1",
                                        "BirthDate": {
                                            "year": "1987"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "age": "0",
                                        "date": "1987-09-16",
                                        "partitionSet": "2",
                                        "BirthDate": {
                                            "year": "1987",
                                            "month": "9",
                                            "day": "16"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "CreditStatement": [
                                    {
                                        "statement": "#HK#EFCRA EXTENDED FRAUD ALERT: ACTION MAY BE REQUIRED UNDER FCRA BEFORE OPENING OR MODIFYING AN ACC",
                                        "StatementType": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    }
                                ],
                                "CreditScore": [
                                    {
                                        "riskScore": "607",
                                        "scoreName": "VantageScore3",
                                        "populationRank": "34",
                                        "inquiriesAffectedScore": "true",
                                        "CreditScoreFactor": [
                                            {
                                                "bureauCode": "98",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "98",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Bankruptcy is a proven indicator of risk with future payments and causes a significant drop to your credit score over an extended period of time."
                                                    },
                                                    {
                                                        "FactorText": "factor: There is a bankruptcy on your credit report"
                                                    },
                                                    {
                                                        "FactorText": "cando: Make all future payments on time. The impact on your credit score from the bankruptcy will diminish over time."
                                                    }
                                                ]
                                            }
                                        ],
                                        "CreditScoreModel": {
                                            "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                            "description": "VantageScore 3.0 with Positive Score Factors",
                                            "symbol": "00W40",
                                            "rank": "10000"
                                        },
                                        "NoScoreReason": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    }
                                ],
                                "Employer": [
                                    {
                                        "dateReported": "2016-05-01",
                                        "dateUpdated": "2017-07-15",
                                        "name": "HOME DEPOT",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "",
                                            "stateCode": "",
                                            "unparsedStreet": "",
                                            "postalCode": ""
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    }
                                ],
                                "BorrowerName": [
                                    {
                                        "partitionSet": "0",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "partitionSet": "1",
                                        "Name": {
                                            "first": "",
                                            "middle": "",
                                            "last": "SMITH JOHN"
                                        },
                                        "NameType": {
                                            "abbreviation": "Also Known As",
                                            "description": "Also Known As",
                                            "symbol": "A",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-27",
                                            "Reference": "MFS_56D5D3F7-6484-43EC"
                                        }
                                    },
                                    {
                                        "partitionSet": "2",
                                        "Name": {
                                            "first": "JON",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Also Known As",
                                            "description": "Also Known As",
                                            "symbol": "A",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-27",
                                            "Reference": "MFS_56D5D3F7-6484-43EC"
                                        }
                                    },
                                    {
                                        "partitionSet": "3",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "partitionSet": "4",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "SocialPartition": {
                                    "Social": [
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                }
                            },
                            "TradeLinePartition": [
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02H42001",
                                            "highBalance": "120",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFF LEND",
                                            "position": "0",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance/Personal",
                                                "description": "Finance/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CUCCCC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "163FP10645",
                                            "highBalance": "120",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFFLEND",
                                            "position": "1",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Secured",
                                                    "description": "Secured",
                                                    "symbol": "Q00EE",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "accountTypeDescription": "Primary or secondary mortgage",
                                    "accountTypeSymbol": "M",
                                    "accountTypeAbbreviation": "Mortgage",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02C82001",
                                            "highBalance": "310025",
                                            "dateVerified": "2022-04-27",
                                            "dateReported": "2022-04-27",
                                            "dateOpened": "2018-08-31",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-27",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MTG",
                                            "position": "10",
                                            "dateClosed": "2022-04-27",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance/Personal",
                                                "description": "Finance/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll/Chargeoff",
                                                "description": "Collection/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "39",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-27",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "39",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUUU321CCCCCCCCCCC",
                                                    "startDate": "2022-03-27",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-26",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2020-01-26",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-12-26",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-11-26",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-10-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-09-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-08-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-07-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-06-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-05-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-04-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-03-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-02-26",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-26",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": "MFS_0794EC06-F586-46AF"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2344320",
                                            "highBalance": "310025",
                                            "dateReported": "2022-04-27",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-01",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MORTGAGE CORP",
                                            "position": "11",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "40",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-27",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "40",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-27",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-27",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "151FM75920",
                                            "highBalance": "310025",
                                            "dateReported": "2022-04-01",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-01",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MT",
                                            "position": "12",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account/zero balance",
                                                        "description": "Closed or paid account/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Real Estate Mortgage",
                                                        "description": "Real Estate Mortgage",
                                                        "symbol": "Q00EF",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "39",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-01",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "39",
                                                "AccountType": {
                                                    "abbreviation": "Real estate mortgage",
                                                    "description": "Real estate mortgage",
                                                    "symbol": "RM",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-03-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ELW001",
                                            "highBalance": "391",
                                            "dateVerified": "2022-06-29",
                                            "dateReported": "2022-06-29",
                                            "dateOpened": "2021-06-28",
                                            "accountNumber": "B76398266N1",
                                            "dateAccountStatus": "2022-06-29",
                                            "currentBalance": "509",
                                            "creditorName": "ALDOUS",
                                            "position": "23",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll/Chargeoff",
                                                "description": "Collection/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account information disputed by consumer, meets FCRA requirements",
                                                    "description": "Account information disputed by consumer, meets FCRA requirements",
                                                    "symbol": "T00AID",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "05 FITNESS PROJECT HOUSTON NORTH",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "accountTypeDescription": "Line of credit",
                                    "accountTypeSymbol": "C",
                                    "accountTypeAbbreviation": "Credit Line",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02HF4001",
                                            "highBalance": "2189",
                                            "dateVerified": "2022-03-31",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-06",
                                            "accountNumber": "972819381739123",
                                            "dateAccountStatus": "2022-03-31",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE",
                                            "position": "37",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance/Personal",
                                                "description": "Finance/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "1557",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "Line of credit",
                                                    "description": "Line of credit",
                                                    "symbol": "LC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCC",
                                                    "startDate": "2022-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": "MFS_2249015F-86EB-49D3"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2931581",
                                            "highBalance": "2189",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "6972819381739123",
                                            "dateAccountStatus": "2022-03-01",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE INC",
                                            "position": "38",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "11",
                                                "monthlyPayment": "566",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "11",
                                                "AccountType": {
                                                    "abbreviation": "Check credit/Line of credit",
                                                    "description": "Check credit/Line of credit",
                                                    "symbol": "CLN",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCC",
                                                    "startDate": "2022-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "01DTV001",
                                            "highBalance": "596",
                                            "dateVerified": "2022-09-13",
                                            "dateReported": "2022-09-13",
                                            "dateOpened": "2020-01-23",
                                            "accountNumber": "673926492644",
                                            "dateAccountStatus": "2020-11-18",
                                            "currentBalance": "374",
                                            "creditorName": "CAPITAL ONE",
                                            "position": "2",
                                            "dateClosed": "2020-11-18",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll/Chargeoff",
                                                "description": "Collection/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Charged off as bad debt",
                                                        "description": "Charged off as bad debt",
                                                        "symbol": "TM009",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Dispute resolved; reported by grantor",
                                                        "description": "Dispute resolved; reported by grantor",
                                                        "symbol": "T00DRG",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "0",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2020-11-19",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "374",
                                                "worstPatStatusCount": "0",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "PayStatusHistory": "",
                                                "CreditLimit": "524"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1270246",
                                            "highBalance": "0",
                                            "dateReported": "2022-09-13",
                                            "dateOpened": "2020-01-01",
                                            "accountNumber": "673926492644",
                                            "dateAccountStatus": "2022-01-01",
                                            "currentBalance": "374",
                                            "creditorName": "CAPITAL ONE",
                                            "position": "3",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll/Chargeoff",
                                                "description": "Collection/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account was in dispute - now resolved - reported by subscriber.",
                                                        "description": "Account was in dispute - now resolved - reported by subscriber.",
                                                        "symbol": "E0013",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "symbol": "XC097",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "32",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "12",
                                                "dateLastPayment": "2020-11-19",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "374",
                                                "worstPatStatusCount": "32",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll/Chargeoff",
                                                    "description": "Collection/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "999999999111111111111CCCC",
                                                    "startDate": "2022-09-13",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-08-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-07-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-06-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-05-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-04-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-03-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-02-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-01-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-12-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-11-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-10-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-09-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-08-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-07-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-06-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-05-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-04-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-03-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-02-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-01-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2020-12-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-13",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-13",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "524"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "9306706",
                                            "highBalance": "6110",
                                            "dateReported": "2021-06-22",
                                            "dateOpened": "2019-03-01",
                                            "accountNumber": "84372930094736547",
                                            "dateAccountStatus": "2019-10-01",
                                            "currentBalance": "6098",
                                            "creditorName": "ACCEPTANCE NOW",
                                            "position": "14",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Furniture Rentals/Leasing",
                                                "description": "Furniture Rentals/Leasing",
                                                "symbol": "HR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll/Chargeoff",
                                                "description": "Collection/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "symbol": "XC097",
                                                    "rank": "10000"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "28",
                                                "monthlyPayment": "0",
                                                "late90Count": "3",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "21",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "28",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll/Chargeoff",
                                                    "description": "Collection/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "9UUUUUUUUUUUUUUUUUUU95432",
                                                    "startDate": "2021-06-22",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-06-22",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-05-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-01-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-12-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-11-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-10-22",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2019-09-22",
                                                            "status": "5"
                                                        },
                                                        {
                                                            "date": "2019-08-22",
                                                            "status": "4"
                                                        },
                                                        {
                                                            "date": "2019-07-22",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2019-06-22",
                                                            "status": "2"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                }
                            ],
                            "InquiryPartition": [
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-03-13",
                                        "subscriberName": "BRIDGECREST FORMERLY DRI",
                                        "subscriberNumber": "01SFX002",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "BRIDGECREST FORMERLY DRI",
                                            "telephone": "8026433864",
                                            "subscriberCode": "01SFX002",
                                            "CreditAddress": {
                                                "city": "PHOENIX ",
                                                "stateCode": "AZ",
                                                "unparsedStreet": "PO BOX 29018 ",
                                                "postalCode": "85038"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        }
                                    }
                                }
                            ],
                            "PulblicRecordPartition": [
                                {
                                    "PublicRecord": [
                                        {
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2021-06-17",
                                            "referenceNumber": "2154606",
                                            "subscriberCode": "0508601Z",
                                            "bureau": "TransUnion",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous",
                                                "description": "Miscellaneous",
                                                "symbol": "Z",
                                                "rank": "199"
                                            },
                                            "Status": {
                                                "abbreviation": "Dismissed",
                                                "description": "Dismissed",
                                                "symbol": "8",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 13 Bankruptcy",
                                                "description": "Chapter 13 Bankruptcy",
                                                "symbol": "4",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2021-12-30",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        }
                                    ]
                                }
                            ],
                            "Subscriber": [
                                {
                                    "name": "FIRST PREMIER BANK",
                                    "telephone": "6053573440",
                                    "subscriberCode": "00020123",
                                    "CreditAddress": {
                                        "city": "SIOUX FALLS ",
                                        "stateCode": "SD",
                                        "unparsedStreet": "3820 N LOUISE AVE ",
                                        "postalCode": "57104"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank",
                                        "description": "Bank",
                                        "symbol": "B",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                }
                            ],
                            "Message": [
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Extended fraud victim alert on file",
                                        "description": "Extended fraud victim alert on file",
                                        "symbol": "TK9006",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                }
                            ],
                            "Summary": {
                                "TradelineSummary": {
                                    "Experian": {
                                        "TotalAccounts": "21",
                                        "OpenAccounts": "9",
                                        "CloseAccounts": "12",
                                        "DelinquentAccounts": "2",
                                        "DerogatoryAccounts": "8",
                                        "TotalBalances": "128150",
                                        "TotalMonthlyPayments": "2025"
                                    },
                                    "Equifax": {
                                        "TotalAccounts": "13",
                                        "OpenAccounts": "8",
                                        "CloseAccounts": "5",
                                        "DelinquentAccounts": "1",
                                        "DerogatoryAccounts": "0",
                                        "TotalBalances": "120115",
                                        "TotalMonthlyPayments": "1175"
                                    },
                                    "TransUnion": {
                                        "TotalAccounts": "12",
                                        "OpenAccounts": "4",
                                        "CloseAccounts": "8",
                                        "DelinquentAccounts": "0",
                                        "DerogatoryAccounts": "2",
                                        "TotalBalances": "56755",
                                        "TotalMonthlyPayments": "1173"
                                    },
                                    "Merge": {
                                        "TotalAccounts": "24",
                                        "OpenAccounts": "4",
                                        "CloseAccounts": "8",
                                        "DelinquentAccounts": "2",
                                        "DerogatoryAccounts": "9",
                                        "TotalBalances": "128210",
                                        "TotalMonthlyPayments": "2035"
                                    }
                                },
                                "InquirySummary": {
                                    "Experian": {
                                        "NumberInLast2Years": "4"
                                    },
                                    "Equifax": {
                                        "NumberInLast2Years": "5"
                                    },
                                    "TransUnion": {
                                        "NumberInLast2Years": "8"
                                    },
                                    "Merge": {
                                        "NumberInLast2Years": "17"
                                    }
                                },
                                "PublicRecordSummary": {
                                    "Experian": {
                                        "NumberOfRecords": "3"
                                    },
                                    "Equifax": {
                                        "NumberOfRecords": "1"
                                    },
                                    "TransUnion": {
                                        "NumberOfRecords": "2"
                                    },
                                    "Merge": {
                                        "NumberOfRecords": "3"
                                    }
                                }
                            },
                            "Sources": {
                                "Source": [
                                    {
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "VFU0UjA2MjAxMU..."
                                    },
                                    {
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "MTEwMDAyO..."
                                    },
                                    {
                                        "Bureau": {
                                            "abbreviation": "Equifax",
                                            "description": "Equifax",
                                            "symbol": "EQF",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "RlVMTCAgICAgICAg..."
                                    }
                                ]
                            },
                            "SafetyCheckPassed": "true"
                        }
                    }
                ],
                "ReportDate": "2023-02-23"
            }
          }
        },
        {
          "id": "2-2",
          "title": "Get member 3B html",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/3B/report.html",
          "description": "Get member 3B html.",
          "queryParams": [
            { "name": "username", "required": true, "description": "Email address of the member." },
            { "name": "password", "required": true, "description": "Password of the member to login of member site." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
            // { "name": "secretKey", "required": true, "description": "The secret key for additional authorization." },
          ],
          "request": {
            "username": "example@example.com",
            "password": "123456"
          },
          "response": {
            "success": true,
            "data" : {
              "html": "<!DOCTYPE html><html lang='en'>    <head>        <meta charset='utf-8'>        <meta http-equiv='X-UA-Compatible' content='IE=edge'>        <meta name='viewport' content='width=device-width, initial-scale=1'>        <meta name='keywords' content='myfreescorenow,free credit score, credit score, credit report, free credit report, free score, free credit reports, credit rating, my free score now, myfreescorenow' />        <meta name='description' content='MyFreeScoreNow is committed to helping you protect, understand, and improve your credit.  Start with your Free 3 credit scores and reports.  Fast and Easy Access to Your 3-Bureau Credit Report. Delivered in Seconds.   Detect & Correct Errors.  Communicate directly with your creditors.  See How Much You Can Save.   SMS Text and Email Alerts for Changes.  $1M ID Fraud Insurance.   Tools to help you control your future credit score.' />        <meta name='author' content='MyFreeScoreNow.com - Copyright (c) 2019' />        <title>Get Your Credit Score &amp; Free Credit Report Now </title>        <link href='http://localhost:8000/css/app.css' rel='stylesheet'>        <link rel='stylesheet' type='text/css' href='https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css'>        <link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/css/flag-icon.min.css'>        <link href='http://localhost:8000/css/jquery.qtip.min.css' rel='stylesheet'><link rel='stylesheet' href='https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css' integrity='sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u' crossorigin='anonymous'><link href='http://localhost:8000/public/css/common.css' rel='stylesheet' ></link>        <style>            @media (max-width: 768px) {                .affLogo {                    border-top:1px solid gray;                    padding-top:2%;                }                .epicTextDiv {                    text-align: center;                    padding-bottom:2%;                    padding:1rem;                }            }            @media (max-width: 992px) {                .affLogo {                    border-top:1px solid gray;                    padding-top:2%;                }                .epicTextDiv {                    text-align: center;                    padding-bottom:2%;                    padding:1rem;                }            }            @media (min-width: 414px) and (max-width: 896px){                .affLogo {                    border-top:1px solid gray;                    padding-top:2%;                }                .epicTextDiv {                    text-align: center;                    padding-bottom:2%;                }            }            .epicTextDiv {                padding:1rem;            }            .topheader {                position: fixed;                top:0;                z-index:1000;                background:#ffffff;                border-bottom:.1rem solid lightgrey;                height:8rem;            }        </style>    </head>    <body>        <nav class='navbar navbar-default'>            <div class='navbar-container col-lg-12'>                <div class='col-lg-3'>                    <div class='navbar-header'>                        <ul class='nav navbar-nav'>                            <li>                                <img src='http://localhost:8000/public/images/siteLogo.jpg' class='brand_img' alt='MyFreeScoreNow.com'>"
            }
          }
        }
      ]
    },
    {
      "id": "3",
      "title": "Epic pro Report of member",
      // "method": "POST",
      // "url": "/v1/signup/create",
      "description": "Get member epic pro report",
      "subApis": [
        {
          "id": "3-1",
          "title": "Get member epic pro report json",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/3B/epic/report.json",
          "description": "Get member epic pro report json",
          "queryParams": [
            { "name": "username", "required": true, "description": "Email address of the member." },
            { "name": "password", "required": true, "description": "Password of the member to login of member site." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
            // { "name": "secretKey", "required": true, "description": "The secret key for additional authorization." },
          ],
          "request": {
            "username": "example@example.com",
            "password": "123456"
          },
          "response": {
            "success": true,
            "data" : {
                "BundleComponent": [
                    {
                        "Type": "TUCReportV6"
                    },
                    {
                        "Type": "EQFReportV6"
                    },
                    {
                        "Type": "EXPReportV6"
                    },
                    {
                        "Type": "TUCVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "607",
                            "scoreName": "VantageScore3",
                            "populationRank": "34",
                            "inquiriesAffectedScore": "true",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "98",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "98",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Bankruptcy is a proven indicator of risk with future payments and causes a significant drop to your credit score over an extended period of time."
                                        },
                                        {
                                            "FactorText": "factor: There is a bankruptcy on your credit report"
                                        },
                                        {
                                            "FactorText": "cando: Make all future payments on time. The impact on your credit score from the bankruptcy will diminish over time."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "14",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "14",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Your credit file does not contain enough information about your use of credit. A credit file with older accounts and\/or more accounts reflects more experience with handling credit and can have a positive impact on your credit score."
                                        },
                                        {
                                            "FactorText": "factor: Lack of sufficient credit history"
                                        },
                                        {
                                            "FactorText": "cando: Maintaining open and active credit accounts in good standing can help improve your credit score."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "07",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "07",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: You have had too many accounts with payments that are at least 30 days late and\/or on which a lender has reported a derogatory status. Late payments are a proven indicator of increased risk. People with late payments are at risk of being overextended, putting existing credit with lenders at risk."
                                        },
                                        {
                                            "FactorText": "factor: You have too many delinquent or derogatory accounts"
                                        },
                                        {
                                            "FactorText": "cando: Paying bills on time every month is important to maintaining a good credit score. If you remain behind with any payments, bring them current as soon as possible, and then make future payments on time. Over time, this will have a positive impact on your score."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "12",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "12",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Your oldest account is still too recent. A credit file containing older accounts will have a positive impact on your credit score because it demonstrates that you are experienced managing credit."
                                        },
                                        {
                                            "FactorText": "factor: The date that you opened your oldest account is too recent"
                                        },
                                        {
                                            "FactorText": "cando: Don't open more accounts than you actually need. Research shows that new accounts indicate greater risk. Your score will benefit as your accounts get older."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "P08",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P08",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Paying your bills on time improves your score. Recently at least one of your accounts was paid on time."
                                        },
                                        {
                                            "FactorText": "factor: One or more of your accounts were paid on time in recent months"
                                        },
                                        {
                                            "FactorText": "cando: Keep paying bills on time every month since it is important to maintaining a good credit score. If you remain behind with any payments, bring them current as soon as possible, and then make future payments on time."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "P34",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P34",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Bankcard accounts include credit cards and charge cards from a bank and are frequently revolving accounts. Revolving accounts allow you to carry a balance and your monthly payment will vary, based on the amount of your balance. The total of your balances on your open bankcard or revolving accounts, compared to the credit limit amounts, is not too high which has caused your score to improve."
                                        },
                                        {
                                            "FactorText": "factor: Total of all balances on bankcard or revolving accounts is not too high"
                                        },
                                        {
                                            "FactorText": "cando: Keep low balances on your accounts; this will benefit your score."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "P32",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P32",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Bankcard accounts include credit cards and charge cards from a bank and are frequently revolving accounts. Revolving accounts allow you to carry a balance and your monthly payment will vary, based on the amount of your balance. Your balances on bankcard or revolving accounts are not too high compared to the credit limit amounts, which causes your score to improve."
                                        },
                                        {
                                            "FactorText": "factor: Balances on bankcard or revolving accts not too high compared to limits"
                                        },
                                        {
                                            "FactorText": "cando: Keep low balances on your accounts; this will benefit your score."
                                        }
                                    ]
                                },
                                {
                                    "bureauCode": "P95",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P95",
                                        "rank": "100000"
                                    },
                                    "FactorText": [
                                        {
                                            "FactorText": "explain: Some collection agencies report account information to credit bureaus just like lenders do. Your credit file has no or few accounts that have been sent to a collection agency and remain unpaid, which increases your score."
                                        },
                                        {
                                            "FactorText": "factor: You have few or no unpaid collection agency accounts"
                                        },
                                        {
                                            "FactorText": "cando: Satisfy all collection accounts and pay all other accounts on time each month. The impact that negative items such as collections accounts have on your credit score will diminish over time."
                                        }
                                    ]
                                }
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "00W40",
                                "rank": "10000"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            }
                        }
                    },
                    {
                        "Type": "EQFVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "554",
                            "scoreName": "VantageScore3",
                            "populationRank": "25",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "P32",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P32",
                                        "rank": "100000"
                                    },
                                    "FactorText": "Balances on bankcard or revolving accts not too high compared to limits"
                                },
                                {
                                    "bureauCode": "P95",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P95",
                                        "rank": "100000"
                                    },
                                    "FactorText": "You have few or no unpaid collection agency accounts"
                                },
                                {
                                    "bureauCode": "P08",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P08",
                                        "rank": "100000"
                                    },
                                    "FactorText": "One or more of your accounts were paid on time in recent months"
                                },
                                {
                                    "bureauCode": "P07",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P07",
                                        "rank": "100000"
                                    },
                                    "FactorText": "You have either no or few delinquent or derogatory accounts"
                                }
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "05215",
                                "rank": "199"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": ""
                            }
                        }
                    },
                    {
                        "Type": "EXPVantageScoreV6",
                        "CreditScoreType": {
                            "riskScore": "568",
                            "scoreName": "VantageScore3",
                            "populationRank": "27",
                            "CreditScoreFactor": [
                                {
                                    "bureauCode": "98",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "98",
                                        "rank": "100000"
                                    },
                                    "FactorText": "There is a bankruptcy on your credit report"
                                },
                                {
                                    "bureauCode": "07",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "07",
                                        "rank": "100000"
                                    },
                                    "FactorText": "You have too many delinquent or derogatory accounts"
                                },
                                {
                                    "bureauCode": "14",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "14",
                                        "rank": "100000"
                                    },
                                    "FactorText": "Lack of sufficient credit history"
                                },
                                {
                                    "bureauCode": "12",
                                    "FactorType": "Negative",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "12",
                                        "rank": "100000"
                                    },
                                    "FactorText": "The date that you opened your oldest account is too recent"
                                },
                                {
                                    "bureauCode": "P08",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P08",
                                        "rank": "100000"
                                    },
                                    "FactorText": "One or more of your accounts were paid on time in recent months"
                                },
                                {
                                    "bureauCode": "P34",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P34",
                                        "rank": "100000"
                                    },
                                    "FactorText": "Total of all balances on bankcard or revolving accounts is not too high"
                                },
                                {
                                    "bureauCode": "P32",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P32",
                                        "rank": "100000"
                                    },
                                    "FactorText": "Balances on bankcard or revolving accts not too high compared to limits"
                                },
                                {
                                    "bureauCode": "P95",
                                    "FactorType": "Positive",
                                    "Factor": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "P95",
                                        "rank": "100000"
                                    },
                                    "FactorText": "You have few or no unpaid collection agency accounts"
                                }
                            ],
                            "CreditScoreModel": {
                                "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                "description": "VantageScore 3.0 with Positive Score Factors",
                                "symbol": "VP",
                                "rank": "199"
                            },
                            "NoScoreReason": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2023-02-23",
                                "Reference": ""
                            }
                        }
                    },
                    {
                        "Type": "MergeCreditReports",
                        "TrueLinkCreditReportType": {
                            "FraudIndicator": "false",
                            "DeceasedIndicator": "false",
                            "SB168Frozen": {
                                "equifax": "false",
                                "experian": "false",
                                "transunion": "false"
                            },
                            "Borrower": {
                                "SocialSecurityNumber": "525993415",
                                "BorrowerAddress": [
                                    {
                                        "dateReported": "2020-10-10",
                                        "addressOrder": "0",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CEDAR CREST",
                                            "direction": "",
                                            "houseNumber": "18924",
                                            "postDirection": "",
                                            "stateCode": "NY",
                                            "streetName": "PO BOX 18924",
                                            "streetType": "",
                                            "unit": "",
                                            "postalCode": "87008"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "dateReported": "2015-02-01",
                                        "dateUpdated": "2022-09-01",
                                        "addressOrder": "1",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CEDAR CREST",
                                            "stateCode": "NY",
                                            "unparsedStreet": "603 MCGILL PARK AVE NE",
                                            "postalCode": "87008"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "dateReported": "2022-09-01",
                                        "addressOrder": "2",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CEDAR CREST",
                                            "stateCode": "NY",
                                            "unparsedStreet": "1925 MONROE DR NE APT 1226 ",
                                            "postalCode": "87008"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "PreviousAddress": [
                                    {
                                        "dateReported": "2009-01-22",
                                        "addressOrder": "0",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "ST PETERSBURG",
                                            "direction": "S",
                                            "houseNumber": "6136",
                                            "stateCode": "FL",
                                            "streetName": "LYNN LAKE",
                                            "streetType": "DR",
                                            "unit": "D",
                                            "postalCode": "33712"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "addressOrder": "1",
                                        "partitionSet": "1",
                                        "CreditAddress": {
                                            "city": "ST PETERSBURG",
                                            "direction": "S",
                                            "houseNumber": "3735",
                                            "stateCode": "FL",
                                            "streetName": "ABINGTON",
                                            "streetType": "AV",
                                            "unit": "",
                                            "postalCode": "33711"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "dateReported": "2019-09-01",
                                        "dateUpdated": "2022-09-01",
                                        "addressOrder": "2",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "BELEN",
                                            "stateCode": "NY",
                                            "unparsedStreet": "3212 HIGHLAND PARC PL SE # 3212",
                                            "postalCode": "87002"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "dateReported": "2020-10-01",
                                        "dateUpdated": "2022-09-01",
                                        "addressOrder": "3",
                                        "partitionSet": "1",
                                        "CreditAddress": {
                                            "city": "LITTLETON",
                                            "stateCode": "NJ",
                                            "unparsedStreet": "2001 LAKE PARK DR SE APT M",
                                            "postalCode": "03561"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "dateReported": "2022-09-01",
                                        "addressOrder": "4",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "CORONA",
                                            "stateCode": "NY",
                                            "unparsedStreet": "3390 STRATFORD RD NE UNIT 1512 ",
                                            "postalCode": "88318"
                                        },
                                        "Dwelling": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Origin": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Ownership": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "Birth": [
                                    {
                                        "age": "0",
                                        "date": "1987-09-16",
                                        "partitionSet": "0",
                                        "BirthDate": {
                                            "year": "1987",
                                            "month": "9",
                                            "day": "16"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "age": "0",
                                        "date": "1987-01-01",
                                        "partitionSet": "1",
                                        "BirthDate": {
                                            "year": "1987"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "age": "0",
                                        "date": "1987-09-16",
                                        "partitionSet": "2",
                                        "BirthDate": {
                                            "year": "1987",
                                            "month": "9",
                                            "day": "16"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "CreditStatement": [
                                    {
                                        "statement": "#HK#EFCRA EXTENDED FRAUD ALERT: ACTION MAY BE REQUIRED UNDER FCRA BEFORE OPENING OR MODIFYING AN ACC",
                                        "StatementType": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "statement": "OUNT. CONTACT CONSUMER AT (470) 421-5485 (727) 313-1723",
                                        "StatementType": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "statement": "06& 08-15-22 0000000 ID FRAUD VICTIM ALERT FRAUDULENT APPLICATIONS MAY BE SUBMITTED IN MY NAME OR MY IDENTITY MAY HAVE BEEN USED WITHOUT MY CONSENT TO FRAUDULENTLY OBTAIN GOODS OR SERVICES. DO NOT EXTEND CREDIT WITHOUT FIRST CONTACTING ME PERSONALLY AND VERIFYING ALL APPLICATION INFORMATION AT DAY 727-804-9797. THIS VICTIM ALERT WILL BE MAINTAINED FOR SEVEN YEARS BEGINNING 08-15-22.",
                                        "StatementType": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "statement": "FRAUD VICTIM. 'EXTENDED ALERT'. CONSUMER HAS REQUESTED AN ALERT BE PLACED ON THEIR CREDIT FILE. DAYTIME 00001 7273131723 EX-00000 EVENING 00001 4704215485 EX-00000",
                                        "StatementType": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "CreditScore": [
                                    {
                                        "riskScore": "607",
                                        "scoreName": "VantageScore3",
                                        "populationRank": "34",
                                        "inquiriesAffectedScore": "true",
                                        "CreditScoreFactor": [
                                            {
                                                "bureauCode": "98",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "98",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Bankruptcy is a proven indicator of risk with future payments and causes a significant drop to your credit score over an extended period of time."
                                                    },
                                                    {
                                                        "FactorText": "factor: There is a bankruptcy on your credit report"
                                                    },
                                                    {
                                                        "FactorText": "cando: Make all future payments on time. The impact on your credit score from the bankruptcy will diminish over time."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "14",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "14",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Your credit file does not contain enough information about your use of credit. A credit file with older accounts and\/or more accounts reflects more experience with handling credit and can have a positive impact on your credit score."
                                                    },
                                                    {
                                                        "FactorText": "factor: Lack of sufficient credit history"
                                                    },
                                                    {
                                                        "FactorText": "cando: Maintaining open and active credit accounts in good standing can help improve your credit score."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "07",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "07",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: You have had too many accounts with payments that are at least 30 days late and\/or on which a lender has reported a derogatory status. Late payments are a proven indicator of increased risk. People with late payments are at risk of being overextended, putting existing credit with lenders at risk."
                                                    },
                                                    {
                                                        "FactorText": "factor: You have too many delinquent or derogatory accounts"
                                                    },
                                                    {
                                                        "FactorText": "cando: Paying bills on time every month is important to maintaining a good credit score. If you remain behind with any payments, bring them current as soon as possible, and then make future payments on time. Over time, this will have a positive impact on your score."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "12",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "12",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Your oldest account is still too recent. A credit file containing older accounts will have a positive impact on your credit score because it demonstrates that you are experienced managing credit."
                                                    },
                                                    {
                                                        "FactorText": "factor: The date that you opened your oldest account is too recent"
                                                    },
                                                    {
                                                        "FactorText": "cando: Don't open more accounts than you actually need. Research shows that new accounts indicate greater risk. Your score will benefit as your accounts get older."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "P08",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P08",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Paying your bills on time improves your score. Recently at least one of your accounts was paid on time."
                                                    },
                                                    {
                                                        "FactorText": "factor: One or more of your accounts were paid on time in recent months"
                                                    },
                                                    {
                                                        "FactorText": "cando: Keep paying bills on time every month since it is important to maintaining a good credit score. If you remain behind with any payments, bring them current as soon as possible, and then make future payments on time."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "P34",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P34",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Bankcard accounts include credit cards and charge cards from a bank and are frequently revolving accounts. Revolving accounts allow you to carry a balance and your monthly payment will vary, based on the amount of your balance. The total of your balances on your open bankcard or revolving accounts, compared to the credit limit amounts, is not too high which has caused your score to improve."
                                                    },
                                                    {
                                                        "FactorText": "factor: Total of all balances on bankcard or revolving accounts is not too high"
                                                    },
                                                    {
                                                        "FactorText": "cando: Keep low balances on your accounts; this will benefit your score."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "P32",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P32",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Bankcard accounts include credit cards and charge cards from a bank and are frequently revolving accounts. Revolving accounts allow you to carry a balance and your monthly payment will vary, based on the amount of your balance. Your balances on bankcard or revolving accounts are not too high compared to the credit limit amounts, which causes your score to improve."
                                                    },
                                                    {
                                                        "FactorText": "factor: Balances on bankcard or revolving accts not too high compared to limits"
                                                    },
                                                    {
                                                        "FactorText": "cando: Keep low balances on your accounts; this will benefit your score."
                                                    }
                                                ]
                                            },
                                            {
                                                "bureauCode": "P95",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P95",
                                                    "rank": "100000"
                                                },
                                                "FactorText": [
                                                    {
                                                        "FactorText": "explain: Some collection agencies report account information to credit bureaus just like lenders do. Your credit file has no or few accounts that have been sent to a collection agency and remain unpaid, which increases your score."
                                                    },
                                                    {
                                                        "FactorText": "factor: You have few or no unpaid collection agency accounts"
                                                    },
                                                    {
                                                        "FactorText": "cando: Satisfy all collection accounts and pay all other accounts on time each month. The impact that negative items such as collections accounts have on your credit score will diminish over time."
                                                    }
                                                ]
                                            }
                                        ],
                                        "CreditScoreModel": {
                                            "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                            "description": "VantageScore 3.0 with Positive Score Factors",
                                            "symbol": "00W40",
                                            "rank": "10000"
                                        },
                                        "NoScoreReason": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "riskScore": "568",
                                        "scoreName": "VantageScore3",
                                        "populationRank": "27",
                                        "CreditScoreFactor": [
                                            {
                                                "bureauCode": "98",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "98",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "There is a bankruptcy on your credit report"
                                            },
                                            {
                                                "bureauCode": "07",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "07",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "You have too many delinquent or derogatory accounts"
                                            },
                                            {
                                                "bureauCode": "14",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "14",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "Lack of sufficient credit history"
                                            },
                                            {
                                                "bureauCode": "12",
                                                "FactorType": "Negative",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "12",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "The date that you opened your oldest account is too recent"
                                            },
                                            {
                                                "bureauCode": "P08",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P08",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "One or more of your accounts were paid on time in recent months"
                                            },
                                            {
                                                "bureauCode": "P34",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P34",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "Total of all balances on bankcard or revolving accounts is not too high"
                                            },
                                            {
                                                "bureauCode": "P32",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P32",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "Balances on bankcard or revolving accts not too high compared to limits"
                                            },
                                            {
                                                "bureauCode": "P95",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P95",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "You have few or no unpaid collection agency accounts"
                                            }
                                        ],
                                        "CreditScoreModel": {
                                            "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                            "description": "VantageScore 3.0 with Positive Score Factors",
                                            "symbol": "VP",
                                            "rank": "199"
                                        },
                                        "NoScoreReason": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "riskScore": "554",
                                        "scoreName": "VantageScore3",
                                        "populationRank": "25",
                                        "CreditScoreFactor": [
                                            {
                                                "bureauCode": "P32",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P32",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "Balances on bankcard or revolving accts not too high compared to limits"
                                            },
                                            {
                                                "bureauCode": "P95",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P95",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "You have few or no unpaid collection agency accounts"
                                            },
                                            {
                                                "bureauCode": "P08",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P08",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "One or more of your accounts were paid on time in recent months"
                                            },
                                            {
                                                "bureauCode": "P07",
                                                "FactorType": "Positive",
                                                "Factor": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "P07",
                                                    "rank": "100000"
                                                },
                                                "FactorText": "You have either no or few delinquent or derogatory accounts"
                                            }
                                        ],
                                        "CreditScoreModel": {
                                            "abbreviation": "VantageScore 3.0 with Positive Score Factors",
                                            "description": "VantageScore 3.0 with Positive Score Factors",
                                            "symbol": "05215",
                                            "rank": "199"
                                        },
                                        "NoScoreReason": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "Employer": [
                                    {
                                        "dateReported": "2016-05-01",
                                        "dateUpdated": "2017-07-15",
                                        "name": "HOME DEPOT",
                                        "partitionSet": "0",
                                        "CreditAddress": {
                                            "city": "",
                                            "stateCode": "",
                                            "unparsedStreet": "",
                                            "postalCode": ""
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "dateUpdated": "2015-02-23",
                                        "name": "ERNST & YOUNG LLP",
                                        "partitionSet": "1",
                                        "CreditAddress": {
                                            "city": "",
                                            "stateCode": "",
                                            "unparsedStreet": "",
                                            "postalCode": ""
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    }
                                ],
                                "BorrowerName": [
                                    {
                                        "partitionSet": "0",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        }
                                    },
                                    {
                                        "partitionSet": "1",
                                        "Name": {
                                            "first": "",
                                            "middle": "",
                                            "last": "SMITH JOHN"
                                        },
                                        "NameType": {
                                            "abbreviation": "Also Known As",
                                            "description": "Also Known As",
                                            "symbol": "A",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-27",
                                            "Reference": "MFS_56D5D3F7-6484-43EC"
                                        }
                                    },
                                    {
                                        "partitionSet": "2",
                                        "Name": {
                                            "first": "JON",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Also Known As",
                                            "description": "Also Known As",
                                            "symbol": "A",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-27",
                                            "Reference": "MFS_56D5D3F7-6484-43EC"
                                        }
                                    },
                                    {
                                        "partitionSet": "3",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    },
                                    {
                                        "partitionSet": "4",
                                        "Name": {
                                            "first": "JOHN",
                                            "middle": "",
                                            "last": "SMITH"
                                        },
                                        "NameType": {
                                            "abbreviation": "Primary",
                                            "description": "Primary",
                                            "symbol": "1",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        }
                                    }
                                ],
                                "SocialPartition": {
                                    "Social": [
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "SocialSecurityNumber": "525993415",
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                }
                            },
                            "TradeLinePartition": [
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02H42001",
                                            "highBalance": "120",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFF LEND",
                                            "position": "0",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CUCCCC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "163FP10645",
                                            "highBalance": "120",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFFLEND",
                                            "position": "1",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Secured",
                                                    "description": "Secured",
                                                    "symbol": "Q00EE",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "KIKOFF LENDING LLC",
                                        "telephone": "4153614040",
                                        "subscriberCode": "02H42001",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO ",
                                            "stateCode": "CA",
                                            "unparsedStreet": "75 BROADWAY SUITE 202 ",
                                            "postalCode": "94111"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "3452FSF4RS"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Primary or secondary mortgage",
                                    "accountTypeSymbol": "M",
                                    "accountTypeAbbreviation": "Mortgage",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02C82001",
                                            "highBalance": "310025",
                                            "dateVerified": "2022-04-27",
                                            "dateReported": "2022-04-27",
                                            "dateOpened": "2018-08-31",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-27",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MTG",
                                            "position": "10",
                                            "dateClosed": "2022-04-27",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "39",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-27",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "39",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUUU321CCCCCCCCCCC",
                                                    "startDate": "2022-03-27",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-26",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2020-01-26",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-12-26",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-11-26",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-10-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-09-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-08-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-07-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-06-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-05-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-04-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-03-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-02-26",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-26",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": "MFS_0794EC06-F586-46AF"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2344320",
                                            "highBalance": "310025",
                                            "dateReported": "2022-04-27",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-01",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MORTGAGE CORP",
                                            "position": "11",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "40",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-27",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "40",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-27",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-26",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-27",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "151FM75920",
                                            "highBalance": "310025",
                                            "dateReported": "2022-04-01",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8376492642",
                                            "dateAccountStatus": "2022-04-01",
                                            "currentBalance": "0",
                                            "creditorName": "FREEDOM MT",
                                            "position": "12",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Real Estate Mortgage",
                                                        "description": "Real Estate Mortgage",
                                                        "symbol": "Q00EF",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "39",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-01",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "39",
                                                "AccountType": {
                                                    "abbreviation": "Real estate mortgage",
                                                    "description": "Real estate mortgage",
                                                    "symbol": "RM",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-03-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FREEDOM MORTGAGE",
                                        "telephone": "8663692012",
                                        "subscriberCode": "02C82001",
                                        "CreditAddress": {
                                            "city": "INDIANAPOLIS ",
                                            "stateCode": "IN",
                                            "unparsedStreet": "P.O. BOX 50485 ",
                                            "postalCode": "46250"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Finance",
                                            "description": "Mortgage Companies - Finance",
                                            "symbol": "FM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-02",
                                            "Reference": "MFS_0794EC06-F586-46AF"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "8376492642"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ELW001",
                                            "highBalance": "391",
                                            "dateVerified": "2022-06-29",
                                            "dateReported": "2022-06-29",
                                            "dateOpened": "2021-06-28",
                                            "accountNumber": "B76398266N1",
                                            "dateAccountStatus": "2022-06-29",
                                            "currentBalance": "509",
                                            "creditorName": "ALDOUS",
                                            "position": "23",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account information disputed by consumer, meets FCRA requirements",
                                                    "description": "Account information disputed by consumer, meets FCRA requirements",
                                                    "symbol": "T00AID",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "05 FITNESS PROJECT HOUSTON NORTH",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ALDOUS AND ASSOCIATES",
                                        "telephone": "8012725281",
                                        "subscriberCode": "02ELW001",
                                        "CreditAddress": {
                                            "city": "HOLLADAY ",
                                            "stateCode": "UT",
                                            "unparsedStreet": "PO BOX 171374 ",
                                            "postalCode": "84117"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Other Collection Agencies",
                                            "description": "Other Collection Agencies",
                                            "symbol": "YC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-04",
                                            "Reference": "MFS_88F25AE4-1CFA-40AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "D85797262M1"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ELW001",
                                            "highBalance": "607",
                                            "dateVerified": "2022-06-29",
                                            "dateReported": "2022-06-29",
                                            "dateOpened": "2017-09-20",
                                            "accountNumber": "B83740274H1",
                                            "dateAccountStatus": "2022-06-29",
                                            "currentBalance": "789",
                                            "creditorName": "ALDOUS",
                                            "position": "24",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Placed for collection",
                                                    "description": "Placed for collection",
                                                    "symbol": "T00CLA",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "05 GOLD S GYM HOUSTON NORTH",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ALDOUS AND ASSOCIATES",
                                        "telephone": "8012725281",
                                        "subscriberCode": "02ELW001",
                                        "CreditAddress": {
                                            "city": "HOLLADAY ",
                                            "stateCode": "UT",
                                            "unparsedStreet": "PO BOX 171374 ",
                                            "postalCode": "84117"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Other Collection Agencies",
                                            "description": "Other Collection Agencies",
                                            "symbol": "YC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-04",
                                            "Reference": "MFS_88F25AE4-1CFA-40AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "D85797262M1"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ELW001",
                                            "highBalance": "1375",
                                            "dateVerified": "2022-06-29",
                                            "dateReported": "2022-06-29",
                                            "dateOpened": "2017-09-20",
                                            "accountNumber": "D85797262M1",
                                            "dateAccountStatus": "2022-06-29",
                                            "currentBalance": "1787",
                                            "creditorName": "ALDOUS",
                                            "position": "25",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Placed for collection",
                                                    "description": "Placed for collection",
                                                    "symbol": "T00CLA",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "05 GOLDS GYM HOUSTON CYPRESS LA",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ALDOUS AND ASSOCIATES",
                                        "telephone": "8012725281",
                                        "subscriberCode": "02ELW001",
                                        "CreditAddress": {
                                            "city": "HOLLADAY ",
                                            "stateCode": "UT",
                                            "unparsedStreet": "PO BOX 171374 ",
                                            "postalCode": "84117"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Other Collection Agencies",
                                            "description": "Other Collection Agencies",
                                            "symbol": "YC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-04",
                                            "Reference": "MFS_88F25AE4-1CFA-40AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "D85797262M1"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2980920",
                                            "highBalance": "2000",
                                            "dateReported": "2022-06-20",
                                            "dateOpened": "2019-05-01",
                                            "accountNumber": "867309003826135005",
                                            "dateAccountStatus": "2019-05-01",
                                            "currentBalance": "2000",
                                            "creditorName": "PROCOLLECT,INC",
                                            "position": "26",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Customer disputed account - reported by subscriber.",
                                                    "description": "Customer disputed account - reported by subscriber.",
                                                    "symbol": "E0078",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "WOODLAND HILLS APARTMENTS OA",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "682YC10122",
                                            "highBalance": "2000",
                                            "dateReported": "2022-06-01",
                                            "dateOpened": "2019-05-01",
                                            "accountNumber": "867309003826135005",
                                            "dateAccountStatus": "2022-06-01",
                                            "currentBalance": "2000",
                                            "creditorName": "",
                                            "position": "27",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account disputed",
                                                "description": "Account disputed",
                                                "symbol": "T",
                                                "rank": "198"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Consumer disputes this account information",
                                                        "description": "Consumer disputes this account information",
                                                        "symbol": "Q00IP",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Collection account",
                                                        "description": "Collection account",
                                                        "symbol": "Q00CZ",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subject has not satisfied debt.",
                                                        "description": "Subject has not satisfied debt.",
                                                        "symbol": "QC0D",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "CollectionTrade": {
                                                "originalCreditor": "WOODLAND HILLS",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-05",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "PROCOLLECT,INC",
                                        "telephone": "2143417788",
                                        "subscriberCode": "2980920",
                                        "CreditAddress": {
                                            "city": "DALLAS",
                                            "stateCode": "TX",
                                            "unparsedStreet": "12170 ABRAMS RD STE 100",
                                            "postalCode": "75243"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-04",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "867309003826135005"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0980304",
                                            "highBalance": "1200",
                                            "dateReported": "2022-06-04",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "89826352",
                                            "dateAccountStatus": "2022-03-01",
                                            "currentBalance": "1200",
                                            "creditorName": "CONVERGENT OUTSOURCING",
                                            "position": "28",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "XFINITY MOBILE",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "701YC00488",
                                            "highBalance": "1200",
                                            "dateReported": "2022-06-01",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "89826352",
                                            "dateAccountStatus": "2022-06-01",
                                            "currentBalance": "1200",
                                            "creditorName": "",
                                            "position": "29",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Subject has not satisfied debt.",
                                                    "description": "Subject has not satisfied debt.",
                                                    "symbol": "QC0D",
                                                    "rank": "10000"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "XFINITY MOBILE",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-05",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CONVERGENT OUTSOURCING",
                                        "telephone": "8888712279",
                                        "subscriberCode": "0980304",
                                        "CreditAddress": {
                                            "city": "RENTON",
                                            "stateCode": "WA",
                                            "unparsedStreet": "800 SW 39TH ST",
                                            "postalCode": "98057"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-04",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "89826352"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Line of credit",
                                    "accountTypeSymbol": "C",
                                    "accountTypeAbbreviation": "Credit Line",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02HF4001",
                                            "highBalance": "2189",
                                            "dateVerified": "2022-03-31",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-06",
                                            "accountNumber": "972819381739123",
                                            "dateAccountStatus": "2022-03-31",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE",
                                            "position": "37",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "1557",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "Line of credit",
                                                    "description": "Line of credit",
                                                    "symbol": "LC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCC",
                                                    "startDate": "2022-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": "MFS_2249015F-86EB-49D3"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2931581",
                                            "highBalance": "2189",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "6972819381739123",
                                            "dateAccountStatus": "2022-03-01",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE INC",
                                            "position": "38",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "11",
                                                "monthlyPayment": "566",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "11",
                                                "AccountType": {
                                                    "abbreviation": "Check credit\/Line of credit",
                                                    "description": "Check credit\/Line of credit",
                                                    "symbol": "CLN",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCC",
                                                    "startDate": "2022-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "SEZZLE INC",
                                        "telephone": "8885401867",
                                        "subscriberCode": "02HF4001",
                                        "CreditAddress": {
                                            "city": "MINNEAPOLIS ",
                                            "stateCode": "MN",
                                            "unparsedStreet": "251 1ST AVE ",
                                            "postalCode": "55401"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-08-04",
                                            "Reference": "MFS_0A597468-499E-4314"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "972819381739123"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Primary or secondary mortgage",
                                    "accountTypeSymbol": "M",
                                    "accountTypeAbbreviation": "Mortgage",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02EEV001",
                                            "highBalance": "310025",
                                            "dateVerified": "2019-01-03",
                                            "dateReported": "2019-01-03",
                                            "dateOpened": "2018-08-31",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2019-01-03",
                                            "currentBalance": "0",
                                            "creditorName": "PACIFICUNION",
                                            "position": "13",
                                            "dateClosed": "2019-01-03",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Credit Union",
                                                "description": "Credit Union",
                                                "symbol": "Q",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transferred to another lender",
                                                    "description": "Transferred to another lender",
                                                    "symbol": "T00TRL",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-14",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCC",
                                                    "startDate": "2018-12-03",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2018-12-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-01-03",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": "MFS_0794EC06-F586-46AF"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2267980",
                                            "highBalance": "310025",
                                            "dateReported": "2019-01-03",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2019-01-01",
                                            "currentBalance": "0",
                                            "creditorName": "PACIFIC UNION FINANCIA",
                                            "position": "14",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transferred to another lender or claim purchased.",
                                                    "description": "Transferred to another lender or claim purchased.",
                                                    "symbol": "E0031",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-14",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCC",
                                                    "startDate": "2019-01-03",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-01-03",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-12-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-03",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "242FM00110",
                                            "highBalance": "310025",
                                            "dateReported": "2019-01-01",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2018-12-01",
                                            "currentBalance": "0",
                                            "creditorName": "PACUF",
                                            "position": "15",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account transferred or sold",
                                                        "description": "Account transferred or sold",
                                                        "symbol": "Q00BC",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Real Estate Mortgage",
                                                        "description": "Real Estate Mortgage",
                                                        "symbol": "Q00EF",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-01",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "Real estate mortgage",
                                                    "description": "Real estate mortgage",
                                                    "symbol": "RM",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUU",
                                                    "startDate": "2018-12-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2018-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-01-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "PACIFIC UNION FINANCIAL",
                                        "telephone": "8884802432",
                                        "subscriberCode": "02EEV001",
                                        "CreditAddress": {
                                            "city": "HOUSTON ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "350 HIGHLAND ",
                                            "postalCode": "77067"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Credit Union",
                                            "description": "Mortgage Companies - Credit Union",
                                            "symbol": "QM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-02",
                                            "Reference": "MFS_0794EC06-F586-46AF"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "8739287291732"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "01DTV001",
                                            "highBalance": "596",
                                            "dateVerified": "2022-09-13",
                                            "dateReported": "2022-09-13",
                                            "dateOpened": "2020-01-23",
                                            "accountNumber": "673926492644",
                                            "dateAccountStatus": "2020-11-18",
                                            "currentBalance": "374",
                                            "creditorName": "CAPITAL ONE",
                                            "position": "2",
                                            "dateClosed": "2020-11-18",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Charged off as bad debt",
                                                        "description": "Charged off as bad debt",
                                                        "symbol": "TM009",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Dispute resolved; reported by grantor",
                                                        "description": "Dispute resolved; reported by grantor",
                                                        "symbol": "T00DRG",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "0",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2020-11-19",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "374",
                                                "worstPatStatusCount": "0",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "PayStatusHistory": "",
                                                "CreditLimit": "524"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "Utilization": "71.37%"
                                        },
                                        {
                                            "subscriberCode": "1270246",
                                            "highBalance": "0",
                                            "dateReported": "2022-09-13",
                                            "dateOpened": "2020-01-01",
                                            "accountNumber": "673926492644",
                                            "dateAccountStatus": "2022-01-01",
                                            "currentBalance": "374",
                                            "creditorName": "CAPITAL ONE",
                                            "position": "3",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account was in dispute - now resolved - reported by subscriber.",
                                                        "description": "Account was in dispute - now resolved - reported by subscriber.",
                                                        "symbol": "E0013",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "symbol": "XC097",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "32",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "12",
                                                "dateLastPayment": "2020-11-19",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "374",
                                                "worstPatStatusCount": "32",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "999999999111111111111CCCC",
                                                    "startDate": "2022-09-13",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-08-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-07-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-06-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-05-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-04-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-03-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-02-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-01-12",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-12-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-11-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-10-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-09-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-08-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-07-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-06-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-05-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-04-13",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-03-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-02-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-01-12",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2020-12-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-13",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-13",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "524"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "71.37%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CAPITAL ONE",
                                        "telephone": "8009557070",
                                        "subscriberCode": "01DTV001",
                                        "CreditAddress": {
                                            "city": "SALT LAKE CITY ",
                                            "stateCode": "UT",
                                            "unparsedStreet": "PO BOX 31293 ",
                                            "postalCode": "84131"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "673926492644"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "1240000",
                                            "highBalance": "175",
                                            "dateReported": "2017-05-06",
                                            "dateOpened": "2017-04-01",
                                            "accountNumber": "7635286294394",
                                            "dateAccountStatus": "2017-05-01",
                                            "currentBalance": "0",
                                            "creditorName": "CITICARDS CBNA",
                                            "position": "4",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "symbol": "E0020",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by credit grantor.",
                                                        "symbol": "XS097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "symbol": "XC067",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "1",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "1",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "9",
                                                    "startDate": "2017-05-06",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2017-05-06",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2017-04-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-01-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-12-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-10-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-09-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-08-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-07-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-06-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-05-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-04-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-03-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-02-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-01-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-12-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-11-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-10-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-09-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-08-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-07-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-06-06",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "200"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CITICARDS CBNA",
                                        "telephone": "8009505114",
                                        "subscriberCode": "1240000",
                                        "CreditAddress": {
                                            "city": "SIOUX FALLS",
                                            "stateCode": "SD",
                                            "unparsedStreet": "PO BOX 6241",
                                            "postalCode": "57117"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "7635286294394"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "09FCR453",
                                            "highBalance": "1951",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2021-08-01",
                                            "accountNumber": "878271629281",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "0",
                                            "creditorName": "BIGHTON RENT",
                                            "position": "5",
                                            "dateClosed": "2022-05-31",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Real Estate and Public Accommodations",
                                                "description": "Real Estate and Public Accommodations",
                                                "symbol": "R",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transfer",
                                                    "description": "Transfer",
                                                    "symbol": "T00TRF",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "8",
                                                "monthlyPayment": "1951",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "8",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "133RZ02959",
                                            "highBalance": "1951",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2021-08-01",
                                            "accountNumber": "878271629281",
                                            "currentBalance": "0",
                                            "creditorName": "BRIGHTONRENT",
                                            "position": "6",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Real Estate and Public Accomodations",
                                                "description": "Miscellaneous Real Estate and Public Accomodations",
                                                "symbol": "RZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account transferred or sold",
                                                        "description": "Account transferred or sold",
                                                        "symbol": "Q00BC",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Rental agreement",
                                                        "description": "Rental agreement",
                                                        "symbol": "Q00JP",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "9",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "9",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "BIGHTON RENT",
                                        "telephone": "8674598345",
                                        "subscriberCode": "09FCR453",
                                        "CreditAddress": {
                                            "city": "WOODINVILLE ",
                                            "stateCode": "WA",
                                            "unparsedStreet": "14241 NE WOODINVILLE-DUVALL RD ",
                                            "postalCode": "98072"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Property Management",
                                            "description": "Property Management",
                                            "symbol": "RR",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "878271629281"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02HVP001",
                                            "highBalance": "3263",
                                            "dateVerified": "2022-09-01",
                                            "dateReported": "2022-09-01",
                                            "dateOpened": "2020-11-30",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "213",
                                            "creditorName": "CHIME-STRIDE",
                                            "position": "7",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-08-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2918527",
                                            "highBalance": "3263",
                                            "dateReported": "2022-09-01",
                                            "dateOpened": "2020-11-01",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "213",
                                            "creditorName": "CHIME\/STRIDE BANK NA",
                                            "position": "8",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-01",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-09-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "265FZ00034",
                                            "highBalance": "3263",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2020-11-01",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "0",
                                            "creditorName": "CHIMEF\/STR",
                                            "position": "9",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Secured credit card",
                                                        "description": "Secured credit card",
                                                        "symbol": "Q00GR",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "20",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "20",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CHIME - STRIDE BANK",
                                        "telephone": "8442446363",
                                        "subscriberCode": "02HVP001",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO ",
                                            "stateCode": "CA",
                                            "unparsedStreet": "PO BOX 417 ",
                                            "postalCode": "94104"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Bank - Mortgage Loans",
                                            "description": "Bank - Mortgage Loans",
                                            "symbol": "BM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "983627386482"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2886940",
                                            "highBalance": "2105",
                                            "dateReported": "2022-08-12",
                                            "accountNumber": "DDGAUKDYALDOL345LDD",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "0",
                                            "creditorName": "RENT SELF-REPORTED",
                                            "position": "10",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Property Management",
                                                "description": "Property Management",
                                                "symbol": "RR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "7",
                                                "monthlyPayment": "2105",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-12",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "7",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCUC",
                                                    "startDate": "2022-08-12",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-11",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-11",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-12",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "RENT SELF-REPORTED",
                                        "telephone": "8558912743",
                                        "subscriberCode": "2886940",
                                        "CreditAddress": {
                                            "city": "ALLEN",
                                            "stateCode": "TX",
                                            "unparsedStreet": "PO BOX 4500",
                                            "postalCode": "75013"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "DDGAUKDYALDOL345LDD"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02GS2001",
                                            "highBalance": "525",
                                            "dateVerified": "2021-03-10",
                                            "dateReported": "2021-03-10",
                                            "dateOpened": "2019-03-28",
                                            "accountNumber": "736293645",
                                            "dateAccountStatus": "2021-03-10",
                                            "currentBalance": "0",
                                            "creditorName": "ATLCAPBKSELF",
                                            "position": "11",
                                            "dateClosed": "2021-03-10",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "24",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "2",
                                                "late30Count": "2",
                                                "dateLastPayment": "2021-03-10",
                                                "termMonths": "24",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "24",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCC21CCCCC21CC",
                                                    "startDate": "2021-02-10",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-10",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-12-10",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-11-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-10-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-09-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-08-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-07-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-06-10",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-05-10",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-04-10",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-03-10",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2928750",
                                            "highBalance": "525",
                                            "dateReported": "2021-03-31",
                                            "dateOpened": "2019-03-01",
                                            "accountNumber": "736293645",
                                            "dateAccountStatus": "2021-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "SELF\/ATLANTIC CAPITAL",
                                            "position": "12",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "25",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "2",
                                                "late30Count": "2",
                                                "dateLastPayment": "2021-03-10",
                                                "termMonths": "24",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "25",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCCCCCCCCCCCC21CCCCC21CC",
                                                    "startDate": "2021-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-03-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-03-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "401BB42003",
                                            "highBalance": "525",
                                            "dateReported": "2021-03-01",
                                            "dateOpened": "2019-03-01",
                                            "accountNumber": "736293645",
                                            "dateAccountStatus": "2021-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "ATLANTICCA",
                                            "position": "13",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Secured",
                                                        "description": "Secured",
                                                        "symbol": "Q00EE",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "24",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "2",
                                                "late30Count": "2",
                                                "dateLastPayment": "2021-03-01",
                                                "termMonths": "24",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "24",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUU21UUUUU21UU",
                                                    "startDate": "2021-02-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-01-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-12-01",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-03-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ATLANTIC CAP BKSELFLENDR",
                                        "telephone": "8778830999",
                                        "subscriberCode": "02GS2001",
                                        "CreditAddress": {
                                            "city": "AUSTIN ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "515 CONGRESS AVE SUITE 2200 ",
                                            "postalCode": "78701"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Full Service Banks",
                                            "description": "Full Service Banks",
                                            "symbol": "BO",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "736293645"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Delinquency"
                                },
                                {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "9306706",
                                            "highBalance": "6110",
                                            "dateReported": "2021-06-22",
                                            "dateOpened": "2019-03-01",
                                            "accountNumber": "84372930094736547",
                                            "dateAccountStatus": "2019-10-01",
                                            "currentBalance": "6098",
                                            "creditorName": "ACCEPTANCE NOW",
                                            "position": "14",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Furniture Rentals\/Leasing",
                                                "description": "Furniture Rentals\/Leasing",
                                                "symbol": "HR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "symbol": "XC097",
                                                    "rank": "10000"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "28",
                                                "monthlyPayment": "0",
                                                "late90Count": "3",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "21",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "28",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "9UUUUUUUUUUUUUUUUUUU95432",
                                                    "startDate": "2021-06-22",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-06-22",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-05-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-22",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-01-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-12-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-11-21",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-10-22",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2019-09-22",
                                                            "status": "5"
                                                        },
                                                        {
                                                            "date": "2019-08-22",
                                                            "status": "4"
                                                        },
                                                        {
                                                            "date": "2019-07-22",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2019-06-22",
                                                            "status": "2"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ACCEPTANCE NOW",
                                        "telephone": "8886722411",
                                        "subscriberCode": "9306706",
                                        "CreditAddress": {
                                            "city": "PLANO",
                                            "stateCode": "TX",
                                            "unparsedStreet": "5501 HEADQUARTERS DR",
                                            "postalCode": "75024"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "R0601004500034562723"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "1918788",
                                            "highBalance": "30180",
                                            "dateReported": "2017-05-06",
                                            "dateOpened": "2015-02-01",
                                            "accountNumber": "84729472974924",
                                            "dateAccountStatus": "2017-05-01",
                                            "currentBalance": "0",
                                            "creditorName": "ALLY FINANCIAL",
                                            "position": "15",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Joint",
                                                "description": "Joint",
                                                "symbol": "J",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "symbol": "E0020",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by credit grantor.",
                                                        "symbol": "XS097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "symbol": "XC067",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "23",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "1",
                                                "late30Count": "2",
                                                "termMonths": "75",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "23",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "991U21UCCCCCCCUUUUUUUUC",
                                                    "startDate": "2017-05-06",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2017-05-06",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2017-04-06",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2017-03-05",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2017-02-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2017-01-05",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2016-12-05",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2016-11-06",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2016-10-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-09-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-08-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-07-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-06-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-05-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-04-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-03-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2016-02-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2016-01-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-12-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-11-05",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-10-06",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-09-06",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-08-06",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-07-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-06-06",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ALLY FINANCIAL",
                                        "telephone": "8002004622",
                                        "subscriberCode": "1918788",
                                        "CreditAddress": {
                                            "city": "DETROIT",
                                            "stateCode": "MI",
                                            "unparsedStreet": "200 RENAISSANCE CTR # B0",
                                            "postalCode": "48243"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "84729472974924"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0908N664",
                                            "highBalance": "1656",
                                            "dateVerified": "2017-05-06",
                                            "dateReported": "2017-05-06",
                                            "dateOpened": "2011-12-29",
                                            "accountNumber": "6646540006081",
                                            "dateAccountStatus": "2016-03-15",
                                            "currentBalance": "0",
                                            "creditorName": "WELLS FARGO",
                                            "position": "16",
                                            "dateClosed": "2016-03-15",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Unk",
                                                "description": "Unknown",
                                                "symbol": "U",
                                                "rank": "10000"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Chapter 7 bankruptcy",
                                                    "description": "Chapter 7 bankruptcy",
                                                    "symbol": "T00CBL",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "0",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-05-11",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "0",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "PayStatusHistory": "",
                                                "CreditLimit": "1200"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "Utilization": "0%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "WELLS FARGO CARD SERVICE",
                                        "telephone": "8004624720",
                                        "subscriberCode": "0908N664",
                                        "CreditAddress": {
                                            "city": "DES MOINES ",
                                            "stateCode": "IA",
                                            "unparsedStreet": "PO BOX 14517 ",
                                            "postalCode": "50306"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "6646540006081"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Derogatory"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0600631",
                                            "highBalance": "24118",
                                            "dateReported": "2021-11-10",
                                            "dateOpened": "2018-02-01",
                                            "accountNumber": "746394720490",
                                            "dateAccountStatus": "2021-11-01",
                                            "currentBalance": "0",
                                            "creditorName": "CONSUMER PORTFOLIO SVC",
                                            "position": "17",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Purchased by a another lender.",
                                                        "description": "Purchased by a another lender.",
                                                        "symbol": "E0040",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by credit grantor.",
                                                        "symbol": "XS097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "Sold to: JEFFERSON CAPITAL",
                                                    "RemarkCode": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "46",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-04-13",
                                                "termMonths": "72",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "46",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "9UUUUUUUUUU99999999999999",
                                                    "startDate": "2021-11-10",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-11-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-10-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-10",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-11-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-10-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-09-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-08-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-07-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-06-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-05-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-04-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-03-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-02-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-01-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2019-12-10",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2019-11-10",
                                                            "status": "9"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CONSUMER PORTFOLIO SVC",
                                        "telephone": "BYMAILONLY",
                                        "subscriberCode": "0600631",
                                        "CreditAddress": {
                                            "city": "IRVINE",
                                            "stateCode": "CA",
                                            "unparsedStreet": "PO BOX 57071",
                                            "postalCode": "92619"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "746394720490"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "1689430",
                                            "highBalance": "332",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2019-02-01",
                                            "accountNumber": "98800000003936927",
                                            "dateAccountStatus": "2020-09-01",
                                            "currentBalance": "444",
                                            "creditorName": "A+ LOANS",
                                            "position": "18",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                    "description": "Unpaid balance reported as a loss by credit grantor.",
                                                    "symbol": "XS097",
                                                    "rank": "10000"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "24",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-05-30",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "340",
                                                "worstPatStatusCount": "24",
                                                "AccountType": {
                                                    "abbreviation": "Note loan",
                                                    "description": "Note loan",
                                                    "symbol": "NT",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "999UUUUUUUUUUUUU99999999",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "9"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "A+ LOANS",
                                        "telephone": "6787209006",
                                        "subscriberCode": "1689430",
                                        "CreditAddress": {
                                            "city": "ATLANTA",
                                            "stateCode": "GA",
                                            "unparsedStreet": "1352 LAKEWOOD AVE SE",
                                            "postalCode": "30315"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "98800000003936927"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02FCE002",
                                            "highBalance": "1663",
                                            "dateVerified": "2022-05-18",
                                            "dateReported": "2022-05-18",
                                            "dateOpened": "2021-05-25",
                                            "accountNumber": "76483753",
                                            "dateAccountStatus": "2022-05-18",
                                            "currentBalance": "0",
                                            "creditorName": "SBNASELFLNDR",
                                            "position": "19",
                                            "dateClosed": "2022-05-18",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-05-18",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "30 Delinq",
                                                    "description": "Late 30 Days",
                                                    "symbol": "1",
                                                    "rank": "105"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUCC1CCC",
                                                    "startDate": "2022-04-18",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-18",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-03-18",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-17",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-17",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-17",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-11-17",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-18",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-18",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-17",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-17",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-17",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-17",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-18",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-18",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1188380",
                                            "highBalance": "1663",
                                            "dateReported": "2022-06-06",
                                            "dateOpened": "2021-05-01",
                                            "accountNumber": "76483753",
                                            "dateAccountStatus": "2022-06-01",
                                            "currentBalance": "0",
                                            "creditorName": "SBNASELFLNDR",
                                            "position": "20",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "30 Delinq",
                                                "description": "Late 30 Days",
                                                "symbol": "1",
                                                "rank": "105"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "14",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "3",
                                                "dateLastPayment": "2022-05-18",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "14",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "30 Delinq",
                                                    "description": "Late 30 Days",
                                                    "symbol": "1",
                                                    "rank": "105"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "1C1CCCC1CCCCCC",
                                                    "startDate": "2022-06-06",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-06-06",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2022-05-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-06",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2022-03-05",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-05",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-05",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-05",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-06",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-10-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-06",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "436BB00879",
                                            "highBalance": "1663",
                                            "dateReported": "2022-06-01",
                                            "dateOpened": "2021-05-01",
                                            "accountNumber": "76483753",
                                            "dateAccountStatus": "2022-04-01",
                                            "currentBalance": "0",
                                            "creditorName": "SBNASLFLDR",
                                            "position": "21",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "11",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "1",
                                                "dateLastPayment": "2022-04-01",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "11",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "30 Delinq",
                                                    "description": "Late 30 Days",
                                                    "symbol": "1",
                                                    "rank": "105"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUU1UUUUUU",
                                                    "startDate": "2022-05-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "SUNRISE BANK SELF LENDER",
                                        "telephone": "6052502620",
                                        "subscriberCode": "02FCE002",
                                        "CreditAddress": {
                                            "city": "AUSTIN ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "515 CONGRESS AVE, SUITE 2200 C\/O SELF FINANCIAL, INC. ",
                                            "postalCode": "78701"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Banks",
                                            "description": "Miscellaneous Banks",
                                            "symbol": "BZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "76483753"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Delinquency"
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "1453090",
                                            "highBalance": "0",
                                            "dateReported": "2022-09-13",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "8543271930201630",
                                            "dateAccountStatus": "2022-06-01",
                                            "currentBalance": "106",
                                            "creditorName": "GREEN DOT BANK",
                                            "position": "22",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                    "symbol": "XC097",
                                                    "rank": "10000"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "73",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "2",
                                                "late30Count": "1",
                                                "dateLastPayment": "2016-10-02",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "106",
                                                "worstPatStatusCount": "73",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "9999UUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-09-13",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-08-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-07-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-06-13",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2022-05-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-03-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-12",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-13",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-13",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "1000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "10.60%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "GREEN DOT BANK",
                                        "telephone": "6094540337",
                                        "subscriberCode": "1453090",
                                        "CreditAddress": {
                                            "city": "PASADENA",
                                            "stateCode": "CA",
                                            "unparsedStreet": "PO BOX 5100",
                                            "postalCode": "91117"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "8543271930201630"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2919349",
                                            "highBalance": "25",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "CSHRLED45A",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "12",
                                            "creditorName": "KIKOFF LENDING LLC",
                                            "position": "23",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "17",
                                                "monthlyPayment": "2",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-29",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "17",
                                                "AccountType": {
                                                    "abbreviation": "Charge account",
                                                    "description": "Charge account",
                                                    "symbol": "CH",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "500"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "2.40%"
                                        },
                                        {
                                            "subscriberCode": "163FP10645",
                                            "highBalance": "0",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "CSHRLED45A",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "12",
                                            "creditorName": "KIKOFFLEND",
                                            "position": "24",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Charge",
                                                        "description": "Charge",
                                                        "symbol": "Q00AV",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Amount in H\/C column is credit limit",
                                                        "description": "Amount in H\/C column is credit limit",
                                                        "symbol": "Q00AZ",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "16",
                                                "monthlyPayment": "2",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "16",
                                                "AccountType": {
                                                    "abbreviation": "Charge account",
                                                    "description": "Charge account",
                                                    "symbol": "CH",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "500"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "2.40%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "KIKOFF LENDING LLC",
                                        "telephone": "4153614040",
                                        "subscriberCode": "2919349",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO",
                                            "stateCode": "CA",
                                            "unparsedStreet": "75 BROADWAY STE 226",
                                            "postalCode": "94111"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "CSHRLED45A"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02E4W001",
                                            "highBalance": "1987",
                                            "dateVerified": "2019-03-28",
                                            "dateReported": "2019-03-28",
                                            "dateOpened": "2018-11-23",
                                            "accountNumber": "04500034562723",
                                            "dateAccountStatus": "2019-03-28",
                                            "currentBalance": "0",
                                            "creditorName": "ACEPTANCENOW",
                                            "position": "25",
                                            "dateClosed": "2019-03-28",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCC",
                                                    "startDate": "2019-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "9306706",
                                            "highBalance": "1987",
                                            "dateReported": "2019-03-31",
                                            "dateOpened": "2018-11-01",
                                            "accountNumber": "R0601004500034562723",
                                            "dateAccountStatus": "2019-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "ACCEPTANCE NOW",
                                            "position": "26",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Furniture Rentals\/Leasing",
                                                "description": "Furniture Rentals\/Leasing",
                                                "symbol": "HR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "5",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "5",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCCC",
                                                    "startDate": "2019-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-03-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "242HZ00053",
                                            "highBalance": "1987",
                                            "dateReported": "2020-11-01",
                                            "dateOpened": "2018-11-01",
                                            "accountNumber": "1004500034562723",
                                            "dateAccountStatus": "2019-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "ACCPTNOW",
                                            "position": "27",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Home Furnishings",
                                                "description": "Miscellaneous Home Furnishings",
                                                "symbol": "HZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Rental agreement",
                                                        "description": "Rental agreement",
                                                        "symbol": "Q00JP",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-01",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUU",
                                                    "startDate": "2020-10-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-02-29",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ACCEPTANCENOW",
                                        "telephone": "8002752696",
                                        "subscriberCode": "02E4W001",
                                        "CreditAddress": {
                                            "city": "PLANO ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "5501 HEADQUARTERS DRIVE ",
                                            "postalCode": "75024"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "04500034562723"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ANW004",
                                            "highBalance": "424",
                                            "dateVerified": "2021-03-31",
                                            "dateReported": "2021-03-31",
                                            "dateOpened": "2020-03-18",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-02-26",
                                            "currentBalance": "0",
                                            "creditorName": "SELFINC\/LEAD",
                                            "position": "28",
                                            "dateClosed": "2021-03-02",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account closed by consumer",
                                                    "description": "Account closed by consumer",
                                                    "symbol": "T00CBC",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-26",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCC",
                                                    "startDate": "2021-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "425"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "2932264",
                                            "highBalance": "465",
                                            "dateReported": "2021-03-31",
                                            "dateOpened": "2020-03-01",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "SELF FINANCIAL\/LEAD BA",
                                            "position": "29",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Credit line closed - consumer request - reported by subscriber.",
                                                    "description": "Credit line closed - consumer request - reported by subscriber.",
                                                    "symbol": "E0019",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "13",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-26",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "13",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCCCCCCCCCCC",
                                                    "startDate": "2021-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-03-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "425"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "786BB00902",
                                            "highBalance": "425",
                                            "dateReported": "2021-03-01",
                                            "dateOpened": "2020-03-01",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-02-01",
                                            "currentBalance": "0",
                                            "creditorName": "SELF\/LEADB",
                                            "position": "30",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account closed at consumer's request",
                                                        "description": "Account closed at consumer's request",
                                                        "symbol": "Q00IR",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUU",
                                                    "startDate": "2021-02-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-03-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "SELF FINANCIAL INC \/ LEA",
                                        "telephone": "8778830999",
                                        "subscriberCode": "02ANW004",
                                        "CreditAddress": {
                                            "city": "AUSTIN ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "901 E. 6TH STREET SUITE #400 ",
                                            "postalCode": "78702"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Sales Financing",
                                            "description": "Sales Financing",
                                            "symbol": "FF",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "9834598271"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "01SFX002",
                                            "highBalance": "49287",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-03-09",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGECREST",
                                            "position": "31",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "5",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-28",
                                                "termMonths": "72",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "5",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "8602240",
                                            "highBalance": "49287",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGECREST",
                                            "position": "32",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-28",
                                                "termMonths": "72",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "152AU11874",
                                            "highBalance": "49287",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGCREST",
                                            "position": "33",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Dealers, Used",
                                                "description": "Auto Dealers, Used",
                                                "symbol": "AU",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Auto",
                                                    "description": "Auto",
                                                    "symbol": "Q00AO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "BRIDGECREST FORMERLY DRI",
                                        "telephone": "8026433864",
                                        "subscriberCode": "01SFX002",
                                        "CreditAddress": {
                                            "city": "PHOENIX ",
                                            "stateCode": "AZ",
                                            "unparsedStreet": "PO BOX 29018 ",
                                            "postalCode": "85038"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Auto Financing",
                                            "description": "Auto Financing",
                                            "symbol": "FA",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "726946298734"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CSN003",
                                            "highBalance": "148",
                                            "dateVerified": "2016-06-29",
                                            "dateReported": "2016-06-29",
                                            "dateOpened": "2016-06-06",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-06-29",
                                            "currentBalance": "0",
                                            "creditorName": "WEBBNK\/FSTR",
                                            "position": "34",
                                            "dateClosed": "2016-06-29",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Department\/Variety and Other Retail",
                                                "description": "Department\/Variety and Other Retail",
                                                "symbol": "D",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "0",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-26",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "0",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "PayStatusHistory": "",
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2244980",
                                            "highBalance": "0",
                                            "dateReported": "2016-07-07",
                                            "dateOpened": "2016-06-01",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-07-01",
                                            "currentBalance": "0",
                                            "creditorName": "WEBBANK\/FINGERHUT FRES",
                                            "position": "35",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "2",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-26",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "2",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UC",
                                                    "startDate": "2016-07-07",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2016-07-07",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2016-06-07",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-05-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-04-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-03-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-01-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-12-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-10-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-09-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-08-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-07-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-06-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-05-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-04-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-03-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-01-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-12-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-10-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-09-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-08-07",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "401DM00387",
                                            "highBalance": "148",
                                            "dateReported": "2020-11-01",
                                            "dateOpened": "2016-06-01",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-06-01",
                                            "currentBalance": "0",
                                            "creditorName": "FHUT\/WEBBK",
                                            "position": "36",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mail Order Firms",
                                                "description": "Mail Order Firms",
                                                "symbol": "DP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Installment sales contract",
                                                        "description": "Installment sales contract",
                                                        "symbol": "Q00KA",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "1",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-01",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "1",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "U",
                                                    "startDate": "2020-10-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-02-29",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "WEBBANK\/FRESHSTART",
                                        "telephone": "8667340342",
                                        "subscriberCode": "02CSN003",
                                        "CreditAddress": {
                                            "city": "EDEN PRAIRIE ",
                                            "stateCode": "MN",
                                            "unparsedStreet": "13300 PIONEER TRAIL ",
                                            "postalCode": "55347"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Variety Store",
                                            "description": "Variety Store",
                                            "symbol": "DV",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "657873625183722"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2244970",
                                            "highBalance": "273",
                                            "dateReported": "2017-05-06",
                                            "dateOpened": "2016-06-01",
                                            "accountNumber": "785636992105648",
                                            "dateAccountStatus": "2017-05-01",
                                            "currentBalance": "0",
                                            "creditorName": "WEBBANK\/FINGERHUT",
                                            "position": "37",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Credit Card - Dept. Store",
                                                "description": "Credit Card - Dept. Store",
                                                "symbol": "1D",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Purchased by a another lender.",
                                                        "description": "Purchased by a another lender.",
                                                        "symbol": "E0040",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by credit grantor.",
                                                        "symbol": "XS097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                        "symbol": "XC067",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "11",
                                                "monthlyPayment": "0",
                                                "late90Count": "1",
                                                "late60Count": "1",
                                                "late30Count": "1",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "11",
                                                "AccountType": {
                                                    "abbreviation": "Charge account",
                                                    "description": "Charge account",
                                                    "symbol": "CH",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "99321CCCCCC",
                                                    "startDate": "2017-05-06",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2017-05-06",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2017-04-06",
                                                            "status": "9"
                                                        },
                                                        {
                                                            "date": "2017-03-05",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2017-02-05",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2017-01-05",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2016-12-05",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-11-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-10-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-09-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-08-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-07-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-06-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-05-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-04-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-03-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-02-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-01-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-12-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-11-05",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-10-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-09-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-08-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-07-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-06-06",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "WEBBANK\/FINGERHUT",
                                        "telephone": "",
                                        "subscriberCode": "2244970",
                                        "CreditAddress": {
                                            "city": "SAINT CLOUD",
                                            "stateCode": "MN",
                                            "unparsedStreet": "6250 RIDGEWOOD RD",
                                            "postalCode": "56303"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "785636992105648"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2886930",
                                            "highBalance": "860",
                                            "dateReported": "2022-09-16",
                                            "accountNumber": "AADHKSH281630DFT564",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "860",
                                            "creditorName": "TELECOM SELF-REPORTED",
                                            "position": "38",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Telephone Companies",
                                                "description": "Telephone Companies",
                                                "symbol": "UT",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "8",
                                                "monthlyPayment": "860",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-16",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "8",
                                                "AccountType": {
                                                    "abbreviation": "Unknown - credit extension, review, or collection",
                                                    "description": "Unknown - credit extension, review, or collection",
                                                    "symbol": "UNK",
                                                    "rank": "100"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CUUUUCCC",
                                                    "startDate": "2022-09-16",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-08-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-07-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-15",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-16",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "TELECOM SELF-REPORTED",
                                        "telephone": "8558912743",
                                        "subscriberCode": "2886930",
                                        "CreditAddress": {
                                            "city": "ALLEN",
                                            "stateCode": "TX",
                                            "unparsedStreet": "PO BOX 4500",
                                            "postalCode": "75013"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "AADHKSH281630DFT564"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "1132610",
                                            "highBalance": "47496",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2009-09-01",
                                            "accountNumber": "15362871281",
                                            "dateAccountStatus": "2016-10-01",
                                            "currentBalance": "62491",
                                            "creditorName": "US DEPT OF ED\/GLELSI",
                                            "position": "39",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                    "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                    "symbol": "E0020",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "87",
                                                "monthlyPayment": "0",
                                                "late90Count": "2",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "87",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCUUUUUUUUUUUUCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "668FZ67126",
                                            "highBalance": "47496",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2009-09-01",
                                            "accountNumber": "15362871281",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "62491",
                                            "creditorName": "USD\/GLELSI",
                                            "position": "40",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account disputed",
                                                "description": "Account disputed",
                                                "symbol": "T",
                                                "rank": "198"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Consumer disputes after resolution",
                                                        "description": "Consumer disputes after resolution",
                                                        "symbol": "Q00IQ",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "99",
                                                "monthlyPayment": "0",
                                                "late90Count": "2",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "99",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "US DEPT OF ED\/GLELSI",
                                        "telephone": "8002364300",
                                        "subscriberCode": "1132610",
                                        "CreditAddress": {
                                            "city": "MADISON",
                                            "stateCode": "WI",
                                            "unparsedStreet": "PO BOX 7860",
                                            "postalCode": "53707"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "87927492345"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Delinquency"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0494T94D",
                                            "highBalance": "21857",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2007-08-01",
                                            "accountNumber": "64864379283A00001",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "26319",
                                            "creditorName": "AES\/NCT",
                                            "position": "127",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Joint",
                                                "description": "Joint",
                                                "symbol": "J",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "90 Delinq",
                                                "description": "Late 90 Days",
                                                "symbol": "3",
                                                "rank": "103"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Dispute resolved; customer disagrees",
                                                    "description": "Dispute resolved; customer disagrees",
                                                    "symbol": "T00DRC",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "291",
                                                "late90Count": "2",
                                                "late60Count": "2",
                                                "late30Count": "5",
                                                "dateLastPayment": "2022-05-18",
                                                "termMonths": "240",
                                                "collateral": "",
                                                "amountPastDue": "830",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "21C1CCCCC4321CUUUUUUCUUUUUUUUC11CCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "4"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-05-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "8997791",
                                            "highBalance": "21857",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2007-08-01",
                                            "accountNumber": "64864379283A00001",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "26319",
                                            "creditorName": "AES\/NCT",
                                            "position": "128",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Joint",
                                                "description": "Joint",
                                                "symbol": "J",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "90 Delinq",
                                                "description": "Late 90 Days",
                                                "symbol": "3",
                                                "rank": "103"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                    "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                    "symbol": "E0020",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "99",
                                                "monthlyPayment": "291",
                                                "late90Count": "3",
                                                "late60Count": "2",
                                                "late30Count": "5",
                                                "dateLastPayment": "2022-05-18",
                                                "termMonths": "240",
                                                "collateral": "",
                                                "amountPastDue": "830",
                                                "worstPatStatusCount": "99",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "321C1CCCCC4321CUUUUUUCUUU",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "4"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496FZ06166",
                                            "highBalance": "21857",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2007-08-01",
                                            "accountNumber": "64864379283A00001",
                                            "dateAccountStatus": "2022-03-01",
                                            "currentBalance": "26319",
                                            "creditorName": "AES\/NCTR",
                                            "position": "129",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Joint",
                                                "description": "Joint",
                                                "symbol": "J",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account disputed",
                                                "description": "Account disputed",
                                                "symbol": "T",
                                                "rank": "198"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "90 Delinq",
                                                "description": "Late 90 Days",
                                                "symbol": "3",
                                                "rank": "103"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Consumer disputes after resolution",
                                                        "description": "Consumer disputes after resolution",
                                                        "symbol": "Q00IQ",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "99",
                                                "monthlyPayment": "291",
                                                "late90Count": "2",
                                                "late60Count": "2",
                                                "late30Count": "5",
                                                "dateLastPayment": "2022-03-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "830",
                                                "worstPatStatusCount": "99",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "21U1UUUUU4321UUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "4"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "3"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "AES\/NCT",
                                        "telephone": "8002330557",
                                        "subscriberCode": "0494T94D",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 61047 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "64864379283A00001"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Derogatory"
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "6000",
                                            "dateVerified": "2015-09-25",
                                            "dateReported": "2015-09-25",
                                            "dateOpened": "2014-08-26",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2015-09-25",
                                            "currentBalance": "0",
                                            "creditorName": "FEDLOAN",
                                            "position": "8",
                                            "dateClosed": "2015-09-25",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Refi",
                                                "description": "Refinanced",
                                                "symbol": "R",
                                                "rank": "40"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account closed due to refinance",
                                                    "description": "Account closed due to refinance",
                                                    "symbol": "T00ACR",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2015-09-25",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCC",
                                                    "startDate": "2015-08-25",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2015-08-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-07-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-06-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-05-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-04-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-03-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-02-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-01-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-12-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-11-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-10-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-09-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-08-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-07-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-06-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-05-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-04-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-03-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-02-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-01-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-12-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-10-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-09-25",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "6000",
                                            "dateReported": "2015-09-01",
                                            "dateOpened": "2014-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2015-09-01",
                                            "currentBalance": "0",
                                            "creditorName": "FEDLOAN",
                                            "position": "9",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Refinanced",
                                                        "description": "Refinanced",
                                                        "symbol": "Q00CE",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2015-09-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUU",
                                                    "startDate": "2015-08-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2015-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-09-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "6181",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-19",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "6988",
                                            "creditorName": "FEDLOAN",
                                            "position": "12",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCUUUUUUUUUUUUUUCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "6181",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "6988",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "13",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "30",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "30",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCUUUUUUUUUUUUUUCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "6181",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "6988",
                                            "creditorName": "FEDLOAN",
                                            "position": "14",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "68",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "68",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "10250",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2020-08-17",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "10250",
                                            "creditorName": "FEDLOAN",
                                            "position": "43",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "10250",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2020-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "10250",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "44",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "22",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "22",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "10250",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2020-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "10250",
                                            "creditorName": "FEDLOAN",
                                            "position": "45",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "5500",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-19",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "5793",
                                            "creditorName": "FEDLOAN",
                                            "position": "15",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCUUUUUUUUUUUUUUCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "5500",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "5793",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "16",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "30",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "30",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCUUUUUUUUUUUUUUCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "5500",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "5793",
                                            "creditorName": "FEDLOAN",
                                            "position": "17",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "68",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "68",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0368N4TP",
                                            "highBalance": "4897",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2008-12-17",
                                            "accountNumber": "87927492345",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "6935",
                                            "creditorName": "USDOE\/GLELSI",
                                            "position": "41",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCUUUUUUUUUUUUCCCCCCCCCUCUUUUUUUUUUUC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-02-27",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1132610",
                                            "highBalance": "4897",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2008-12-01",
                                            "accountNumber": "87927492345",
                                            "dateAccountStatus": "2016-09-01",
                                            "currentBalance": "6935",
                                            "creditorName": "US DEPT OF ED\/GLELSI",
                                            "position": "42",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "88",
                                                "monthlyPayment": "0",
                                                "late90Count": "2",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "88",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCUUUUUUUUUUUUCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "668FZ65280",
                                            "highBalance": "4897",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2008-12-01",
                                            "accountNumber": "87927492345",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "6935",
                                            "creditorName": "USD\/GLELSI",
                                            "position": "43",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Student loan",
                                                    "description": "Student loan",
                                                    "symbol": "Q00BU",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "99",
                                                "monthlyPayment": "0",
                                                "late90Count": "2",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "99",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "120 Delinq",
                                                    "description": "Late 120 Days",
                                                    "symbol": "4",
                                                    "rank": "102"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "US DEPT OF EDUCATION\/GLE",
                                        "telephone": "8002364300",
                                        "subscriberCode": "0368N4TP",
                                        "CreditAddress": {
                                            "city": "MADISON ",
                                            "stateCode": "WI",
                                            "unparsedStreet": "2401 INTERNATIONAL LANE POB 7859 ",
                                            "postalCode": "53704"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "87927492345"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Delinquency"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0204K003",
                                            "highBalance": "128",
                                            "dateVerified": "2022-09-25",
                                            "dateReported": "2022-09-25",
                                            "dateOpened": "2022-05-16",
                                            "accountNumber": "946662930283",
                                            "dateAccountStatus": "2022-09-25",
                                            "currentBalance": "128",
                                            "creditorName": "MED DATA SYS",
                                            "position": "18",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Placed for collection",
                                                    "description": "Placed for collection",
                                                    "symbol": "T00CLA",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "KENNESTONE HOSPITAL",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-10-17",
                                                "Reference": "MFS_73EEBD7E-1756-49F1"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1982731",
                                            "highBalance": "128",
                                            "dateReported": "2022-09-25",
                                            "dateOpened": "2022-05-01",
                                            "accountNumber": "946662930283",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "128",
                                            "creditorName": "MEDICAL DATA SYSTEMS I",
                                            "position": "19",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "KENNESTONE HOSPITAL",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-10-17",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "835YC00000",
                                            "highBalance": "128",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-05-01",
                                            "accountNumber": "946662930283",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "128",
                                            "creditorName": "",
                                            "position": "20",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Medical",
                                                        "description": "Medical",
                                                        "symbol": "Q00GS",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subject has not satisfied debt.",
                                                        "description": "Subject has not satisfied debt.",
                                                        "symbol": "QC0D",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "CollectionTrade": {
                                                "originalCreditor": "",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-10-17",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "MEDICAL DATA SYSTEMS INC",
                                        "telephone": "8003156050",
                                        "subscriberCode": "0204K003",
                                        "CreditAddress": {
                                            "city": "SEBRING ",
                                            "stateCode": "FL",
                                            "unparsedStreet": "1532 LAKEVIEW DR ",
                                            "postalCode": "33870"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Other Collection Agencies",
                                            "description": "Other Collection Agencies",
                                            "symbol": "YC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-10-17",
                                            "Reference": "MFS_73EEBD7E-1756-49F1"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "946662930283"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Collection Account",
                                    "accountTypeSymbol": "Y",
                                    "accountTypeAbbreviation": "Collection",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "0925M001",
                                            "highBalance": "99",
                                            "dateVerified": "2022-10-04",
                                            "dateReported": "2022-10-04",
                                            "dateOpened": "2020-09-29",
                                            "accountNumber": "7569044",
                                            "dateAccountStatus": "2022-10-04",
                                            "currentBalance": "150",
                                            "creditorName": "ARMADA COR",
                                            "position": "42",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Collection Services",
                                                "description": "Collection Services",
                                                "symbol": "Y",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Placed for collection",
                                                    "description": "Placed for collection",
                                                    "symbol": "T00CLA",
                                                    "rank": "199"
                                                }
                                            },
                                            "CollectionTrade": {
                                                "originalCreditor": "HOLA DENTAL CHEYENNE",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-11-01",
                                                "Reference": "MFS_14356E72-A030-494F"
                                            }
                                        },
                                        {
                                            "subscriberCode": "712YC00000",
                                            "highBalance": "99",
                                            "dateReported": "2022-10-01",
                                            "dateOpened": "2020-09-01",
                                            "accountNumber": "7569044",
                                            "dateAccountStatus": "2022-10-01",
                                            "currentBalance": "150",
                                            "creditorName": "",
                                            "position": "43",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Derog",
                                                "description": "Derogatory",
                                                "symbol": "F",
                                                "rank": "20"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Coll\/Chargeoff",
                                                "description": "Collection\/Chargeoff",
                                                "symbol": "9",
                                                "rank": "2"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Medical",
                                                        "description": "Medical",
                                                        "symbol": "Q00GS",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subject has not satisfied debt.",
                                                        "description": "Subject has not satisfied debt.",
                                                        "symbol": "QC0D",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "CollectionTrade": {
                                                "originalCreditor": "",
                                                "creditType": {
                                                    "abbreviation": "Collection",
                                                    "description": "Collection Account",
                                                    "symbol": "Y",
                                                    "rank": "5"
                                                }
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-11-01",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ARMADA CORPORATION",
                                        "telephone": "8009492372",
                                        "subscriberCode": "0925M001",
                                        "CreditAddress": {
                                            "city": "EAST WENATCHEE ",
                                            "stateCode": "WA",
                                            "unparsedStreet": "93 EASTMONT AVE SUITE #100 ",
                                            "postalCode": "98802"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Other Collection Agencies",
                                            "description": "Other Collection Agencies",
                                            "symbol": "YC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-11-01",
                                            "Reference": "MFS_14356E72-A030-494F"
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "7569044"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "ChargeOff"
                                },
                                {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2925066",
                                            "highBalance": "1560",
                                            "dateReported": "2021-12-06",
                                            "dateOpened": "2021-02-01",
                                            "accountNumber": "834729362937639",
                                            "dateAccountStatus": "2021-11-01",
                                            "currentBalance": "1444",
                                            "creditorName": "TOMOCREDIT INC",
                                            "position": "44",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Credit Card - Finance Company",
                                                "description": "Credit Card - Finance Company",
                                                "symbol": "1F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "60 Delinq",
                                                "description": "Late 60 Days",
                                                "symbol": "2",
                                                "rank": "104"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "**CONSUMER STATEMENT** ACCOUNT WAS PAID BEFORE BEING TURNED OVER TO A COLLECTION AGENCY.",
                                                "RemarkCode": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "2",
                                                "late30Count": "1",
                                                "dateLastPayment": "2021-08-15",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "1444",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "Credit Card",
                                                    "description": "Credit Card",
                                                    "symbol": "CC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "221CCCCCCC",
                                                    "startDate": "2021-12-06",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-12-06",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-11-06",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-10-06",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-09-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-06",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-03-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-06",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "2000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "72.20%"
                                        },
                                        {
                                            "subscriberCode": "163FZ06207",
                                            "highBalance": "0",
                                            "dateReported": "2022-03-01",
                                            "dateOpened": "2021-02-01",
                                            "accountNumber": "834729362937639",
                                            "dateAccountStatus": "2021-09-01",
                                            "currentBalance": "1444",
                                            "creditorName": "TOMOCREDIT",
                                            "position": "45",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "60 Delinq",
                                                "description": "Late 60 Days",
                                                "symbol": "2",
                                                "rank": "104"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Amount in H\/C column is credit limit",
                                                    "description": "Amount in H\/C column is credit limit",
                                                    "symbol": "Q00AZ",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "3",
                                                "late30Count": "1",
                                                "dateLastPayment": "2021-09-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "1444",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "22U21UUUUUUUU",
                                                    "startDate": "2022-02-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-02-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2022-01-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "2"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "1"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-03-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "2000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "72.20%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "TOMOCREDIT INC",
                                        "telephone": "2028581034",
                                        "subscriberCode": "2925066",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO",
                                            "stateCode": "CA",
                                            "unparsedStreet": "535 MISSION ST FL 14",
                                            "postalCode": "94105"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Bad",
                                        "accountID": "834729362937639"
                                    },
                                    "accountStatus": "Negative",
                                    "accountSeverity": "Delinquency"
                                }
                            ],
                            "InquiryPartition": [
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-03-13",
                                        "subscriberName": "BRIDGECREST FORMERLY DRI",
                                        "subscriberNumber": "01SFX002",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "BRIDGECREST FORMERLY DRI",
                                            "telephone": "8026433864",
                                            "subscriberCode": "01SFX002",
                                            "CreditAddress": {
                                                "city": "PHOENIX ",
                                                "stateCode": "AZ",
                                                "unparsedStreet": "PO BOX 29018 ",
                                                "postalCode": "85038"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Good",
                                            "accountID": "726946298734"
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-02-28",
                                        "subscriberName": "KIKOFF LENDING LLC",
                                        "subscriberNumber": "02H42001",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "KIKOFF LENDING LLC",
                                            "telephone": "4153614040",
                                            "subscriberCode": "02H42001",
                                            "CreditAddress": {
                                                "city": "SAN FRANCISCO ",
                                                "stateCode": "CA",
                                                "unparsedStreet": "75 BROADWAY SUITE 202 ",
                                                "postalCode": "94111"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Good",
                                            "accountID": "3452FSF4RS"
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-09-05",
                                        "subscriberName": "DISCOVER FINANCIAL SER",
                                        "subscriberNumber": "B6",
                                        "bureau": "Experian",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-02",
                                        "subscriberName": "BK OF AMER",
                                        "subscriberNumber": "06199555",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Bank Credit Cards",
                                            "description": "Bank Credit Cards",
                                            "symbol": "BC",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "BANK OF AMERICA",
                                            "telephone": "8004212110",
                                            "subscriberCode": "06199555",
                                            "CreditAddress": {
                                                "city": "EL PASO ",
                                                "stateCode": "TX",
                                                "unparsedStreet": "PO BOX 982238 ",
                                                "postalCode": "79998"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-02",
                                        "subscriberName": "TRUIST",
                                        "subscriberNumber": "456BB09024",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-02",
                                        "subscriberName": "TRUIST",
                                        "subscriberNumber": "456BB12441",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-08-15",
                                        "subscriberName": "LIGHTSTREAM",
                                        "subscriberNumber": "06525583",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Installment Loans",
                                            "description": "Installment Loans",
                                            "symbol": "BI",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "SUNTRUST DBA LIGHTSTREAM",
                                            "telephone": "8007868787",
                                            "subscriberCode": "06525583",
                                            "CreditAddress": {
                                                "city": "SAN DIEGO ",
                                                "stateCode": "CA",
                                                "unparsedStreet": "600 W BROADWAY SUITE 2000 ",
                                                "postalCode": "92101"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-05-18",
                                        "subscriberName": "SYNCB\/CC",
                                        "subscriberNumber": "04877646",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Sales Financing",
                                            "description": "Sales Financing",
                                            "symbol": "FF",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "SYNCB\/CARE CREDIT",
                                            "telephone": "8009242927",
                                            "subscriberCode": "04877646",
                                            "CreditAddress": {
                                                "city": "DAYTON ",
                                                "stateCode": "OH",
                                                "unparsedStreet": "PO BOX 8726 ",
                                                "postalCode": "45401"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-13",
                                        "subscriberName": "CREDIT PLUS",
                                        "subscriberNumber": "00049997",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Credit Bureaus\/Mortgage Processing",
                                            "description": "Credit Bureaus\/Mortgage Processing",
                                            "symbol": "ZM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "CREDIT PLUS",
                                            "telephone": "8002583488",
                                            "subscriberCode": "00049997",
                                            "CreditAddress": {
                                                "city": "SALISBURY ",
                                                "stateCode": "MD",
                                                "unparsedStreet": "31550 WINTERPLACE ",
                                                "postalCode": "21804"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous",
                                                "description": "Miscellaneous",
                                                "symbol": "Z",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-13",
                                        "subscriberName": "XACTUS-CP\/ASSURANCE FI",
                                        "subscriberNumber": "B6",
                                        "bureau": "Experian",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Finance",
                                            "description": "Mortgage Companies - Finance",
                                            "symbol": "FM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-06-13",
                                        "subscriberName": "XACTUS",
                                        "subscriberNumber": "801ZB00982",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2020-09-17",
                                        "subscriberName": "BRIDGECREST",
                                        "subscriberNumber": "01SFX002",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "Subscriber": {
                                            "name": "BRIDGECREST FORMERLY DRI",
                                            "telephone": "8026433864",
                                            "subscriberCode": "01SFX002",
                                            "CreditAddress": {
                                                "city": "PHOENIX ",
                                                "stateCode": "AZ",
                                                "unparsedStreet": "PO BOX 29018 ",
                                                "postalCode": "85038"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Good",
                                            "accountID": "726946298734"
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-09-22",
                                        "subscriberName": "PANORAMA MOR",
                                        "subscriberNumber": "06335039",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Credit Union",
                                            "description": "Mortgage Companies - Credit Union",
                                            "symbol": "QM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "CREDIT PLUS\/PANORAMA MOR",
                                            "telephone": "7025885430",
                                            "subscriberCode": "06335039",
                                            "CreditAddress": {
                                                "city": "LAS VEGAS ",
                                                "stateCode": "NV",
                                                "unparsedStreet": "350 S RAMPART BLVD STE 310 ",
                                                "postalCode": "89145"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Credit Union",
                                                "description": "Credit Union",
                                                "symbol": "Q",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-09-22",
                                        "subscriberName": "XACTUS-CP\/PANORAMA MOR",
                                        "subscriberNumber": "B6",
                                        "bureau": "Experian",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Finance",
                                            "description": "Mortgage Companies - Finance",
                                            "symbol": "FM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-09-22",
                                        "subscriberName": "XACTUS",
                                        "subscriberNumber": "243ZB01899",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-07-08",
                                        "subscriberName": "CORELOGIC",
                                        "subscriberNumber": "02964510",
                                        "bureau": "TransUnion",
                                        "inquiryType": "I",
                                        "IndustryCode": {
                                            "abbreviation": "Bank - Mortgage Loans",
                                            "description": "Bank - Mortgage Loans",
                                            "symbol": "BM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "Subscriber": {
                                            "name": "CREDCO\/BAC 5",
                                            "telephone": "8004476192",
                                            "subscriberCode": "02964510",
                                            "CreditAddress": {
                                                "city": "PASADENA ",
                                                "stateCode": "CA",
                                                "unparsedStreet": "35 N LAKE AVE ",
                                                "postalCode": "91101"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-07-08",
                                        "subscriberName": "CORELOGIC CREDCO LLC",
                                        "subscriberNumber": "B6",
                                        "bureau": "Experian",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Reporters",
                                            "description": "Mortgage Reporters",
                                            "symbol": "FR",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                },
                                {
                                    "Inquiry": {
                                        "inquiryDate": "2022-07-08",
                                        "subscriberName": "CORELOGIC",
                                        "subscriberNumber": "181ZB16539",
                                        "bureau": "Equifax",
                                        "inquiryType": "",
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Equifax",
                                                "description": "Equifax",
                                                "symbol": "EQF",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                                    }
                                }
                            ],
                            "PulblicRecordPartition": [
                                {
                                    "PublicRecord": [
                                        {
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2021-06-17",
                                            "referenceNumber": "2154606",
                                            "subscriberCode": "0508601Z",
                                            "bureau": "TransUnion",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous",
                                                "description": "Miscellaneous",
                                                "symbol": "Z",
                                                "rank": "199"
                                            },
                                            "Status": {
                                                "abbreviation": "Dismissed",
                                                "description": "Dismissed",
                                                "symbol": "8",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 13 Bankruptcy",
                                                "description": "Chapter 13 Bankruptcy",
                                                "symbol": "4",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2021-12-30",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "courtName": "US BKPT CT GA ATLANTA",
                                            "dateFiled": "2021-06-17",
                                            "referenceNumber": "2154606PB",
                                            "subscriberCode": "8000",
                                            "bureau": "Experian",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Status": {
                                                "abbreviation": "Dismissed",
                                                "description": "Dismissed",
                                                "symbol": "8",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 13 Bankruptcy",
                                                "description": "Chapter 13 Bankruptcy",
                                                "symbol": "4",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2021-12-30",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2021-01-21",
                                            "referenceNumber": "2150547",
                                            "subscriberCode": "0508601Z",
                                            "bureau": "TransUnion",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous",
                                                "description": "Miscellaneous",
                                                "symbol": "Z",
                                                "rank": "199"
                                            },
                                            "Status": {
                                                "abbreviation": "Dismissed",
                                                "description": "Dismissed",
                                                "symbol": "8",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 13 Bankruptcy",
                                                "description": "Chapter 13 Bankruptcy",
                                                "symbol": "4",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2021-06-03",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "courtName": "US BKPT CT GA ATLANTA",
                                            "dateFiled": "2021-01-21",
                                            "referenceNumber": "2150547PB",
                                            "subscriberCode": "8000",
                                            "bureau": "Experian",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Status": {
                                                "abbreviation": "Dismissed",
                                                "description": "Dismissed",
                                                "symbol": "8",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 13 Bankruptcy",
                                                "description": "Chapter 13 Bankruptcy",
                                                "symbol": "4",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2021-06-03",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "courtName": "US BKPT CT GA ATLANTA",
                                            "dateFiled": "2017-05-06",
                                            "referenceNumber": "1758283LRC",
                                            "subscriberCode": "8000",
                                            "bureau": "Experian",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Status": {
                                                "abbreviation": "Discharged",
                                                "description": "Discharged",
                                                "symbol": "1",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 7 Bankruptcy",
                                                "description": "Chapter 7 Bankruptcy",
                                                "symbol": "1",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "dateResolved": "2017-10-10",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "courtName": "Federal",
                                            "dateFiled": "2017-05-01",
                                            "referenceNumber": "1758283-DSP-10\/17-VER-05\/22",
                                            "subscriberCode": "401VF00077",
                                            "bureau": "Equifax",
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "Classification": {
                                                "abbreviation": "Bankruptcy",
                                                "description": "Bankruptcy",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Federal",
                                                "description": "Federal",
                                                "symbol": "VF",
                                                "rank": "199"
                                            },
                                            "Status": {
                                                "abbreviation": "Discharged",
                                                "description": "Discharged",
                                                "symbol": "1",
                                                "rank": "199"
                                            },
                                            "Type": {
                                                "abbreviation": "Chapter 7 Bankruptcy",
                                                "description": "Chapter 7 Bankruptcy",
                                                "symbol": "1",
                                                "rank": "199"
                                            },
                                            "Bankruptcy": {
                                                "courtNumber": "",
                                                "division": "",
                                                "assetAmount": "0",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0",
                                                "trustee": "",
                                                "company": "",
                                                "thirdParty": ""
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_C8C8B549-234E-4711",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2018-12-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-06-07",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "04887436",
                                            "referenceNumber": "1874321",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT VA NORFOLK",
                                            "dateFiled": "2018-12-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-06-07",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "5204",
                                            "referenceNumber": "1874321FJS",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2018-12-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "832VF00013",
                                            "referenceNumber": "1874321-DSP-06\/21-VER-01\/24",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_9E3E6BEF-ED5F-448F",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-08"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2017-10-16",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2018-05-02",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05105335",
                                            "referenceNumber": "1711666",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Remark": {
                                                "RemarkCode": {
                                                    "rank": "199",
                                                    "symbol": "Q00FW",
                                                    "description": "Consumer disputes - reinvestigation in progress",
                                                    "abbreviation": "Consumer disputes - reinvestigation in progress"
                                                },
                                                "customRemark": ""
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-08"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2017-10-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "669VF02570",
                                            "referenceNumber": "1711666-DSP-05\/18",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_3322368C-477B-4515",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2016-12-29",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-04-04",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0512324J",
                                            "referenceNumber": "1680413",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT TX HOUSTON",
                                            "dateFiled": "2016-12-29",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-04-04",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "4234",
                                            "referenceNumber": "1680413MI",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2016-12-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "605VF49449",
                                            "referenceNumber": "1680413-DSP-04\/17",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_03F66D85-CB1C-4248",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-28"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2021-02-12",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-09-28",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05000411",
                                            "referenceNumber": "2141203",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-28"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BK CT-EAST DIST MIC",
                                            "dateFiled": "2021-02-12",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-09-28",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "5500",
                                            "referenceNumber": "2141203MLO",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-28"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2021-02-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "168VF00077",
                                            "referenceNumber": "2141203-DSP-09\/21",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_A0EDA754-EB54-4A8C",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-08-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2014-12-19",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-04-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05080454",
                                            "referenceNumber": "1417919",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-08-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT OH CLEVELAN",
                                            "dateFiled": "2014-12-19",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-04-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1056",
                                            "referenceNumber": "1417919AIH",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-08-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2014-12-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "645VF09306",
                                            "referenceNumber": "1417919-DSP-04\/15-VER-05\/23",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_490C3B0D-A527-4135",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-07"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2015-04-28",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-09-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0508726P",
                                            "referenceNumber": "1516683",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-07"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT CA L A",
                                            "dateFiled": "2015-04-28",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-09-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1002",
                                            "referenceNumber": "1516683RMN",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-07"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2015-04-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "180VF00014",
                                            "referenceNumber": "1516683-DSP-09\/15",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_A100A2B4-4284-440A",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-06"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2022-11-15",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-03-30",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05000411",
                                            "referenceNumber": "2248976",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-06"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BK CT-EAST DIST MIC",
                                            "dateFiled": "2022-11-15",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-03-30",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "5500",
                                            "referenceNumber": "2248976TJT",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-06"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2022-11-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "168VF00077",
                                            "referenceNumber": "2248976-DSP-03\/23",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EXP",
                                                "description": "Experian",
                                                "abbreviation": "Experian"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-01-01"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "8",
                                            "description": "Dismissed",
                                            "abbreviation": "Dismissed"
                                        },
                                        "bureau": "Experian",
                                        "courtName": "US BKPT CT IL CHICAGO",
                                        "dateFiled": "2018-08-06",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "dateResolved": "2018-09-20",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "100000",
                                            "symbol": "",
                                            "description": "",
                                            "abbreviation": ""
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "1000",
                                        "referenceNumber": "1822026TAB",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EQF",
                                                "description": "Equifax",
                                                "abbreviation": "Equifax"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-01-01"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "8",
                                            "description": "Dismissed",
                                            "abbreviation": "Dismissed"
                                        },
                                        "bureau": "Equifax",
                                        "courtName": "Federal",
                                        "dateFiled": "2018-08-01",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "199",
                                            "symbol": "VF",
                                            "description": "Federal",
                                            "abbreviation": "Federal"
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "155VF00015",
                                        "referenceNumber": "1822026-DSP-09\/18-VER-11\/21",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EXP",
                                                "description": "Experian",
                                                "abbreviation": "Experian"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-01-01"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "8",
                                            "description": "Dismissed",
                                            "abbreviation": "Dismissed"
                                        },
                                        "bureau": "Experian",
                                        "courtName": "US BKPT CT IL CHICAGO",
                                        "dateFiled": "2018-08-06",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "dateResolved": "2018-09-20",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "100000",
                                            "symbol": "",
                                            "description": "",
                                            "abbreviation": ""
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "1000",
                                        "referenceNumber": "1822026TAB",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EQF",
                                                "description": "Equifax",
                                                "abbreviation": "Equifax"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-01-01"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "8",
                                            "description": "Dismissed",
                                            "abbreviation": "Dismissed"
                                        },
                                        "bureau": "Equifax",
                                        "courtName": "Federal",
                                        "dateFiled": "2018-08-01",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "199",
                                            "symbol": "VF",
                                            "description": "Federal",
                                            "abbreviation": "Federal"
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "155VF00015",
                                        "referenceNumber": "1822026-DSP-09\/18-VER-11\/21",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EXP",
                                                "description": "Experian",
                                                "abbreviation": "Experian"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-03-19"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "8",
                                            "description": "Dismissed",
                                            "abbreviation": "Dismissed"
                                        },
                                        "bureau": "Experian",
                                        "courtName": "US BKPT CT GA ATLANTA",
                                        "dateFiled": "2018-06-15",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "dateResolved": "2018-09-25",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "100000",
                                            "symbol": "",
                                            "description": "",
                                            "abbreviation": ""
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "8000",
                                        "referenceNumber": "1860054PB",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_147778B5-036A-417D",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-09-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2018-11-26",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-04-05",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "04841347",
                                            "referenceNumber": "1877914",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-09-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT NY WESTBURY",
                                            "dateFiled": "2018-11-26",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-04-05",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1011",
                                            "referenceNumber": "1877914AST",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2023-09-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2018-11-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "404VF00389",
                                            "referenceNumber": "1877914-DSP-04\/19",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_C2DDBFA1-1338-4E89",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-27"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2019-02-23",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2022-02-23",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05060203",
                                            "referenceNumber": "1904746",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-27"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT IL CHICAGO",
                                            "dateFiled": "2019-02-23",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2022-02-23",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1000",
                                            "referenceNumber": "1904746DDC",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-27"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2019-02-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "155VF00015",
                                            "referenceNumber": "1904746-DSP-02\/22",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_42D38528-F6DD-43FB",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-09"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2020-09-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-01-07",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05100374",
                                            "referenceNumber": "2024404",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-09"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT TN MEMPHIS",
                                            "dateFiled": "2020-09-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-01-07",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "2200",
                                            "referenceNumber": "2024404JDL",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-09"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2020-09-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "833VF00046",
                                            "referenceNumber": "2024404-DSP-01\/21",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_084478AC-61CC-472B",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-18"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2019-07-31",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-12-12",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0512324H",
                                            "referenceNumber": "1932528",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-18"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT TX DALLAS",
                                            "dateFiled": "2019-07-31",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-12-12",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "4238",
                                            "referenceNumber": "1932528BJH",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-18"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2019-07-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "682VF05117",
                                            "referenceNumber": "1932528-DSP-12\/19",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_460344E0-FF68-4ECB",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-05"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2023-06-27",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-09-26",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05060203",
                                            "referenceNumber": "2308434",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-05"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT IL CHICAGO",
                                            "dateFiled": "2023-06-27",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-09-26",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1000",
                                            "referenceNumber": "2308434JPC",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_7833F33D-FA22-497A",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2022-08-17",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2022-11-22",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0508735L",
                                            "referenceNumber": "2202150",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT CA SAN DIEG",
                                            "dateFiled": "2022-08-17",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2022-11-22",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1004",
                                            "referenceNumber": "2202150CBL",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2022-08-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "180VF00022",
                                            "referenceNumber": "2202150-DSP-11\/22",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_07D12D9A-9CDA-408D",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2015-06-25",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-10-09",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "04850108",
                                            "referenceNumber": "1521959",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT NJ TRENTON",
                                            "dateFiled": "2015-06-25",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2015-10-09",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "2000",
                                            "referenceNumber": "1521959MBK",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2015-06-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "444VF00605",
                                            "referenceNumber": "1521959-DSP-10\/15",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_88EAE37B-B45E-4B51",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2019-03-15",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-06-24",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0508726P",
                                            "referenceNumber": "1912796",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT CA L A",
                                            "dateFiled": "2019-03-15",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2019-06-24",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1002",
                                            "referenceNumber": "1912796EMR",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-04"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2019-03-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "180VF00014",
                                            "referenceNumber": "1912796-DSP-06\/19",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_91DC654D-08E0-4F65",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2016-05-12",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-08-22",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05100374",
                                            "referenceNumber": "1624480",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT TN MEMPHIS",
                                            "dateFiled": "2016-05-12",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-08-22",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "2200",
                                            "referenceNumber": "1624480JDL",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2016-05-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "833VF00046",
                                            "referenceNumber": "1624480-DSP-08\/16",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_DC3A9767-F824-4196",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-26"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2016-07-16",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-11-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0508601Z",
                                            "referenceNumber": "1662371",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-26"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT GA ATLANTA",
                                            "dateFiled": "2016-07-16",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-11-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "8000",
                                            "referenceNumber": "1662371MGD",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-01-26"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2016-07-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "401VF00077",
                                            "referenceNumber": "1662371-DSP-11\/16",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_1E02AB5A-7943-4DC9",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2020-03-06",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2020-05-06",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05064313",
                                            "referenceNumber": "2013154",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT FL MIAMI",
                                            "dateFiled": "2020-03-06",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2020-05-06",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "7000",
                                            "referenceNumber": "2013154LMI",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Remark": {
                                                "RemarkCode": {
                                                    "rank": "199",
                                                    "symbol": "Q00FW",
                                                    "description": "Consumer disputes - reinvestigation in progress",
                                                    "abbreviation": "Consumer disputes - reinvestigation in progress"
                                                },
                                                "customRemark": ""
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-01"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2020-03-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "402VF01074",
                                            "referenceNumber": "2013154-DSP-05\/20",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_478220CF-A76A-4CF2",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-05-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2020-10-26",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-02-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0506113V",
                                            "referenceNumber": "2011816",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-05-02"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT AZ PHOENIX",
                                            "dateFiled": "2020-10-26",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2021-02-08",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0001",
                                            "referenceNumber": "2011816PS",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "J",
                                                "description": "Joint",
                                                "abbreviation": "Joint"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_A1D8F1D5-268D-48D7",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-08"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2017-11-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2018-02-26",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "02C2W001",
                                            "referenceNumber": "1725146",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-08"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT MD BALTIMOR",
                                            "dateFiled": "2017-11-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2018-02-26",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "5000",
                                            "referenceNumber": "1725146DER",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_9F78B436-E4FD-4889",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-21"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2017-08-09",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-11-20",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0508735Q",
                                            "referenceNumber": "1725262",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-21"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT CA SACRAMEN",
                                            "dateFiled": "2017-08-09",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-11-20",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1003",
                                            "referenceNumber": "1725262MSM",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Remark": {
                                                "RemarkCode": {
                                                    "rank": "199",
                                                    "symbol": "Q00FW",
                                                    "description": "Consumer disputes - reinvestigation in progress",
                                                    "abbreviation": "Consumer disputes - reinvestigation in progress"
                                                },
                                                "customRemark": ""
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-03-21"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2017-08-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "236VF00092",
                                            "referenceNumber": "1725262-DSP-11\/17-VER-03\/23",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": {
                                        "Type": {
                                            "rank": "199",
                                            "symbol": "4",
                                            "description": "Chapter 13 Bankruptcy",
                                            "abbreviation": "Chapter 13 Bankruptcy"
                                        },
                                        "Source": {
                                            "Bureau": {
                                                "rank": "1",
                                                "symbol": "EXP",
                                                "description": "Experian",
                                                "abbreviation": "Experian"
                                            },
                                            "Reference": "",
                                            "BorrowerKey": "",
                                            "InquiryDate": "2024-02-06"
                                        },
                                        "Status": {
                                            "rank": "199",
                                            "symbol": "1",
                                            "description": "Discharged",
                                            "abbreviation": "Discharged"
                                        },
                                        "bureau": "Experian",
                                        "courtName": "US BKPT CT IN HAMMOND",
                                        "dateFiled": "2018-09-14",
                                        "Bankruptcy": {
                                            "company": "",
                                            "trustee": "",
                                            "division": "",
                                            "thirdParty": "",
                                            "assetAmount": "0",
                                            "courtNumber": "",
                                            "dateResolved": "2023-12-07",
                                            "exemptAmount": "0",
                                            "liabilityAmount": "0"
                                        },
                                        "IndustryCode": {
                                            "rank": "100000",
                                            "symbol": "",
                                            "description": "",
                                            "abbreviation": ""
                                        },
                                        "Classification": {
                                            "rank": "199",
                                            "symbol": "B",
                                            "description": "Bankruptcy",
                                            "abbreviation": "Bankruptcy"
                                        },
                                        "subscriberCode": "8000",
                                        "referenceNumber": "1822453KL",
                                        "AccountDesignator": {
                                            "rank": "199",
                                            "symbol": "I",
                                            "description": "Individual",
                                            "abbreviation": "Individual"
                                        }
                                    }
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_6C1720DA-7B88-4E86",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-13"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2015-02-02",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-05-02",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05064306",
                                            "referenceNumber": "1511987",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-13"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT FL FT LAUDE",
                                            "dateFiled": "2015-02-02",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2016-05-02",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0061",
                                            "referenceNumber": "1511987RBR",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-13"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2015-02-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "402VF12828",
                                            "referenceNumber": "1511987-DSP-05\/16",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_56957241-DDA4-48DC",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2022-12-30",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-03-09",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05060203",
                                            "referenceNumber": "2215009",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT IL CHICAGO",
                                            "dateFiled": "2022-12-30",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2023-03-09",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1000",
                                            "referenceNumber": "2215009TAB",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-29"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2022-12-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "155VF00015",
                                            "referenceNumber": "2215009-DSP-03\/23-VER-03\/24",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_97A4BFDC-E4C1-45A4",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-18"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2017-07-11",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2018-04-11",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05105384",
                                            "referenceNumber": "1750883",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-18"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT LA LAKE CHA",
                                            "dateFiled": "2017-07-11",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2018-04-11",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "0003",
                                            "referenceNumber": "1750883RS",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_4D66CB05-B748-48BA",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2019-05-08",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2020-02-13",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05074186",
                                            "referenceNumber": "1930620",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BKPT CT NC CHARLOTT",
                                            "dateFiled": "2019-05-08",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2020-02-13",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "1048",
                                            "referenceNumber": "1930620LTB",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "4",
                                                "description": "Chapter 13 Bankruptcy",
                                                "abbreviation": "Chapter 13 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EQF",
                                                    "description": "Equifax",
                                                    "abbreviation": "Equifax"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-04-25"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "8",
                                                "description": "Dismissed",
                                                "abbreviation": "Dismissed"
                                            },
                                            "bureau": "Equifax",
                                            "courtName": "Federal",
                                            "dateFiled": "2019-05-01",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "VF",
                                                "description": "Federal",
                                                "abbreviation": "Federal"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "805VF85006",
                                            "referenceNumber": "1930620-DSP-02\/20",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "PublicRecord": [
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "TUC",
                                                    "description": "TransUnion",
                                                    "abbreviation": "TransUnion"
                                                },
                                                "Reference": "MFS_6B48A1EC-F246-4A00",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-24"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "TransUnion",
                                            "courtName": "U.S. Bankruptcy Court",
                                            "dateFiled": "2016-11-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-02-15",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "199",
                                                "symbol": "ZP",
                                                "description": "Public Records",
                                                "abbreviation": "Public Records"
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "05000411",
                                            "referenceNumber": "1655278",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        },
                                        {
                                            "Type": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Chapter 7 Bankruptcy",
                                                "abbreviation": "Chapter 7 Bankruptcy"
                                            },
                                            "Source": {
                                                "Bureau": {
                                                    "rank": "1",
                                                    "symbol": "EXP",
                                                    "description": "Experian",
                                                    "abbreviation": "Experian"
                                                },
                                                "Reference": "",
                                                "BorrowerKey": "",
                                                "InquiryDate": "2024-02-24"
                                            },
                                            "Status": {
                                                "rank": "199",
                                                "symbol": "1",
                                                "description": "Discharged",
                                                "abbreviation": "Discharged"
                                            },
                                            "bureau": "Experian",
                                            "courtName": "US BK CT-EAST DIST MIC",
                                            "dateFiled": "2016-11-10",
                                            "Bankruptcy": {
                                                "company": "",
                                                "trustee": "",
                                                "division": "",
                                                "thirdParty": "",
                                                "assetAmount": "0",
                                                "courtNumber": "",
                                                "dateResolved": "2017-02-15",
                                                "exemptAmount": "0",
                                                "liabilityAmount": "0"
                                            },
                                            "IndustryCode": {
                                                "rank": "100000",
                                                "symbol": "",
                                                "description": "",
                                                "abbreviation": ""
                                            },
                                            "Classification": {
                                                "rank": "199",
                                                "symbol": "B",
                                                "description": "Bankruptcy",
                                                "abbreviation": "Bankruptcy"
                                            },
                                            "subscriberCode": "5500",
                                            "referenceNumber": "1655278MLO",
                                            "AccountDesignator": {
                                                "rank": "199",
                                                "symbol": "I",
                                                "description": "Individual",
                                                "abbreviation": "Individual"
                                            }
                                        }
                                    ]
                                }
                            ],
                            "Subscriber": [
                                {
                                    "name": "FIRST PREMIER BANK",
                                    "telephone": "6053573440",
                                    "subscriberCode": "00020123",
                                    "CreditAddress": {
                                        "city": "SIOUX FALLS ",
                                        "stateCode": "SD",
                                        "unparsedStreet": "3820 N LOUISE AVE ",
                                        "postalCode": "57104"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank",
                                        "description": "Bank",
                                        "symbol": "B",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "CREDIT PLUS",
                                    "telephone": "8002583488",
                                    "subscriberCode": "00049997",
                                    "CreditAddress": {
                                        "city": "SALISBURY ",
                                        "stateCode": "MD",
                                        "unparsedStreet": "31550 WINTERPLACE ",
                                        "postalCode": "21804"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Miscellaneous",
                                        "description": "Miscellaneous",
                                        "symbol": "Z",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "CREDIT PLUS\/PANORAMA MOR",
                                    "telephone": "7025885430",
                                    "subscriberCode": "06335039",
                                    "CreditAddress": {
                                        "city": "LAS VEGAS ",
                                        "stateCode": "NV",
                                        "unparsedStreet": "350 S RAMPART BLVD STE 310 ",
                                        "postalCode": "89145"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Credit Union",
                                        "description": "Credit Union",
                                        "symbol": "Q",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "FEDLOAN SERVICING",
                                    "telephone": "8006992908",
                                    "subscriberCode": "02CN2006",
                                    "CreditAddress": {
                                        "city": "HARRISBURG ",
                                        "stateCode": "PA",
                                        "unparsedStreet": "POB 60610 ",
                                        "postalCode": "17106"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Student Loans",
                                        "description": "Student Loans",
                                        "symbol": "EL",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-07-03",
                                        "Reference": "MFS_BE90D669-1FE5-4587"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "873450347833428"
                                },
                                {
                                    "name": "SYNCB\/CARE CREDIT",
                                    "telephone": "8009242927",
                                    "subscriberCode": "04877646",
                                    "CreditAddress": {
                                        "city": "DAYTON ",
                                        "stateCode": "OH",
                                        "unparsedStreet": "PO BOX 8726 ",
                                        "postalCode": "45401"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Finance\/Personal",
                                        "description": "Finance\/Personal",
                                        "symbol": "F",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "BANK OF AMERICA",
                                    "telephone": "8004212110",
                                    "subscriberCode": "06199555",
                                    "CreditAddress": {
                                        "city": "EL PASO ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "PO BOX 982238 ",
                                        "postalCode": "79998"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank",
                                        "description": "Bank",
                                        "symbol": "B",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "SUNTRUST DBA LIGHTSTREAM",
                                    "telephone": "8007868787",
                                    "subscriberCode": "06525583",
                                    "CreditAddress": {
                                        "city": "SAN DIEGO ",
                                        "stateCode": "CA",
                                        "unparsedStreet": "600 W BROADWAY SUITE 2000 ",
                                        "postalCode": "92101"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank",
                                        "description": "Bank",
                                        "symbol": "B",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "CREDCO\/BAC 5",
                                    "telephone": "8004476192",
                                    "subscriberCode": "02964510",
                                    "CreditAddress": {
                                        "city": "PASADENA ",
                                        "stateCode": "CA",
                                        "unparsedStreet": "35 N LAKE AVE ",
                                        "postalCode": "91101"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank",
                                        "description": "Bank",
                                        "symbol": "B",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "WELLS FARGO CARD SERVICE",
                                    "telephone": "8004624720",
                                    "subscriberCode": "0908N664",
                                    "CreditAddress": {
                                        "city": "DES MOINES ",
                                        "stateCode": "IA",
                                        "unparsedStreet": "PO BOX 14517 ",
                                        "postalCode": "50306"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank Credit Cards",
                                        "description": "Bank Credit Cards",
                                        "symbol": "BC",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "6646540006081"
                                },
                                {
                                    "name": "US DEPT OF EDUCATION\/GLE",
                                    "telephone": "8002364300",
                                    "subscriberCode": "0368N4TP",
                                    "CreditAddress": {
                                        "city": "MADISON ",
                                        "stateCode": "WI",
                                        "unparsedStreet": "2401 INTERNATIONAL LANE POB 7859 ",
                                        "postalCode": "53704"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Student Loans",
                                        "description": "Student Loans",
                                        "symbol": "EL",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "87927492345"
                                },
                                {
                                    "name": "CHIME - STRIDE BANK",
                                    "telephone": "8442446363",
                                    "subscriberCode": "02HVP001",
                                    "CreditAddress": {
                                        "city": "SAN FRANCISCO ",
                                        "stateCode": "CA",
                                        "unparsedStreet": "PO BOX 417 ",
                                        "postalCode": "94104"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank - Mortgage Loans",
                                        "description": "Bank - Mortgage Loans",
                                        "symbol": "BM",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "983627386482"
                                },
                                {
                                    "name": "KIKOFF LENDING LLC",
                                    "telephone": "4153614040",
                                    "subscriberCode": "02H42001",
                                    "CreditAddress": {
                                        "city": "SAN FRANCISCO ",
                                        "stateCode": "CA",
                                        "unparsedStreet": "75 BROADWAY SUITE 202 ",
                                        "postalCode": "94111"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Miscellaneous Finance",
                                        "description": "Miscellaneous Finance",
                                        "symbol": "FZ",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "3452FSF4RS"
                                },
                                {
                                    "name": "ATLANTIC CAP BKSELFLENDR",
                                    "telephone": "8778830999",
                                    "subscriberCode": "02GS2001",
                                    "CreditAddress": {
                                        "city": "AUSTIN ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "515 CONGRESS AVE SUITE 2200 ",
                                        "postalCode": "78701"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Full Service Banks",
                                        "description": "Full Service Banks",
                                        "symbol": "BO",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "736293645"
                                },
                                {
                                    "name": "SUNRISE BANK SELF LENDER",
                                    "telephone": "6052502620",
                                    "subscriberCode": "02FCE002",
                                    "CreditAddress": {
                                        "city": "AUSTIN ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "515 CONGRESS AVE, SUITE 2200 C\/O SELF FINANCIAL, INC. ",
                                        "postalCode": "78701"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Miscellaneous Banks",
                                        "description": "Miscellaneous Banks",
                                        "symbol": "BZ",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "76483753"
                                },
                                {
                                    "name": "BIGHTON RENT",
                                    "telephone": "8674598345",
                                    "subscriberCode": "09FCR453",
                                    "CreditAddress": {
                                        "city": "WOODINVILLE ",
                                        "stateCode": "WA",
                                        "unparsedStreet": "14241 NE WOODINVILLE-DUVALL RD ",
                                        "postalCode": "98072"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Property Management",
                                        "description": "Property Management",
                                        "symbol": "RR",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "878271629281"
                                },
                                {
                                    "name": "ACCEPTANCENOW",
                                    "telephone": "8002752696",
                                    "subscriberCode": "02E4W001",
                                    "CreditAddress": {
                                        "city": "PLANO ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "5501 HEADQUARTERS DRIVE ",
                                        "postalCode": "75024"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Miscellaneous Finance",
                                        "description": "Miscellaneous Finance",
                                        "symbol": "FZ",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "04500034562723"
                                },
                                {
                                    "name": "WEBBANK\/FRESHSTART",
                                    "telephone": "8667340342",
                                    "subscriberCode": "02CSN003",
                                    "CreditAddress": {
                                        "city": "EDEN PRAIRIE ",
                                        "stateCode": "MN",
                                        "unparsedStreet": "13300 PIONEER TRAIL ",
                                        "postalCode": "55347"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Variety Store",
                                        "description": "Variety Store",
                                        "symbol": "DV",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "657873625183722"
                                },
                                {
                                    "name": "SELF FINANCIAL INC \/ LEA",
                                    "telephone": "8778830999",
                                    "subscriberCode": "02ANW004",
                                    "CreditAddress": {
                                        "city": "AUSTIN ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "901 E. 6TH STREET SUITE #400 ",
                                        "postalCode": "78702"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Sales Financing",
                                        "description": "Sales Financing",
                                        "symbol": "FF",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "9834598271"
                                },
                                {
                                    "name": "BRIDGECREST FORMERLY DRI",
                                    "telephone": "8026433864",
                                    "subscriberCode": "01SFX002",
                                    "CreditAddress": {
                                        "city": "PHOENIX ",
                                        "stateCode": "AZ",
                                        "unparsedStreet": "PO BOX 29018 ",
                                        "postalCode": "85038"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Auto Financing",
                                        "description": "Auto Financing",
                                        "symbol": "FA",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "726946298734"
                                },
                                {
                                    "name": "CAPITAL ONE",
                                    "telephone": "8009557070",
                                    "subscriberCode": "01DTV001",
                                    "CreditAddress": {
                                        "city": "SALT LAKE CITY ",
                                        "stateCode": "UT",
                                        "unparsedStreet": "PO BOX 31293 ",
                                        "postalCode": "84131"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Bank Credit Cards",
                                        "description": "Bank Credit Cards",
                                        "symbol": "BC",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "673926492644"
                                },
                                {
                                    "name": "USBK COURT NORTHERN GEOR",
                                    "telephone": "4042151000",
                                    "subscriberCode": "0508601Z",
                                    "CreditAddress": {
                                        "city": "ATLANTA ",
                                        "stateCode": "GA",
                                        "unparsedStreet": "75 TED TURNER DRIVE SW # 1340 ",
                                        "postalCode": "30303"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Public Records",
                                        "description": "Public Records",
                                        "symbol": "ZP",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": "MFS_421A1643-37F4-44AB"
                                    }
                                },
                                {
                                    "name": "XACTUS-CP\/PANORAMA MOR",
                                    "telephone": "7025885430",
                                    "subscriberCode": "1544208",
                                    "CreditAddress": {
                                        "city": "LAS VEGAS",
                                        "stateCode": "NV",
                                        "unparsedStreet": "350 S RAMPART BLVD STE 3",
                                        "postalCode": "89145"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    }
                                },
                                {
                                    "name": "XACTUS-CP\/ASSURANCE FI",
                                    "telephone": "2254482680",
                                    "subscriberCode": "2919141",
                                    "CreditAddress": {
                                        "city": "BATON ROUGE",
                                        "stateCode": "LA",
                                        "unparsedStreet": "9029 JEFFERSON HWY STE 1",
                                        "postalCode": "70809"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    }
                                },
                                {
                                    "name": "WEBBANK\/FINGERHUT FRES",
                                    "telephone": "",
                                    "subscriberCode": "2244980",
                                    "CreditAddress": {
                                        "city": "SAINT CLOUD",
                                        "stateCode": "MN",
                                        "unparsedStreet": "6250 RIDGEWOOD RD",
                                        "postalCode": "56303"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "657873625183722"
                                },
                                {
                                    "name": "WEBBANK\/FINGERHUT",
                                    "telephone": "",
                                    "subscriberCode": "2244970",
                                    "CreditAddress": {
                                        "city": "SAINT CLOUD",
                                        "stateCode": "MN",
                                        "unparsedStreet": "6250 RIDGEWOOD RD",
                                        "postalCode": "56303"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "785636992105648"
                                },
                                {
                                    "name": "US DEPT OF ED\/GLELSI",
                                    "telephone": "8002364300",
                                    "subscriberCode": "1132610",
                                    "CreditAddress": {
                                        "city": "MADISON",
                                        "stateCode": "WI",
                                        "unparsedStreet": "PO BOX 7860",
                                        "postalCode": "53707"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "87927492345"
                                },
                                {
                                    "name": "US BKPT CT GA ATLANTA",
                                    "telephone": "BYMAILONLY",
                                    "subscriberCode": "1008000",
                                    "CreditAddress": {
                                        "city": "ATLANTA",
                                        "stateCode": "GA",
                                        "unparsedStreet": "75 TED TURNER DR SW STE ",
                                        "postalCode": "30303"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    }
                                },
                                {
                                    "name": "TOMOCREDIT INC",
                                    "telephone": "2028581034",
                                    "subscriberCode": "2925066",
                                    "CreditAddress": {
                                        "city": "SAN FRANCISCO",
                                        "stateCode": "CA",
                                        "unparsedStreet": "535 MISSION ST FL 14",
                                        "postalCode": "94105"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "834729362937639"
                                },
                                {
                                    "name": "TELECOM SELF-REPORTED",
                                    "telephone": "8558912743",
                                    "subscriberCode": "2886930",
                                    "CreditAddress": {
                                        "city": "ALLEN",
                                        "stateCode": "TX",
                                        "unparsedStreet": "PO BOX 4500",
                                        "postalCode": "75013"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "AADHKSH281630DFT564"
                                },
                                {
                                    "name": "SELF\/ATLANTIC CAPITAL",
                                    "telephone": "4049556050",
                                    "subscriberCode": "2928750",
                                    "CreditAddress": {
                                        "city": "ATLANTA",
                                        "stateCode": "GA",
                                        "unparsedStreet": "945 E PACES FERRY RD NE",
                                        "postalCode": "30326"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "736293645"
                                },
                                {
                                    "name": "SELF FINANCIAL\/LEAD BA",
                                    "telephone": "8668459545",
                                    "subscriberCode": "2932264",
                                    "CreditAddress": {
                                        "city": "KANSAS CITY",
                                        "stateCode": "MO",
                                        "unparsedStreet": "1801 MAIN ST",
                                        "postalCode": "64108"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "9834598271"
                                },
                                {
                                    "name": "SBNASELFLNDR",
                                    "telephone": "6512655600",
                                    "subscriberCode": "1188380",
                                    "CreditAddress": {
                                        "city": "AUSTIN",
                                        "stateCode": "TX",
                                        "unparsedStreet": "901 E 6TH ST STE 400",
                                        "postalCode": "78702"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "76483753"
                                },
                                {
                                    "name": "RENT SELF-REPORTED",
                                    "telephone": "8558912743",
                                    "subscriberCode": "2886940",
                                    "CreditAddress": {
                                        "city": "ALLEN",
                                        "stateCode": "TX",
                                        "unparsedStreet": "PO BOX 4500",
                                        "postalCode": "75013"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "DDGAUKDYALDOL345LDD"
                                },
                                {
                                    "name": "AES\/NCT",
                                    "telephone": "8002330557",
                                    "subscriberCode": "0494T94D",
                                    "CreditAddress": {
                                        "city": "HARRISBURG ",
                                        "stateCode": "PA",
                                        "unparsedStreet": "POB 61047 ",
                                        "postalCode": "17106"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Student Loans",
                                        "description": "Student Loans",
                                        "symbol": "EL",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-07-03",
                                        "Reference": "MFS_BE90D669-1FE5-4587"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "64864379283A00001"
                                },
                                {
                                    "name": "KIKOFF LENDING LLC",
                                    "telephone": "4153614040",
                                    "subscriberCode": "2919349",
                                    "CreditAddress": {
                                        "city": "SAN FRANCISCO",
                                        "stateCode": "CA",
                                        "unparsedStreet": "75 BROADWAY STE 226",
                                        "postalCode": "94111"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "CSHRLED45A"
                                },
                                {
                                    "name": "GREEN DOT BANK",
                                    "telephone": "6094540337",
                                    "subscriberCode": "1453090",
                                    "CreditAddress": {
                                        "city": "PASADENA",
                                        "stateCode": "CA",
                                        "unparsedStreet": "PO BOX 5100",
                                        "postalCode": "91117"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "8543271930201630"
                                },
                                {
                                    "name": "DISCOVER FINANCIAL SER",
                                    "telephone": "BYMAILONLY",
                                    "subscriberCode": "1224590",
                                    "CreditAddress": {
                                        "city": "NEW CASTLE",
                                        "stateCode": "DE",
                                        "unparsedStreet": "12 READS WAY",
                                        "postalCode": "19720"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    }
                                },
                                {
                                    "name": "CORELOGIC CREDCO LLC",
                                    "telephone": "8006372422",
                                    "subscriberCode": "1727750",
                                    "CreditAddress": {
                                        "city": "SAN DIEGO",
                                        "stateCode": "CA",
                                        "unparsedStreet": "PO BOX 509124",
                                        "postalCode": "92150"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    }
                                },
                                {
                                    "name": "CONSUMER PORTFOLIO SVC",
                                    "telephone": "BYMAILONLY",
                                    "subscriberCode": "0600631",
                                    "CreditAddress": {
                                        "city": "IRVINE",
                                        "stateCode": "CA",
                                        "unparsedStreet": "PO BOX 57071",
                                        "postalCode": "92619"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "746394720490"
                                },
                                {
                                    "name": "CITICARDS CBNA",
                                    "telephone": "8009505114",
                                    "subscriberCode": "1240000",
                                    "CreditAddress": {
                                        "city": "SIOUX FALLS",
                                        "stateCode": "SD",
                                        "unparsedStreet": "PO BOX 6241",
                                        "postalCode": "57117"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "7635286294394"
                                },
                                {
                                    "name": "CHIME\/STRIDE BANK NA",
                                    "telephone": "5802333535",
                                    "subscriberCode": "2918527",
                                    "CreditAddress": {
                                        "city": "ENID",
                                        "stateCode": "OK",
                                        "unparsedStreet": "324 W BROADWAY AVE",
                                        "postalCode": "73701"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "983627386482"
                                },
                                {
                                    "name": "CAPITAL ONE",
                                    "telephone": "8009557070",
                                    "subscriberCode": "1270246",
                                    "CreditAddress": {
                                        "city": "SALT LAKE CITY",
                                        "stateCode": "UT",
                                        "unparsedStreet": "PO BOX 31293",
                                        "postalCode": "84131"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "673926492644"
                                },
                                {
                                    "name": "BRIDGECREST",
                                    "telephone": "4808135200",
                                    "subscriberCode": "8602240",
                                    "CreditAddress": {
                                        "city": "MESA",
                                        "stateCode": "AZ",
                                        "unparsedStreet": "7300 E HAMPTON AVE",
                                        "postalCode": "85209"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "726946298734"
                                },
                                {
                                    "name": "ALLY FINANCIAL",
                                    "telephone": "8002004622",
                                    "subscriberCode": "1918788",
                                    "CreditAddress": {
                                        "city": "DETROIT",
                                        "stateCode": "MI",
                                        "unparsedStreet": "200 RENAISSANCE CTR # B0",
                                        "postalCode": "48243"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "84729472974924"
                                },
                                {
                                    "name": "ALDOUS AND ASSOCIATES",
                                    "telephone": "8012725281",
                                    "subscriberCode": "02ELW001",
                                    "CreditAddress": {
                                        "city": "HOLLADAY ",
                                        "stateCode": "UT",
                                        "unparsedStreet": "PO BOX 171374 ",
                                        "postalCode": "84117"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Other Collection Agencies",
                                        "description": "Other Collection Agencies",
                                        "symbol": "YC",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-07-04",
                                        "Reference": "MFS_88F25AE4-1CFA-40AB"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "D85797262M1"
                                },
                                {
                                    "name": "PROCOLLECT,INC",
                                    "telephone": "2143417788",
                                    "subscriberCode": "2980920",
                                    "CreditAddress": {
                                        "city": "DALLAS",
                                        "stateCode": "TX",
                                        "unparsedStreet": "12170 ABRAMS RD STE 100",
                                        "postalCode": "75243"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-07-04",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "867309003826135005"
                                },
                                {
                                    "name": "ARMADA CORPORATION",
                                    "telephone": "8009492372",
                                    "subscriberCode": "0925M001",
                                    "CreditAddress": {
                                        "city": "EAST WENATCHEE ",
                                        "stateCode": "WA",
                                        "unparsedStreet": "93 EASTMONT AVE SUITE #100 ",
                                        "postalCode": "98802"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Other Collection Agencies",
                                        "description": "Other Collection Agencies",
                                        "symbol": "YC",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-11-01",
                                        "Reference": "MFS_14356E72-A030-494F"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "7569044"
                                },
                                {
                                    "name": "MEDICAL DATA SYSTEMS INC",
                                    "telephone": "8003156050",
                                    "subscriberCode": "0204K003",
                                    "CreditAddress": {
                                        "city": "SEBRING ",
                                        "stateCode": "FL",
                                        "unparsedStreet": "1532 LAKEVIEW DR ",
                                        "postalCode": "33870"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Other Collection Agencies",
                                        "description": "Other Collection Agencies",
                                        "symbol": "YC",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-10-17",
                                        "Reference": "MFS_73EEBD7E-1756-49F1"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "946662930283"
                                },
                                {
                                    "name": "MEDICAL DATA SYSTEMS I",
                                    "telephone": "8003156050",
                                    "subscriberCode": "1982731",
                                    "CreditAddress": {
                                        "city": "SEBRING",
                                        "stateCode": "FL",
                                        "unparsedStreet": "128 W CENTER AVE FL 2",
                                        "postalCode": "33870"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-10-17",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "946662930283"
                                },
                                {
                                    "name": "FREEDOM MORTGAGE",
                                    "telephone": "8663692012",
                                    "subscriberCode": "02C82001",
                                    "CreditAddress": {
                                        "city": "INDIANAPOLIS ",
                                        "stateCode": "IN",
                                        "unparsedStreet": "P.O. BOX 50485 ",
                                        "postalCode": "46250"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Mortgage Companies - Finance",
                                        "description": "Mortgage Companies - Finance",
                                        "symbol": "FM",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-06-02",
                                        "Reference": "MFS_0794EC06-F586-46AF"
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "8376492642"
                                },
                                {
                                    "name": "PACIFIC UNION FINANCIAL",
                                    "telephone": "8884802432",
                                    "subscriberCode": "02EEV001",
                                    "CreditAddress": {
                                        "city": "HOUSTON ",
                                        "stateCode": "TX",
                                        "unparsedStreet": "350 HIGHLAND ",
                                        "postalCode": "77067"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Mortgage Companies - Credit Union",
                                        "description": "Mortgage Companies - Credit Union",
                                        "symbol": "QM",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-06-02",
                                        "Reference": "MFS_0794EC06-F586-46AF"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "8739287291732"
                                },
                                {
                                    "name": "SEZZLE INC",
                                    "telephone": "8885401867",
                                    "subscriberCode": "02HF4001",
                                    "CreditAddress": {
                                        "city": "MINNEAPOLIS ",
                                        "stateCode": "MN",
                                        "unparsedStreet": "251 1ST AVE ",
                                        "postalCode": "55401"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "Miscellaneous Finance",
                                        "description": "Miscellaneous Finance",
                                        "symbol": "FZ",
                                        "rank": "199"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-08-04",
                                        "Reference": "MFS_0A597468-499E-4314"
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "972819381739123"
                                },
                                {
                                    "name": "CONVERGENT OUTSOURCING",
                                    "telephone": "8888712279",
                                    "subscriberCode": "0980304",
                                    "CreditAddress": {
                                        "city": "RENTON",
                                        "stateCode": "WA",
                                        "unparsedStreet": "800 SW 39TH ST",
                                        "postalCode": "98057"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-07-04",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "89826352"
                                },
                                {
                                    "name": "ACCEPTANCE NOW",
                                    "telephone": "8886722411",
                                    "subscriberCode": "9306706",
                                    "CreditAddress": {
                                        "city": "PLANO",
                                        "stateCode": "TX",
                                        "unparsedStreet": "5501 HEADQUARTERS DR",
                                        "postalCode": "75024"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Good",
                                    "accountID": "R0601004500034562723"
                                },
                                {
                                    "name": "A+ LOANS",
                                    "telephone": "6787209006",
                                    "subscriberCode": "1689430",
                                    "CreditAddress": {
                                        "city": "ATLANTA",
                                        "stateCode": "GA",
                                        "unparsedStreet": "1352 LAKEWOOD AVE SE",
                                        "postalCode": "30315"
                                    },
                                    "IndustryCode": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    },
                                    "Source": {
                                        "BorrowerKey": "",
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "Reference": ""
                                    },
                                    "inquiryType": "Bad",
                                    "accountID": "98800000003936927"
                                }
                            ],
                            "Message": [
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Extended fraud victim alert on file",
                                        "description": "Extended fraud victim alert on file",
                                        "symbol": "TK9006",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                },
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Inquiry\/onfile current address conflict",
                                        "description": "Inquiry\/onfile current address conflict",
                                        "symbol": "XF001",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                },
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Inquiry current address not onfile",
                                        "description": "Inquiry current address not onfile",
                                        "symbol": "XF003",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                },
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Security statement present on report",
                                        "description": "Security statement present on report",
                                        "symbol": "XF012",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                },
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Current address rpt by new trade only",
                                        "description": "Current address rpt by new trade only",
                                        "symbol": "XF019",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                },
                                {
                                    "text": "",
                                    "Code": {
                                        "abbreviation": "Fraud Victim \"Extended Fraud Alert\"",
                                        "description": "Fraud Victim \"Extended Fraud Alert\"",
                                        "symbol": "QFX",
                                        "rank": "199"
                                    },
                                    "Type": {
                                        "abbreviation": "",
                                        "description": "",
                                        "symbol": "",
                                        "rank": "100000"
                                    }
                                }
                            ],
                            "Summary": {
                                "TradelineSummary": {
                                    "Experian": {
                                        "TotalAccounts": "21",
                                        "OpenAccounts": "9",
                                        "CloseAccounts": "12",
                                        "DelinquentAccounts": "2",
                                        "DerogatoryAccounts": "8",
                                        "TotalBalances": "128150",
                                        "TotalMonthlyPayments": "2025"
                                    },
                                    "Equifax": {
                                        "TotalAccounts": "13",
                                        "OpenAccounts": "8",
                                        "CloseAccounts": "5",
                                        "DelinquentAccounts": "1",
                                        "DerogatoryAccounts": "0",
                                        "TotalBalances": "120115",
                                        "TotalMonthlyPayments": "1175"
                                    },
                                    "TransUnion": {
                                        "TotalAccounts": "12",
                                        "OpenAccounts": "4",
                                        "CloseAccounts": "8",
                                        "DelinquentAccounts": "0",
                                        "DerogatoryAccounts": "2",
                                        "TotalBalances": "56755",
                                        "TotalMonthlyPayments": "1173"
                                    },
                                    "Merge": {
                                        "TotalAccounts": "24",
                                        "OpenAccounts": "4",
                                        "CloseAccounts": "8",
                                        "DelinquentAccounts": "2",
                                        "DerogatoryAccounts": "9",
                                        "TotalBalances": "128210",
                                        "TotalMonthlyPayments": "2035"
                                    }
                                },
                                "InquirySummary": {
                                    "Experian": {
                                        "NumberInLast2Years": "4"
                                    },
                                    "Equifax": {
                                        "NumberInLast2Years": "5"
                                    },
                                    "TransUnion": {
                                        "NumberInLast2Years": "8"
                                    },
                                    "Merge": {
                                        "NumberInLast2Years": "17"
                                    }
                                },
                                "PublicRecordSummary": {
                                    "Experian": {
                                        "NumberOfRecords": "3"
                                    },
                                    "Equifax": {
                                        "NumberOfRecords": "1"
                                    },
                                    "TransUnion": {
                                        "NumberOfRecords": "2"
                                    },
                                    "Merge": {
                                        "NumberOfRecords": "3"
                                    }
                                }
                            },
                            "Sources": {
                                "Source": [
                                    {
                                        "Bureau": {
                                            "abbreviation": "TransUnion",
                                            "description": "TransUnion",
                                            "symbol": "TUC",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "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"
                                    },
                                    {
                                        "Bureau": {
                                            "abbreviation": "Experian",
                                            "description": "Experian",
                                            "symbol": "EXP",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "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"
                                    },
                                    {
                                        "Bureau": {
                                            "abbreviation": "Equifax",
                                            "description": "Equifax",
                                            "symbol": "EQF",
                                            "rank": "1"
                                        },
                                        "InquiryDate": "2022-09-23",
                                        "OriginalData": "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"
                                    }
                                ]
                            },
                            "SafetyCheckPassed": "true"
                        }
                    }
                ],
                "ReportDate": "2023-02-23",
                "InquiryDate": {
                    "TUC": "2023-02-23",
                    "EQF": "2023-02-23",
                    "EXP": "2023-02-23"
                },
                "RiskScore": {
                    "TUC": "607",
                    "EQF": "554",
                    "EXP": "568"
                },
                "Borrower": {
                    "Full_SSN": "525993415",
                    "SSN": {
                        "TUC": "525993415",
                        "EXP": "525993415",
                        "EQF": "525993415"
                    },
                    "BorrowerName": {
                        "Primary": {
                            "TUC": "JOHN  SMITH",
                            "EXP": "JOHN  SMITH",
                            "EQF": "JOHN  SMITH"
                        },
                        "Secondary": {
                            "TUC": "  SMITH JOHN",
                            "EXP": "JON  SMITH"
                        }
                    },
                    "BirthYear": {
                        "TUC": "1987",
                        "EXP": "1987",
                        "EQF": "1987"
                    },
                    "CurrentAddress": {
                        "TUC": {
                            "Address": "18924  PO BOX 18924  CEDAR CREST, NY 87008",
                            "DateUpdated": ""
                        },
                        "EXP": {
                            "Address": "603 MCGILL PARK AVE NE CEDAR CREST, NY 87008",
                            "DateUpdated": "2022-09-01"
                        },
                        "EQF": {
                            "Address": "1925 MONROE DR NE APT 1226  CEDAR CREST, NY 87008",
                            "DateUpdated": ""
                        }
                    },
                    "PreviousAddress": {
                        "TUC": [
                            {
                                "Address": "6136 S LYNN LAKE DR ST PETERSBURG, FL 33712",
                                "DateUpdated": ""
                            },
                            {
                                "Address": "3735 S ABINGTON AV ST PETERSBURG, FL 33711",
                                "DateUpdated": ""
                            }
                        ],
                        "EXP": [
                            {
                                "Address": "3212 HIGHLAND PARC PL SE # 3212 BELEN, NY 87002",
                                "DateUpdated": "2022-09-01"
                            },
                            {
                                "Address": "2001 LAKE PARK DR SE APT M LITTLETON, NJ 03561",
                                "DateUpdated": "2022-09-01"
                            }
                        ],
                        "EQF": [
                            {
                                "Address": "3390 STRATFORD RD NE UNIT 1512  CORONA, NY",
                                "DateUpdated": ""
                            }
                        ]
                    },
                    "Employer": {
                        "TUC": [
                            {
                                "Address": "HOME DEPOT",
                                "DateUpdated": "2017-07-15"
                            },
                            {
                                "Address": "ERNST & YOUNG LLP",
                                "DateUpdated": "2015-02-23"
                            }
                        ]
                    },
                    "CreditStatement": {
                        "TUC": [
                            "#HK#EFCRA EXTENDED FRAUD ALERT: ACTION MAY BE REQUIRED UNDER FCRA BEFORE OPENING OR MODIFYING AN ACC",
                            "OUNT. CONTACT CONSUMER AT (470) 421-5485 (727) 313-1723"
                        ],
                        "EXP": [
                            "06& 08-15-22 0000000 ID FRAUD VICTIM ALERT FRAUDULENT APPLICATIONS MAY BE SUBMITTED IN MY NAME OR MY IDENTITY MAY HAVE BEEN USED WITHOUT MY CONSENT TO FRAUDULENTLY OBTAIN GOODS OR SERVICES. DO NOT EXTEND CREDIT WITHOUT FIRST CONTACTING ME PERSONALLY AND VERIFYING ALL APPLICATION INFORMATION AT DAY 727-804-9797. THIS VICTIM ALERT WILL BE MAINTAINED FOR SEVEN YEARS BEGINNING 08-15-22."
                        ],
                        "EQF": [
                            "FRAUD VICTIM. 'EXTENDED ALERT'. CONSUMER HAS REQUESTED AN ALERT BE PLACED ON THEIR CREDIT FILE. DAYTIME 00001 7273131723 EX-00000 EVENING 00001 4704215485 EX-00000"
                        ]
                    }
                },
                "AccountIds": {
                    "1": {
                        "ID": "",
                        "Name": "FIRST PREMIER BANK",
                        "CreditorNo": "00020123"
                    },
                    "2": {
                        "ID": "",
                        "Name": "CREDIT PLUS",
                        "CreditorNo": "00049997"
                    },
                    "3": {
                        "ID": "",
                        "Name": "CREDIT PLUS\/PANORAMA MOR",
                        "CreditorNo": "06335039"
                    },
                    "4": {
                        "ID": "873450347833428",
                        "Name": "FEDLOAN",
                        "CreditorNo": "02CN2006",
                        "AccCreditor": "02CN2006"
                    },
                    "5": {
                        "ID": "",
                        "Name": "SYNCB\/CARE CREDIT",
                        "CreditorNo": "04877646"
                    },
                    "6": {
                        "ID": "",
                        "Name": "BANK OF AMERICA",
                        "CreditorNo": "06199555"
                    },
                    "7": {
                        "ID": "",
                        "Name": "SUNTRUST DBA LIGHTSTREAM",
                        "CreditorNo": "06525583"
                    },
                    "8": {
                        "ID": "",
                        "Name": "CREDCO\/BAC 5",
                        "CreditorNo": "02964510"
                    },
                    "9": {
                        "ID": "6646540006081",
                        "Name": "WELLS FARGO",
                        "CreditorNo": "0908N664",
                        "AccCreditor": "0908N664"
                    },
                    "10": {
                        "ID": "87927492345",
                        "Name": "USDOE\/GLELSI",
                        "CreditorNo": "0368N4TP",
                        "AccCreditor": "0368N4TP"
                    },
                    "11": {
                        "ID": "983627386482",
                        "Name": "CHIME-STRIDE",
                        "CreditorNo": "02HVP001",
                        "AccCreditor": "02HVP001"
                    },
                    "12": {
                        "ID": "3452FSF4RS",
                        "Name": "KIKOFF LEND",
                        "CreditorNo": "02H42001",
                        "AccCreditor": "02H42001"
                    },
                    "13": {
                        "ID": "736293645",
                        "Name": "ATLCAPBKSELF",
                        "CreditorNo": "02GS2001",
                        "AccCreditor": "02GS2001"
                    },
                    "14": {
                        "ID": "76483753",
                        "Name": "SBNASELFLNDR",
                        "CreditorNo": "02FCE002",
                        "AccCreditor": "02FCE002"
                    },
                    "15": {
                        "ID": "878271629281",
                        "Name": "BIGHTON RENT",
                        "CreditorNo": "09FCR453",
                        "AccCreditor": "09FCR453"
                    },
                    "16": {
                        "ID": "04500034562723",
                        "Name": "ACEPTANCENOW",
                        "CreditorNo": "02E4W001",
                        "AccCreditor": "02E4W001"
                    },
                    "17": {
                        "ID": "657873625183722",
                        "Name": "WEBBNK\/FSTR",
                        "CreditorNo": "02CSN003",
                        "AccCreditor": "02CSN003"
                    },
                    "18": {
                        "ID": "9834598271",
                        "Name": "SELFINC\/LEAD",
                        "CreditorNo": "02ANW004",
                        "AccCreditor": "02ANW004"
                    },
                    "19": {
                        "ID": "726946298734",
                        "Name": "BRIDGECREST",
                        "CreditorNo": "01SFX002",
                        "AccCreditor": "01SFX002"
                    },
                    "20": {
                        "ID": "673926492644",
                        "Name": "CAPITAL ONE",
                        "CreditorNo": "01DTV001",
                        "AccCreditor": "01DTV001"
                    },
                    "21": {
                        "ID": "",
                        "Name": "USBK COURT NORTHERN GEOR",
                        "CreditorNo": "0508601Z"
                    },
                    "22": {
                        "ID": "",
                        "Name": "XACTUS-CP\/PANORAMA MOR",
                        "CreditorNo": "1544208"
                    },
                    "23": {
                        "ID": "",
                        "Name": "XACTUS-CP\/ASSURANCE FI",
                        "CreditorNo": "2919141"
                    },
                    "24": {
                        "ID": "",
                        "Name": "WEBBANK\/FINGERHUT FRES",
                        "CreditorNo": "2244980"
                    },
                    "25": {
                        "ID": "785636992105648",
                        "Name": "WEBBANK\/FINGERHUT",
                        "CreditorNo": "2244970",
                        "AccCreditor": "2244970"
                    },
                    "26": {
                        "ID": "15362871281",
                        "Name": "US DEPT OF ED\/GLELSI",
                        "CreditorNo": "1132610",
                        "AccCreditor": "1132610"
                    },
                    "27": {
                        "ID": "",
                        "Name": "US BKPT CT GA ATLANTA",
                        "CreditorNo": "1008000"
                    },
                    "28": {
                        "ID": "834729362937639",
                        "Name": "TOMOCREDIT INC",
                        "CreditorNo": "2925066",
                        "AccCreditor": "2925066"
                    },
                    "29": {
                        "ID": "AADHKSH281630DFT564",
                        "Name": "TELECOM SELF-REPORTED",
                        "CreditorNo": "2886930",
                        "AccCreditor": "2886930"
                    },
                    "30": {
                        "ID": "",
                        "Name": "SELF\/ATLANTIC CAPITAL",
                        "CreditorNo": "2928750"
                    },
                    "31": {
                        "ID": "",
                        "Name": "SELF FINANCIAL\/LEAD BA",
                        "CreditorNo": "2932264"
                    },
                    "32": {
                        "ID": "",
                        "Name": "SBNASELFLNDR",
                        "CreditorNo": "1188380"
                    },
                    "33": {
                        "ID": "DDGAUKDYALDOL345LDD",
                        "Name": "RENT SELF-REPORTED",
                        "CreditorNo": "2886940",
                        "AccCreditor": "2886940"
                    },
                    "34": {
                        "ID": "64864379283A00001",
                        "Name": "AES\/NCT",
                        "CreditorNo": "0494T94D",
                        "AccCreditor": "0494T94D"
                    },
                    "35": {
                        "ID": "CSHRLED45A",
                        "Name": "KIKOFF LENDING LLC",
                        "CreditorNo": "2919349",
                        "AccCreditor": "2919349"
                    },
                    "36": {
                        "ID": "8543271930201630",
                        "Name": "GREEN DOT BANK",
                        "CreditorNo": "1453090",
                        "AccCreditor": "1453090"
                    },
                    "37": {
                        "ID": "",
                        "Name": "DISCOVER FINANCIAL SER",
                        "CreditorNo": "1224590"
                    },
                    "38": {
                        "ID": "",
                        "Name": "CORELOGIC CREDCO LLC",
                        "CreditorNo": "1727750"
                    },
                    "39": {
                        "ID": "746394720490",
                        "Name": "CONSUMER PORTFOLIO SVC",
                        "CreditorNo": "0600631",
                        "AccCreditor": "0600631"
                    },
                    "40": {
                        "ID": "7635286294394",
                        "Name": "CITICARDS CBNA",
                        "CreditorNo": "1240000",
                        "AccCreditor": "1240000"
                    },
                    "41": {
                        "ID": "",
                        "Name": "CHIME\/STRIDE BANK NA",
                        "CreditorNo": "2918527"
                    },
                    "42": {
                        "ID": "",
                        "Name": "CAPITAL ONE",
                        "CreditorNo": "1270246"
                    },
                    "43": {
                        "ID": "",
                        "Name": "BRIDGECREST",
                        "CreditorNo": "8602240"
                    },
                    "44": {
                        "ID": "84729472974924",
                        "Name": "ALLY FINANCIAL",
                        "CreditorNo": "1918788",
                        "AccCreditor": "1918788"
                    },
                    "45": {
                        "ID": "B76398266N1",
                        "Name": "ALDOUS",
                        "CreditorNo": "02ELW001",
                        "AccCreditor": "02ELW001"
                    },
                    "46": {
                        "ID": "867309003826135005",
                        "Name": "PROCOLLECT,INC",
                        "CreditorNo": "2980920",
                        "AccCreditor": "2980920"
                    },
                    "47": {
                        "ID": "7569044",
                        "Name": "ARMADA COR",
                        "CreditorNo": "0925M001",
                        "AccCreditor": "0925M001"
                    },
                    "48": {
                        "ID": "946662930283",
                        "Name": "MED DATA SYS",
                        "CreditorNo": "0204K003",
                        "AccCreditor": "0204K003"
                    },
                    "49": {
                        "ID": "",
                        "Name": "MEDICAL DATA SYSTEMS I",
                        "CreditorNo": "1982731"
                    },
                    "50": {
                        "ID": "8376492642",
                        "Name": "FREEDOM MTG",
                        "CreditorNo": "02C82001",
                        "AccCreditor": "02C82001"
                    },
                    "51": {
                        "ID": "8739287291732",
                        "Name": "PACIFICUNION",
                        "CreditorNo": "02EEV001",
                        "AccCreditor": "02EEV001"
                    },
                    "52": {
                        "ID": "972819381739123",
                        "Name": "SEZZLE",
                        "CreditorNo": "02HF4001",
                        "AccCreditor": "02HF4001"
                    },
                    "53": {
                        "ID": "89826352",
                        "Name": "CONVERGENT OUTSOURCING",
                        "CreditorNo": "0980304",
                        "AccCreditor": "0980304"
                    },
                    "54": {
                        "ID": "84372930094736547",
                        "Name": "ACCEPTANCE NOW",
                        "CreditorNo": "9306706",
                        "AccCreditor": "9306706"
                    },
                    "55": {
                        "ID": "98800000003936927",
                        "Name": "A+ LOANS",
                        "CreditorNo": "1689430",
                        "AccCreditor": "1689430"
                    },
                    "B83740274H1": {
                        "ID": "B83740274H1",
                        "Name": "ALDOUS",
                        "AccCreditor": "02ELW001"
                    },
                    "D85797262M1": {
                        "ID": "D85797262M1",
                        "Name": "ALDOUS",
                        "AccCreditor": "02ELW001"
                    },
                    "873450347833428": {
                        "ID": "873450347833428",
                        "Name": "FEDLOAN",
                        "AccCreditor": "02CN2006"
                    }
                },
                "AccountTradeLine": {
                    "CreditUtilization": {
                        "TUC": "0%",
                        "EXP": "0%",
                        "EQF": "0%"
                    },
                    "Positive": {
                        "Open": {
                            "Other": {
                                "0": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02H42001",
                                            "highBalance": "120",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFF LEND",
                                            "position": "0",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "12",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CUCCCC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "163FP10645",
                                            "highBalance": "120",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-02-01",
                                            "accountNumber": "3452FSF4RS",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "60",
                                            "creditorName": "KIKOFFLEND",
                                            "position": "1",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Secured",
                                                    "description": "Secured",
                                                    "symbol": "Q00EE",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "10",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Secured loan",
                                                    "description": "Secured loan",
                                                    "symbol": "SE",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "KIKOFF LENDING LLC",
                                        "telephone": "4153614040",
                                        "subscriberCode": "02H42001",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO ",
                                            "stateCode": "CA",
                                            "unparsedStreet": "75 BROADWAY SUITE 202 ",
                                            "postalCode": "94111"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "3452FSF4RS"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "7": {
                                    "accountTypeDescription": "Line of credit",
                                    "accountTypeSymbol": "C",
                                    "accountTypeAbbreviation": "Credit Line",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02HF4001",
                                            "highBalance": "2189",
                                            "dateVerified": "2022-03-31",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-06",
                                            "accountNumber": "972819381739123",
                                            "dateAccountStatus": "2022-03-31",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE",
                                            "position": "37",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "10",
                                                "monthlyPayment": "1557",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "10",
                                                "AccountType": {
                                                    "abbreviation": "Line of credit",
                                                    "description": "Line of credit",
                                                    "symbol": "LC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCC",
                                                    "startDate": "2022-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": "MFS_2249015F-86EB-49D3"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2931581",
                                            "highBalance": "2189",
                                            "dateReported": "2022-03-31",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "6972819381739123",
                                            "dateAccountStatus": "2022-03-01",
                                            "currentBalance": "566",
                                            "creditorName": "SEZZLE INC",
                                            "position": "38",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "11",
                                                "monthlyPayment": "566",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-03-28",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "11",
                                                "AccountType": {
                                                    "abbreviation": "Check credit\/Line of credit",
                                                    "description": "Check credit\/Line of credit",
                                                    "symbol": "CLN",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Credit Line",
                                                    "description": "Line of credit",
                                                    "symbol": "C",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCC",
                                                    "startDate": "2022-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-03-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "3450"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-06",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "SEZZLE INC",
                                        "telephone": "8885401867",
                                        "subscriberCode": "02HF4001",
                                        "CreditAddress": {
                                            "city": "MINNEAPOLIS ",
                                            "stateCode": "MN",
                                            "unparsedStreet": "251 1ST AVE ",
                                            "postalCode": "55401"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-08-04",
                                            "Reference": "MFS_0A597468-499E-4314"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "972819381739123"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "12": {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02HVP001",
                                            "highBalance": "3263",
                                            "dateVerified": "2022-09-01",
                                            "dateReported": "2022-09-01",
                                            "dateOpened": "2020-11-30",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "213",
                                            "creditorName": "CHIME-STRIDE",
                                            "position": "7",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank",
                                                "description": "Bank",
                                                "symbol": "B",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-08-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2918527",
                                            "highBalance": "3263",
                                            "dateReported": "2022-09-01",
                                            "dateOpened": "2020-11-01",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "213",
                                            "creditorName": "CHIME\/STRIDE BANK NA",
                                            "position": "8",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-01",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-09-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "265FZ00034",
                                            "highBalance": "3263",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2020-11-01",
                                            "accountNumber": "983627386482",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "0",
                                            "creditorName": "CHIMEF\/STR",
                                            "position": "9",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Finance",
                                                "description": "Miscellaneous Finance",
                                                "symbol": "FZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Secured credit card",
                                                        "description": "Secured credit card",
                                                        "symbol": "Q00GR",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "20",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "20",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "CHIME - STRIDE BANK",
                                        "telephone": "8442446363",
                                        "subscriberCode": "02HVP001",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO ",
                                            "stateCode": "CA",
                                            "unparsedStreet": "PO BOX 417 ",
                                            "postalCode": "94104"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Bank - Mortgage Loans",
                                            "description": "Bank - Mortgage Loans",
                                            "symbol": "BM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "983627386482"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "13": {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2886940",
                                            "highBalance": "2105",
                                            "dateReported": "2022-08-12",
                                            "accountNumber": "DDGAUKDYALDOL345LDD",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "0",
                                            "creditorName": "RENT SELF-REPORTED",
                                            "position": "10",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Property Management",
                                                "description": "Property Management",
                                                "symbol": "RR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "7",
                                                "monthlyPayment": "2105",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-12",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "7",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCUC",
                                                    "startDate": "2022-08-12",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-12",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-11",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-11",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-11",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-12",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-12",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "RENT SELF-REPORTED",
                                        "telephone": "8558912743",
                                        "subscriberCode": "2886940",
                                        "CreditAddress": {
                                            "city": "ALLEN",
                                            "stateCode": "TX",
                                            "unparsedStreet": "PO BOX 4500",
                                            "postalCode": "75013"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "DDGAUKDYALDOL345LDD"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "22": {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2919349",
                                            "highBalance": "25",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "CSHRLED45A",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "12",
                                            "creditorName": "KIKOFF LENDING LLC",
                                            "position": "23",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "17",
                                                "monthlyPayment": "2",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-29",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "17",
                                                "AccountType": {
                                                    "abbreviation": "Charge account",
                                                    "description": "Charge account",
                                                    "symbol": "CH",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "500"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "2.40%"
                                        },
                                        {
                                            "subscriberCode": "163FP10645",
                                            "highBalance": "0",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2021-04-01",
                                            "accountNumber": "CSHRLED45A",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "12",
                                            "creditorName": "KIKOFFLEND",
                                            "position": "24",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Charge",
                                                        "description": "Charge",
                                                        "symbol": "Q00AV",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Amount in H\/C column is credit limit",
                                                        "description": "Amount in H\/C column is credit limit",
                                                        "symbol": "Q00AZ",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "16",
                                                "monthlyPayment": "2",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "16",
                                                "AccountType": {
                                                    "abbreviation": "Charge account",
                                                    "description": "Charge account",
                                                    "symbol": "CH",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "500"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "2.40%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "KIKOFF LENDING LLC",
                                        "telephone": "4153614040",
                                        "subscriberCode": "2919349",
                                        "CreditAddress": {
                                            "city": "SAN FRANCISCO",
                                            "stateCode": "CA",
                                            "unparsedStreet": "75 BROADWAY STE 226",
                                            "postalCode": "94111"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "CSHRLED45A"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "28": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "2886930",
                                            "highBalance": "860",
                                            "dateReported": "2022-09-16",
                                            "accountNumber": "AADHKSH281630DFT564",
                                            "dateAccountStatus": "2022-09-01",
                                            "currentBalance": "860",
                                            "creditorName": "TELECOM SELF-REPORTED",
                                            "position": "38",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Telephone Companies",
                                                "description": "Telephone Companies",
                                                "symbol": "UT",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "8",
                                                "monthlyPayment": "860",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-09-16",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "8",
                                                "AccountType": {
                                                    "abbreviation": "Unknown - credit extension, review, or collection",
                                                    "description": "Unknown - credit extension, review, or collection",
                                                    "symbol": "UNK",
                                                    "rank": "100"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CUUUUCCC",
                                                    "startDate": "2022-09-16",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-09-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-08-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-07-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-16",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-16",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-15",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-16",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-15",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-16",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "TELECOM SELF-REPORTED",
                                        "telephone": "8558912743",
                                        "subscriberCode": "2886930",
                                        "CreditAddress": {
                                            "city": "ALLEN",
                                            "stateCode": "TX",
                                            "unparsedStreet": "PO BOX 4500",
                                            "postalCode": "75013"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "",
                                            "description": "",
                                            "symbol": "",
                                            "rank": "100000"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "Experian",
                                                "description": "Experian",
                                                "symbol": "EXP",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": ""
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "AADHKSH281630DFT564"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            },
                            "AutoLoan": {
                                "25": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "01SFX002",
                                            "highBalance": "49287",
                                            "dateVerified": "2022-08-31",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-03-09",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-31",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGECREST",
                                            "position": "31",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "5",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-28",
                                                "termMonths": "72",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "5",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCC",
                                                    "startDate": "2022-07-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "8602240",
                                            "highBalance": "49287",
                                            "dateReported": "2022-08-31",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGECREST",
                                            "position": "32",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Financing",
                                                "description": "Auto Financing",
                                                "symbol": "FA",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "6",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-07-28",
                                                "termMonths": "72",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "6",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCC",
                                                    "startDate": "2022-08-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-08-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-07-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-06-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-05-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "152AU11874",
                                            "highBalance": "49287",
                                            "dateReported": "2022-08-01",
                                            "dateOpened": "2022-03-01",
                                            "accountNumber": "726946298734",
                                            "dateAccountStatus": "2022-08-01",
                                            "currentBalance": "49173",
                                            "creditorName": "BRIDGCREST",
                                            "position": "33",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Auto Dealers, Used",
                                                "description": "Auto Dealers, Used",
                                                "symbol": "AU",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Auto",
                                                    "description": "Auto",
                                                    "symbol": "Q00AO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "1163",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-08-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "Auto Loan",
                                                    "description": "Auto Loan",
                                                    "symbol": "AU",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUU",
                                                    "startDate": "2022-07-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "BRIDGECREST FORMERLY DRI",
                                        "telephone": "8026433864",
                                        "subscriberCode": "01SFX002",
                                        "CreditAddress": {
                                            "city": "PHOENIX ",
                                            "stateCode": "AZ",
                                            "unparsedStreet": "PO BOX 29018 ",
                                            "postalCode": "85038"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Auto Financing",
                                            "description": "Auto Financing",
                                            "symbol": "FA",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "726946298734"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            },
                            "Educational": {
                                "32": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "6181",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-19",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "6988",
                                            "creditorName": "FEDLOAN",
                                            "position": "12",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCUUUUUUUUUUUUUUCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "6181",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "6988",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "13",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "30",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "30",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCUUUUUUUUUUUUUUCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "6181",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "6988",
                                            "creditorName": "FEDLOAN",
                                            "position": "14",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "68",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "68",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "33": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "10250",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2020-08-17",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "10250",
                                            "creditorName": "FEDLOAN",
                                            "position": "43",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "10250",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2020-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "10250",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "44",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "22",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "22",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCCCCCCCCCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "10250",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2020-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "10250",
                                            "creditorName": "FEDLOAN",
                                            "position": "45",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "21",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "21",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "34": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "5500",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-19",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "5793",
                                            "creditorName": "FEDLOAN",
                                            "position": "15",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "48",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "48",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCUUUUUUUUUUUUUUCCCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "1850180",
                                            "highBalance": "5500",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "5793",
                                            "creditorName": "FED LOAN SERV",
                                            "position": "16",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "30",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "300",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "30",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCUUUUUUUUUUUUUUCCCC",
                                                    "startDate": "2022-05-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-05-31",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "5500",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2016-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2022-05-01",
                                            "currentBalance": "5793",
                                            "creditorName": "FEDLOAN",
                                            "position": "17",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "60"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Open",
                                                "description": "Open",
                                                "symbol": "O",
                                                "rank": "199"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Fixed rate",
                                                        "description": "Fixed rate",
                                                        "symbol": "Q00EP",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "68",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "68",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            }
                        },
                        "Closed": {
                            "Mortgage": {
                                "8": {
                                    "accountTypeDescription": "Primary or secondary mortgage",
                                    "accountTypeSymbol": "M",
                                    "accountTypeAbbreviation": "Mortgage",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02EEV001",
                                            "highBalance": "310025",
                                            "dateVerified": "2019-01-03",
                                            "dateReported": "2019-01-03",
                                            "dateOpened": "2018-08-31",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2019-01-03",
                                            "currentBalance": "0",
                                            "creditorName": "PACIFICUNION",
                                            "position": "13",
                                            "dateClosed": "2019-01-03",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Credit Union",
                                                "description": "Credit Union",
                                                "symbol": "Q",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transferred to another lender",
                                                    "description": "Transferred to another lender",
                                                    "symbol": "T00TRL",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-14",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCC",
                                                    "startDate": "2018-12-03",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2018-12-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-01-03",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": "MFS_0794EC06-F586-46AF"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2267980",
                                            "highBalance": "310025",
                                            "dateReported": "2019-01-03",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2019-01-01",
                                            "currentBalance": "0",
                                            "creditorName": "PACIFIC UNION FINANCIA",
                                            "position": "14",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transferred to another lender or claim purchased.",
                                                    "description": "Transferred to another lender or claim purchased.",
                                                    "symbol": "E0031",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-14",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "FHA real estate mortgage",
                                                    "description": "FHA real estate mortgage",
                                                    "symbol": "FR",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCC",
                                                    "startDate": "2019-01-03",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-01-03",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-12-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-03",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-03",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-03",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "242FM00110",
                                            "highBalance": "310025",
                                            "dateReported": "2019-01-01",
                                            "dateOpened": "2018-08-01",
                                            "accountNumber": "8739287291732",
                                            "dateAccountStatus": "2018-12-01",
                                            "currentBalance": "0",
                                            "creditorName": "PACUF",
                                            "position": "15",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account transferred or sold",
                                                        "description": "Account transferred or sold",
                                                        "symbol": "Q00BC",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Real Estate Mortgage",
                                                        "description": "Real Estate Mortgage",
                                                        "symbol": "Q00EF",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "3",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2018-12-01",
                                                "termMonths": "360",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "3",
                                                "AccountType": {
                                                    "abbreviation": "Real estate mortgage",
                                                    "description": "Real estate mortgage",
                                                    "symbol": "RM",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Mortgage",
                                                    "description": "Primary or secondary mortgage",
                                                    "symbol": "M",
                                                    "rank": "10"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUU",
                                                    "startDate": "2018-12-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2018-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2018-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-01-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "PACIFIC UNION FINANCIAL",
                                        "telephone": "8884802432",
                                        "subscriberCode": "02EEV001",
                                        "CreditAddress": {
                                            "city": "HOUSTON ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "350 HIGHLAND ",
                                            "postalCode": "77067"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Mortgage Companies - Credit Union",
                                            "description": "Mortgage Companies - Credit Union",
                                            "symbol": "QM",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-06-02",
                                            "Reference": "MFS_0794EC06-F586-46AF"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "8739287291732"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            },
                            "Other": {
                                "11": {
                                    "accountTypeDescription": "Open Account",
                                    "accountTypeSymbol": "O",
                                    "accountTypeAbbreviation": "Open Account",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "09FCR453",
                                            "highBalance": "1951",
                                            "dateVerified": "2022-05-31",
                                            "dateReported": "2022-05-31",
                                            "dateOpened": "2021-08-01",
                                            "accountNumber": "878271629281",
                                            "dateAccountStatus": "2022-05-31",
                                            "currentBalance": "0",
                                            "creditorName": "BIGHTON RENT",
                                            "position": "5",
                                            "dateClosed": "2022-05-31",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Real Estate and Public Accommodations",
                                                "description": "Real Estate and Public Accommodations",
                                                "symbol": "R",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Transfer",
                                                    "description": "Transfer",
                                                    "symbol": "T00TRF",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "8",
                                                "monthlyPayment": "1951",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2022-05-01",
                                                "termMonths": "1",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "8",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCC",
                                                    "startDate": "2022-04-30",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-03-30",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2022-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "133RZ02959",
                                            "highBalance": "1951",
                                            "dateReported": "2022-05-01",
                                            "dateOpened": "2021-08-01",
                                            "accountNumber": "878271629281",
                                            "currentBalance": "0",
                                            "creditorName": "BRIGHTONRENT",
                                            "position": "6",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Xfer",
                                                "description": "Transferred",
                                                "symbol": "T",
                                                "rank": "30"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Real Estate and Public Accomodations",
                                                "description": "Miscellaneous Real Estate and Public Accomodations",
                                                "symbol": "RZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account transferred or sold",
                                                        "description": "Account transferred or sold",
                                                        "symbol": "Q00BC",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Rental agreement",
                                                        "description": "Rental agreement",
                                                        "symbol": "Q00JP",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "9",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "9",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUU",
                                                    "startDate": "2022-04-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2022-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2022-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2021-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "BIGHTON RENT",
                                        "telephone": "8674598345",
                                        "subscriberCode": "09FCR453",
                                        "CreditAddress": {
                                            "city": "WOODINVILLE ",
                                            "stateCode": "WA",
                                            "unparsedStreet": "14241 NE WOODINVILLE-DUVALL RD ",
                                            "postalCode": "98072"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Property Management",
                                            "description": "Property Management",
                                            "symbol": "RR",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "878271629281"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "23": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02E4W001",
                                            "highBalance": "1987",
                                            "dateVerified": "2019-03-28",
                                            "dateReported": "2019-03-28",
                                            "dateOpened": "2018-11-23",
                                            "accountNumber": "04500034562723",
                                            "dateAccountStatus": "2019-03-28",
                                            "currentBalance": "0",
                                            "creditorName": "ACEPTANCENOW",
                                            "position": "25",
                                            "dateClosed": "2019-03-28",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCC",
                                                    "startDate": "2019-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "9306706",
                                            "highBalance": "1987",
                                            "dateReported": "2019-03-31",
                                            "dateOpened": "2018-11-01",
                                            "accountNumber": "R0601004500034562723",
                                            "dateAccountStatus": "2019-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "ACCEPTANCE NOW",
                                            "position": "26",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Furniture Rentals\/Leasing",
                                                "description": "Furniture Rentals\/Leasing",
                                                "symbol": "HR",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "5",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-28",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "5",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Open Account",
                                                    "description": "Open Account",
                                                    "symbol": "O",
                                                    "rank": "30"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCCC",
                                                    "startDate": "2019-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2019-03-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2019-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2019-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2018-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-03-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2017-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "242HZ00053",
                                            "highBalance": "1987",
                                            "dateReported": "2020-11-01",
                                            "dateOpened": "2018-11-01",
                                            "accountNumber": "1004500034562723",
                                            "dateAccountStatus": "2019-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "ACCPTNOW",
                                            "position": "27",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Home Furnishings",
                                                "description": "Miscellaneous Home Furnishings",
                                                "symbol": "HZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Rental agreement",
                                                        "description": "Rental agreement",
                                                        "symbol": "Q00JP",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "4",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2019-03-01",
                                                "termMonths": "14",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "4",
                                                "AccountType": {
                                                    "abbreviation": "Rental agreement",
                                                    "description": "Rental agreement",
                                                    "symbol": "RA",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUU",
                                                    "startDate": "2020-10-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-02-29",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "ACCEPTANCENOW",
                                        "telephone": "8002752696",
                                        "subscriberCode": "02E4W001",
                                        "CreditAddress": {
                                            "city": "PLANO ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "5501 HEADQUARTERS DRIVE ",
                                            "postalCode": "75024"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Miscellaneous Finance",
                                            "description": "Miscellaneous Finance",
                                            "symbol": "FZ",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "04500034562723"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "24": {
                                    "accountTypeDescription": "Revolving Account",
                                    "accountTypeSymbol": "R",
                                    "accountTypeAbbreviation": "Revolving",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02ANW004",
                                            "highBalance": "424",
                                            "dateVerified": "2021-03-31",
                                            "dateReported": "2021-03-31",
                                            "dateOpened": "2020-03-18",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-02-26",
                                            "currentBalance": "0",
                                            "creditorName": "SELFINC\/LEAD",
                                            "position": "28",
                                            "dateClosed": "2021-03-02",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Finance\/Personal",
                                                "description": "Finance\/Personal",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account closed by consumer",
                                                    "description": "Account closed by consumer",
                                                    "symbol": "T00CBC",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-26",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "Secured credit card",
                                                    "description": "Secured credit card",
                                                    "symbol": "SC",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCC",
                                                    "startDate": "2021-02-28",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-03-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "425"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "2932264",
                                            "highBalance": "465",
                                            "dateReported": "2021-03-31",
                                            "dateOpened": "2020-03-01",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-03-01",
                                            "currentBalance": "0",
                                            "creditorName": "SELF FINANCIAL\/LEAD BA",
                                            "position": "29",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Credit line closed - consumer request - reported by subscriber.",
                                                    "description": "Credit line closed - consumer request - reported by subscriber.",
                                                    "symbol": "E0019",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "13",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-26",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "13",
                                                "AccountType": {
                                                    "abbreviation": "Credit line secured",
                                                    "description": "Credit line secured",
                                                    "symbol": "LS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UCCCCCCCCCCCC",
                                                    "startDate": "2021-03-31",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-03-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-02-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2021-01-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-12-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-11-27",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-10-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-09-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-08-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-07-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-06-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-05-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-04-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-03-28",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2020-02-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-27",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-28",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "425"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        },
                                        {
                                            "subscriberCode": "786BB00902",
                                            "highBalance": "425",
                                            "dateReported": "2021-03-01",
                                            "dateOpened": "2020-03-01",
                                            "accountNumber": "9834598271",
                                            "dateAccountStatus": "2021-02-01",
                                            "currentBalance": "0",
                                            "creditorName": "SELF\/LEADB",
                                            "position": "30",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "All Banks",
                                                "description": "All Banks",
                                                "symbol": "BBE",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account closed at consumer's request",
                                                        "description": "Account closed at consumer's request",
                                                        "symbol": "Q00IR",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2021-02-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Revolving",
                                                    "description": "Revolving Account",
                                                    "symbol": "R",
                                                    "rank": "50"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUU",
                                                    "startDate": "2021-02-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2021-02-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2021-01-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-12-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-03-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-02-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-03-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "Utilization": "0%"
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "SELF FINANCIAL INC \/ LEA",
                                        "telephone": "8778830999",
                                        "subscriberCode": "02ANW004",
                                        "CreditAddress": {
                                            "city": "AUSTIN ",
                                            "stateCode": "TX",
                                            "unparsedStreet": "901 E. 6TH STREET SUITE #400 ",
                                            "postalCode": "78702"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Sales Financing",
                                            "description": "Sales Financing",
                                            "symbol": "FF",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "9834598271"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                },
                                "26": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CSN003",
                                            "highBalance": "148",
                                            "dateVerified": "2016-06-29",
                                            "dateReported": "2016-06-29",
                                            "dateOpened": "2016-06-06",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-06-29",
                                            "currentBalance": "0",
                                            "creditorName": "WEBBNK\/FSTR",
                                            "position": "34",
                                            "dateClosed": "2016-06-29",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "50"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Department\/Variety and Other Retail",
                                                "description": "Department\/Variety and Other Retail",
                                                "symbol": "D",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "T00CLO",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "0",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-26",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "0",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "Monthly (every month)",
                                                    "description": "Monthly (every month)",
                                                    "symbol": "M",
                                                    "rank": "199"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "PayStatusHistory": "",
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            }
                                        },
                                        {
                                            "subscriberCode": "2244980",
                                            "highBalance": "0",
                                            "dateReported": "2016-07-07",
                                            "dateOpened": "2016-06-01",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-07-01",
                                            "currentBalance": "0",
                                            "creditorName": "WEBBANK\/FINGERHUT FRES",
                                            "position": "35",
                                            "bureau": "Experian",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Personal Loan Companies",
                                                "description": "Personal Loan Companies",
                                                "symbol": "FP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "2",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-26",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "2",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UC",
                                                    "startDate": "2016-07-07",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2016-07-07",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2016-06-07",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2016-05-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-04-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-03-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2016-01-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-12-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-10-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-09-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-08-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-07-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-06-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-05-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-04-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-03-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-02-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2015-01-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-12-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-11-06",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-10-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-09-07",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-08-07",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        },
                                        {
                                            "subscriberCode": "401DM00387",
                                            "highBalance": "148",
                                            "dateReported": "2020-11-01",
                                            "dateOpened": "2016-06-01",
                                            "accountNumber": "657873625183722",
                                            "dateAccountStatus": "2016-06-01",
                                            "currentBalance": "0",
                                            "creditorName": "FHUT\/WEBBK",
                                            "position": "36",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mail Order Firms",
                                                "description": "Mail Order Firms",
                                                "symbol": "DP",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Installment sales contract",
                                                        "description": "Installment sales contract",
                                                        "symbol": "Q00KA",
                                                        "rank": "10000"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "1",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2016-06-01",
                                                "termMonths": "6",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "1",
                                                "AccountType": {
                                                    "abbreviation": "Installment sales contract",
                                                    "description": "Installment sales contract",
                                                    "symbol": "IS",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "U",
                                                    "startDate": "2020-10-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2020-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2020-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-02-29",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2020-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-09-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2019-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2018-11-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "WEBBANK\/FRESHSTART",
                                        "telephone": "8667340342",
                                        "subscriberCode": "02CSN003",
                                        "CreditAddress": {
                                            "city": "EDEN PRAIRIE ",
                                            "stateCode": "MN",
                                            "unparsedStreet": "13300 PIONEER TRAIL ",
                                            "postalCode": "55347"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Variety Store",
                                            "description": "Variety Store",
                                            "symbol": "DV",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-09-23",
                                            "Reference": "MFS_421A1643-37F4-44AB"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "657873625183722"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            },
                            "Educational": {
                                "31": {
                                    "accountTypeDescription": "Installment Account",
                                    "accountTypeSymbol": "I",
                                    "accountTypeAbbreviation": "Installment",
                                    "Tradeline": [
                                        {
                                            "subscriberCode": "02CN2006",
                                            "highBalance": "6000",
                                            "dateVerified": "2015-09-25",
                                            "dateReported": "2015-09-25",
                                            "dateOpened": "2014-08-26",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2015-09-25",
                                            "currentBalance": "0",
                                            "creditorName": "FEDLOAN",
                                            "position": "8",
                                            "dateClosed": "2015-09-25",
                                            "bureau": "TransUnion",
                                            "AccountCondition": {
                                                "abbreviation": "Refi",
                                                "description": "Refinanced",
                                                "symbol": "R",
                                                "rank": "40"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Education\/Employment",
                                                "description": "Education\/Employment",
                                                "symbol": "E",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "Remark": {
                                                "customRemark": "",
                                                "RemarkCode": {
                                                    "abbreviation": "Account closed due to refinance",
                                                    "description": "Account closed due to refinance",
                                                    "symbol": "T00ACR",
                                                    "rank": "199"
                                                }
                                            },
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2015-09-25",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "Educational",
                                                    "description": "Educational",
                                                    "symbol": "ST",
                                                    "rank": "50"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "CCCCCCCCCCCC",
                                                    "startDate": "2015-08-25",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2015-08-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-07-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-06-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-05-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-04-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-03-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-02-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2015-01-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-12-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-11-24",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-10-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-09-25",
                                                            "status": "C"
                                                        },
                                                        {
                                                            "date": "2014-08-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-07-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-06-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-05-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-04-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-03-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-02-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-01-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-12-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-24",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-10-25",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-09-25",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            }
                                        },
                                        {
                                            "subscriberCode": "496ZZ04371",
                                            "highBalance": "6000",
                                            "dateReported": "2015-09-01",
                                            "dateOpened": "2014-08-01",
                                            "accountNumber": "873450347833428",
                                            "dateAccountStatus": "2015-09-01",
                                            "currentBalance": "0",
                                            "creditorName": "FEDLOAN",
                                            "position": "9",
                                            "bureau": "Equifax",
                                            "AccountCondition": {
                                                "abbreviation": "Paid",
                                                "description": "Paid",
                                                "symbol": "P",
                                                "rank": "10"
                                            },
                                            "AccountDesignator": {
                                                "abbreviation": "Individual",
                                                "description": "Individual",
                                                "symbol": "I",
                                                "rank": "199"
                                            },
                                            "DisputeFlag": {
                                                "abbreviation": "Account not disputed",
                                                "description": "Account not disputed",
                                                "symbol": "F",
                                                "rank": "199"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous All Other",
                                                "description": "Miscellaneous All Other",
                                                "symbol": "ZZ",
                                                "rank": "199"
                                            },
                                            "OpenClosed": {
                                                "abbreviation": "Closed",
                                                "description": "Closed",
                                                "symbol": "C",
                                                "rank": "198"
                                            },
                                            "PayStatus": {
                                                "abbreviation": "Current",
                                                "description": "Current",
                                                "symbol": "C",
                                                "rank": "110"
                                            },
                                            "VerificationIndicator": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Remark": [
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed or paid account\/zero balance",
                                                        "description": "Closed or paid account\/zero balance",
                                                        "symbol": "Q00FA",
                                                        "rank": "199"
                                                    }
                                                },
                                                {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Refinanced",
                                                        "description": "Refinanced",
                                                        "symbol": "Q00CE",
                                                        "rank": "199"
                                                    }
                                                }
                                            ],
                                            "GrantedTrade": {
                                                "monthsReviewed": "12",
                                                "monthlyPayment": "0",
                                                "late90Count": "0",
                                                "late60Count": "0",
                                                "late30Count": "0",
                                                "dateLastPayment": "2015-09-01",
                                                "termMonths": "0",
                                                "collateral": "",
                                                "amountPastDue": "0",
                                                "worstPatStatusCount": "12",
                                                "AccountType": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CreditType": {
                                                    "abbreviation": "Installment",
                                                    "description": "Installment Account",
                                                    "symbol": "I",
                                                    "rank": "20"
                                                },
                                                "PaymentFrequency": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "TermType": {
                                                    "abbreviation": "Provided",
                                                    "description": "Provided",
                                                    "symbol": "P",
                                                    "rank": "199"
                                                },
                                                "WorstPayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "PayStatusHistory": {
                                                    "status": "UUUUUUUUUUUU",
                                                    "startDate": "2015-08-01",
                                                    "MonthlyPayStatus": [
                                                        {
                                                            "date": "2015-08-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-07-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-06-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-05-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-04-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-02-28",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2015-01-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-12-31",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-11-30",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-11-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-10-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-09-01",
                                                            "status": "U"
                                                        },
                                                        {
                                                            "date": "2014-08-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-07-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-06-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-05-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-04-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-02-28",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2014-01-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-12-31",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-30",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-11-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-10-01",
                                                            "status": " "
                                                        },
                                                        {
                                                            "date": "2013-09-01",
                                                            "status": " "
                                                        }
                                                    ]
                                                },
                                                "CreditLimit": "0"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Equifax",
                                                    "description": "Equifax",
                                                    "symbol": "EQF",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            }
                                        }
                                    ],
                                    "Subscriber": {
                                        "name": "FEDLOAN SERVICING",
                                        "telephone": "8006992908",
                                        "subscriberCode": "02CN2006",
                                        "CreditAddress": {
                                            "city": "HARRISBURG ",
                                            "stateCode": "PA",
                                            "unparsedStreet": "POB 60610 ",
                                            "postalCode": "17106"
                                        },
                                        "IndustryCode": {
                                            "abbreviation": "Student Loans",
                                            "description": "Student Loans",
                                            "symbol": "EL",
                                            "rank": "199"
                                        },
                                        "Source": {
                                            "BorrowerKey": "",
                                            "Bureau": {
                                                "abbreviation": "TransUnion",
                                                "description": "TransUnion",
                                                "symbol": "TUC",
                                                "rank": "1"
                                            },
                                            "InquiryDate": "2022-07-03",
                                            "Reference": "MFS_BE90D669-1FE5-4587"
                                        },
                                        "inquiryType": "Good",
                                        "accountID": "873450347833428"
                                    },
                                    "accountStatus": "Positive",
                                    "accountSeverity": null
                                }
                            }
                        }
                    },
                    "Negative": {
                        "Closed": {
                            "Mortgage": {
                                "ChargeOff": {
                                    "1": {
                                        "accountTypeDescription": "Primary or secondary mortgage",
                                        "accountTypeSymbol": "M",
                                        "accountTypeAbbreviation": "Mortgage",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02C82001",
                                                "highBalance": "310025",
                                                "dateVerified": "2022-04-27",
                                                "dateReported": "2022-04-27",
                                                "dateOpened": "2018-08-31",
                                                "accountNumber": "8376492642",
                                                "dateAccountStatus": "2022-04-27",
                                                "currentBalance": "0",
                                                "creditorName": "FREEDOM MTG",
                                                "position": "10",
                                                "dateClosed": "2022-04-27",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "C",
                                                    "rank": "50"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Finance\/Personal",
                                                    "description": "Finance\/Personal",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed",
                                                        "description": "Closed",
                                                        "symbol": "T00CLO",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "39",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "1",
                                                    "late60Count": "1",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2022-04-27",
                                                    "termMonths": "360",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "39",
                                                    "AccountType": {
                                                        "abbreviation": "FHA real estate mortgage",
                                                        "description": "FHA real estate mortgage",
                                                        "symbol": "FR",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Mortgage",
                                                        "description": "Primary or secondary mortgage",
                                                        "symbol": "M",
                                                        "rank": "10"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "Monthly (every month)",
                                                        "description": "Monthly (every month)",
                                                        "symbol": "M",
                                                        "rank": "199"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "90 Delinq",
                                                        "description": "Late 90 Days",
                                                        "symbol": "3",
                                                        "rank": "103"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUUUUUUUUUUUUUU321CCCCCCCCCCC",
                                                        "startDate": "2022-03-27",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-03-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-03-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-02-26",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2020-01-26",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-12-26",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-11-26",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-10-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-09-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-08-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-07-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-06-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-05-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-04-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-03-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-02-26",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-01-26",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-06-02",
                                                    "Reference": "MFS_0794EC06-F586-46AF"
                                                }
                                            },
                                            {
                                                "subscriberCode": "2344320",
                                                "highBalance": "310025",
                                                "dateReported": "2022-04-27",
                                                "dateOpened": "2018-08-01",
                                                "accountNumber": "8376492642",
                                                "dateAccountStatus": "2022-04-01",
                                                "currentBalance": "0",
                                                "creditorName": "FREEDOM MORTGAGE CORP",
                                                "position": "11",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "P",
                                                    "rank": "10"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Mortgage Companies - Finance",
                                                    "description": "Mortgage Companies - Finance",
                                                    "symbol": "FM",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "40",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "1",
                                                    "late60Count": "1",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2022-04-27",
                                                    "termMonths": "360",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "40",
                                                    "AccountType": {
                                                        "abbreviation": "FHA real estate mortgage",
                                                        "description": "FHA real estate mortgage",
                                                        "symbol": "FR",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Mortgage",
                                                        "description": "Primary or secondary mortgage",
                                                        "symbol": "M",
                                                        "rank": "10"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "90 Delinq",
                                                        "description": "Late 90 Days",
                                                        "symbol": "3",
                                                        "rank": "103"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUUUUUUUUUUUUUU",
                                                        "startDate": "2022-04-27",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-04-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-03-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-26",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-27",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-06-02",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "151FM75920",
                                                "highBalance": "310025",
                                                "dateReported": "2022-04-01",
                                                "dateOpened": "2018-08-01",
                                                "accountNumber": "8376492642",
                                                "dateAccountStatus": "2022-04-01",
                                                "currentBalance": "0",
                                                "creditorName": "FREEDOM MT",
                                                "position": "12",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "P",
                                                    "rank": "10"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Mortgage Companies - Finance",
                                                    "description": "Mortgage Companies - Finance",
                                                    "symbol": "FM",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Closed or paid account\/zero balance",
                                                            "description": "Closed or paid account\/zero balance",
                                                            "symbol": "Q00FA",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Real Estate Mortgage",
                                                            "description": "Real Estate Mortgage",
                                                            "symbol": "Q00EF",
                                                            "rank": "199"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "39",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "1",
                                                    "late60Count": "1",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2022-04-01",
                                                    "termMonths": "360",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "39",
                                                    "AccountType": {
                                                        "abbreviation": "Real estate mortgage",
                                                        "description": "Real estate mortgage",
                                                        "symbol": "RM",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Mortgage",
                                                        "description": "Primary or secondary mortgage",
                                                        "symbol": "M",
                                                        "rank": "10"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "90 Delinq",
                                                        "description": "Late 90 Days",
                                                        "symbol": "3",
                                                        "rank": "103"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                        "startDate": "2022-03-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-03-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-01",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-06-02",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "FREEDOM MORTGAGE",
                                            "telephone": "8663692012",
                                            "subscriberCode": "02C82001",
                                            "CreditAddress": {
                                                "city": "INDIANAPOLIS ",
                                                "stateCode": "IN",
                                                "unparsedStreet": "P.O. BOX 50485 ",
                                                "postalCode": "46250"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Mortgage Companies - Finance",
                                                "description": "Mortgage Companies - Finance",
                                                "symbol": "FM",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-06-02",
                                                "Reference": "MFS_0794EC06-F586-46AF"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "8376492642"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    }
                                }
                            },
                            "Other": {
                                "ChargeOff": {
                                    "5": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "2980920",
                                                "highBalance": "2000",
                                                "dateReported": "2022-06-20",
                                                "dateOpened": "2019-05-01",
                                                "accountNumber": "867309003826135005",
                                                "dateAccountStatus": "2019-05-01",
                                                "currentBalance": "2000",
                                                "creditorName": "PROCOLLECT,INC",
                                                "position": "26",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Customer disputed account - reported by subscriber.",
                                                        "description": "Customer disputed account - reported by subscriber.",
                                                        "symbol": "E0078",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "WOODLAND HILLS APARTMENTS OA",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "682YC10122",
                                                "highBalance": "2000",
                                                "dateReported": "2022-06-01",
                                                "dateOpened": "2019-05-01",
                                                "accountNumber": "867309003826135005",
                                                "dateAccountStatus": "2022-06-01",
                                                "currentBalance": "2000",
                                                "creditorName": "",
                                                "position": "27",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account disputed",
                                                    "description": "Account disputed",
                                                    "symbol": "T",
                                                    "rank": "198"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Consumer disputes this account information",
                                                            "description": "Consumer disputes this account information",
                                                            "symbol": "Q00IP",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Collection account",
                                                            "description": "Collection account",
                                                            "symbol": "Q00CZ",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Subject has not satisfied debt.",
                                                            "description": "Subject has not satisfied debt.",
                                                            "symbol": "QC0D",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "CollectionTrade": {
                                                    "originalCreditor": "WOODLAND HILLS",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-05",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "PROCOLLECT,INC",
                                            "telephone": "2143417788",
                                            "subscriberCode": "2980920",
                                            "CreditAddress": {
                                                "city": "DALLAS",
                                                "stateCode": "TX",
                                                "unparsedStreet": "12170 ABRAMS RD STE 100",
                                                "postalCode": "75243"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "867309003826135005"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "6": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0980304",
                                                "highBalance": "1200",
                                                "dateReported": "2022-06-04",
                                                "dateOpened": "2022-03-01",
                                                "accountNumber": "89826352",
                                                "dateAccountStatus": "2022-03-01",
                                                "currentBalance": "1200",
                                                "creditorName": "CONVERGENT OUTSOURCING",
                                                "position": "28",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "XFINITY MOBILE",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "701YC00488",
                                                "highBalance": "1200",
                                                "dateReported": "2022-06-01",
                                                "dateOpened": "2022-03-01",
                                                "accountNumber": "89826352",
                                                "dateAccountStatus": "2022-06-01",
                                                "currentBalance": "1200",
                                                "creditorName": "",
                                                "position": "29",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subject has not satisfied debt.",
                                                        "description": "Subject has not satisfied debt.",
                                                        "symbol": "QC0D",
                                                        "rank": "10000"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "XFINITY MOBILE",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-05",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "CONVERGENT OUTSOURCING",
                                            "telephone": "8888712279",
                                            "subscriberCode": "0980304",
                                            "CreditAddress": {
                                                "city": "RENTON",
                                                "stateCode": "WA",
                                                "unparsedStreet": "800 SW 39TH ST",
                                                "postalCode": "98057"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "89826352"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "9": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "01DTV001",
                                                "highBalance": "596",
                                                "dateVerified": "2022-09-13",
                                                "dateReported": "2022-09-13",
                                                "dateOpened": "2020-01-23",
                                                "accountNumber": "673926492644",
                                                "dateAccountStatus": "2020-11-18",
                                                "currentBalance": "374",
                                                "creditorName": "CAPITAL ONE",
                                                "position": "2",
                                                "dateClosed": "2020-11-18",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank",
                                                    "description": "Bank",
                                                    "symbol": "B",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Charged off as bad debt",
                                                            "description": "Charged off as bad debt",
                                                            "symbol": "TM009",
                                                            "rank": "10000"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Dispute resolved; reported by grantor",
                                                            "description": "Dispute resolved; reported by grantor",
                                                            "symbol": "T00DRG",
                                                            "rank": "199"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "0",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2020-11-19",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "374",
                                                    "worstPatStatusCount": "0",
                                                    "AccountType": {
                                                        "abbreviation": "Credit Card",
                                                        "description": "Credit Card",
                                                        "symbol": "CC",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Unk",
                                                        "description": "Unknown",
                                                        "symbol": "U",
                                                        "rank": "10000"
                                                    },
                                                    "PayStatusHistory": "",
                                                    "CreditLimit": "524"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": "MFS_421A1643-37F4-44AB"
                                                },
                                                "Utilization": "71.37%"
                                            },
                                            {
                                                "subscriberCode": "1270246",
                                                "highBalance": "0",
                                                "dateReported": "2022-09-13",
                                                "dateOpened": "2020-01-01",
                                                "accountNumber": "673926492644",
                                                "dateAccountStatus": "2022-01-01",
                                                "currentBalance": "374",
                                                "creditorName": "CAPITAL ONE",
                                                "position": "3",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank Credit Cards",
                                                    "description": "Bank Credit Cards",
                                                    "symbol": "BC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Account was in dispute - now resolved - reported by subscriber.",
                                                            "description": "Account was in dispute - now resolved - reported by subscriber.",
                                                            "symbol": "E0013",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                            "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                            "symbol": "XC097",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "32",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "12",
                                                    "dateLastPayment": "2020-11-19",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "374",
                                                    "worstPatStatusCount": "32",
                                                    "AccountType": {
                                                        "abbreviation": "Credit Card",
                                                        "description": "Credit Card",
                                                        "symbol": "CC",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "999999999111111111111CCCC",
                                                        "startDate": "2022-09-13",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-09-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-08-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-07-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-06-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-05-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-04-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-03-12",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-02-12",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-01-12",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-12-12",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-11-12",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-10-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-09-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-08-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-07-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-06-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-05-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-04-13",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-03-12",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-02-12",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-01-12",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2020-12-12",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-12",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-13",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-13",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "524"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "71.37%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "CAPITAL ONE",
                                            "telephone": "8009557070",
                                            "subscriberCode": "01DTV001",
                                            "CreditAddress": {
                                                "city": "SALT LAKE CITY ",
                                                "stateCode": "UT",
                                                "unparsedStreet": "PO BOX 31293 ",
                                                "postalCode": "84131"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "673926492644"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "10": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "1240000",
                                                "highBalance": "175",
                                                "dateReported": "2017-05-06",
                                                "dateOpened": "2017-04-01",
                                                "accountNumber": "7635286294394",
                                                "dateAccountStatus": "2017-05-01",
                                                "currentBalance": "0",
                                                "creditorName": "CITICARDS CBNA",
                                                "position": "4",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank Credit Cards",
                                                    "description": "Bank Credit Cards",
                                                    "symbol": "BC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                            "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                            "symbol": "E0020",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                            "description": "Unpaid balance reported as a loss by credit grantor.",
                                                            "symbol": "XS097",
                                                            "rank": "10000"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "symbol": "XC067",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "1",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "1",
                                                    "AccountType": {
                                                        "abbreviation": "Credit line secured",
                                                        "description": "Credit line secured",
                                                        "symbol": "LS",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "9",
                                                        "startDate": "2017-05-06",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2017-05-06",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2017-04-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2017-03-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2017-02-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2017-01-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-12-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-11-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-10-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-09-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-08-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-07-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-06-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-05-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-04-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-03-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-02-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-01-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-12-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-11-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-10-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-09-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-08-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-07-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-06-06",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "200"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "0%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "CITICARDS CBNA",
                                            "telephone": "8009505114",
                                            "subscriberCode": "1240000",
                                            "CreditAddress": {
                                                "city": "SIOUX FALLS",
                                                "stateCode": "SD",
                                                "unparsedStreet": "PO BOX 6241",
                                                "postalCode": "57117"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "7635286294394"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "15": {
                                        "accountTypeDescription": "Open Account",
                                        "accountTypeSymbol": "O",
                                        "accountTypeAbbreviation": "Open Account",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "9306706",
                                                "highBalance": "6110",
                                                "dateReported": "2021-06-22",
                                                "dateOpened": "2019-03-01",
                                                "accountNumber": "84372930094736547",
                                                "dateAccountStatus": "2019-10-01",
                                                "currentBalance": "6098",
                                                "creditorName": "ACCEPTANCE NOW",
                                                "position": "14",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Furniture Rentals\/Leasing",
                                                    "description": "Furniture Rentals\/Leasing",
                                                    "symbol": "HR",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "symbol": "XC097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "28",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "3",
                                                    "late60Count": "1",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2019-03-28",
                                                    "termMonths": "21",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "28",
                                                    "AccountType": {
                                                        "abbreviation": "Rental agreement",
                                                        "description": "Rental agreement",
                                                        "symbol": "RA",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Open Account",
                                                        "description": "Open Account",
                                                        "symbol": "O",
                                                        "rank": "30"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "9UUUUUUUUUUUUUUUUUUU95432",
                                                        "startDate": "2021-06-22",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-06-22",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-05-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-03-22",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-02-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-01-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-12-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-11-21",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-10-22",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2019-09-22",
                                                                "status": "5"
                                                            },
                                                            {
                                                                "date": "2019-08-22",
                                                                "status": "4"
                                                            },
                                                            {
                                                                "date": "2019-07-22",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2019-06-22",
                                                                "status": "2"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ACCEPTANCE NOW",
                                            "telephone": "8886722411",
                                            "subscriberCode": "9306706",
                                            "CreditAddress": {
                                                "city": "PLANO",
                                                "stateCode": "TX",
                                                "unparsedStreet": "5501 HEADQUARTERS DR",
                                                "postalCode": "75024"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Good",
                                            "accountID": "R0601004500034562723"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "19": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "1689430",
                                                "highBalance": "332",
                                                "dateReported": "2022-08-31",
                                                "dateOpened": "2019-02-01",
                                                "accountNumber": "98800000003936927",
                                                "dateAccountStatus": "2020-09-01",
                                                "currentBalance": "444",
                                                "creditorName": "A+ LOANS",
                                                "position": "18",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Personal Loan Companies",
                                                    "description": "Personal Loan Companies",
                                                    "symbol": "FP",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by credit grantor.",
                                                        "symbol": "XS097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "24",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2019-05-30",
                                                    "termMonths": "1",
                                                    "collateral": "",
                                                    "amountPastDue": "340",
                                                    "worstPatStatusCount": "24",
                                                    "AccountType": {
                                                        "abbreviation": "Note loan",
                                                        "description": "Note loan",
                                                        "symbol": "NT",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "999UUUUUUUUUUUUU99999999",
                                                        "startDate": "2022-08-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-08-31",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-07-31",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-06-30",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-05-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "9"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "A+ LOANS",
                                            "telephone": "6787209006",
                                            "subscriberCode": "1689430",
                                            "CreditAddress": {
                                                "city": "ATLANTA",
                                                "stateCode": "GA",
                                                "unparsedStreet": "1352 LAKEWOOD AVE SE",
                                                "postalCode": "30315"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "98800000003936927"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "21": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "1453090",
                                                "highBalance": "0",
                                                "dateReported": "2022-09-13",
                                                "dateOpened": "2016-08-01",
                                                "accountNumber": "8543271930201630",
                                                "dateAccountStatus": "2022-06-01",
                                                "currentBalance": "106",
                                                "creditorName": "GREEN DOT BANK",
                                                "position": "22",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank Credit Cards",
                                                    "description": "Bank Credit Cards",
                                                    "symbol": "BC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "description": "Unpaid balance reported as a loss by the credit grantor.",
                                                        "symbol": "XC097",
                                                        "rank": "10000"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "73",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "2",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2016-10-02",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "106",
                                                    "worstPatStatusCount": "73",
                                                    "AccountType": {
                                                        "abbreviation": "Credit line secured",
                                                        "description": "Credit line secured",
                                                        "symbol": "LS",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "9999UUUUUUUUUUUUUUUUUUUUU",
                                                        "startDate": "2022-09-13",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-09-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-08-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-07-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-06-13",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2022-05-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-04-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-03-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-12",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-13",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-13",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "1000"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "10.60%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "GREEN DOT BANK",
                                            "telephone": "6094540337",
                                            "subscriberCode": "1453090",
                                            "CreditAddress": {
                                                "city": "PASADENA",
                                                "stateCode": "CA",
                                                "unparsedStreet": "PO BOX 5100",
                                                "postalCode": "91117"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "8543271930201630"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "27": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "2244970",
                                                "highBalance": "273",
                                                "dateReported": "2017-05-06",
                                                "dateOpened": "2016-06-01",
                                                "accountNumber": "785636992105648",
                                                "dateAccountStatus": "2017-05-01",
                                                "currentBalance": "0",
                                                "creditorName": "WEBBANK\/FINGERHUT",
                                                "position": "37",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Credit Card - Dept. Store",
                                                    "description": "Credit Card - Dept. Store",
                                                    "symbol": "1D",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Purchased by a another lender.",
                                                            "description": "Purchased by a another lender.",
                                                            "symbol": "E0040",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                            "description": "Unpaid balance reported as a loss by credit grantor.",
                                                            "symbol": "XS097",
                                                            "rank": "10000"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "symbol": "XC067",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "11",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "1",
                                                    "late60Count": "1",
                                                    "late30Count": "1",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "11",
                                                    "AccountType": {
                                                        "abbreviation": "Charge account",
                                                        "description": "Charge account",
                                                        "symbol": "CH",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "99321CCCCCC",
                                                        "startDate": "2017-05-06",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2017-05-06",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2017-04-06",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2017-03-05",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2017-02-05",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2017-01-05",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2016-12-05",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-11-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-10-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-09-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-08-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-07-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-06-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-05-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-04-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-03-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-02-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2016-01-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-12-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-11-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-10-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-09-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-08-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-07-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2015-06-06",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "0%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "WEBBANK\/FINGERHUT",
                                            "telephone": "",
                                            "subscriberCode": "2244970",
                                            "CreditAddress": {
                                                "city": "SAINT CLOUD",
                                                "stateCode": "MN",
                                                "unparsedStreet": "6250 RIDGEWOOD RD",
                                                "postalCode": "56303"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "785636992105648"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    }
                                },
                                "Delinq": {
                                    "14": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02GS2001",
                                                "highBalance": "525",
                                                "dateVerified": "2021-03-10",
                                                "dateReported": "2021-03-10",
                                                "dateOpened": "2019-03-28",
                                                "accountNumber": "736293645",
                                                "dateAccountStatus": "2021-03-10",
                                                "currentBalance": "0",
                                                "creditorName": "ATLCAPBKSELF",
                                                "position": "11",
                                                "dateClosed": "2021-03-10",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "50"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank",
                                                    "description": "Bank",
                                                    "symbol": "B",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed",
                                                        "description": "Closed",
                                                        "symbol": "T00CLO",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "24",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "2",
                                                    "late30Count": "2",
                                                    "dateLastPayment": "2021-03-10",
                                                    "termMonths": "24",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "24",
                                                    "AccountType": {
                                                        "abbreviation": "Secured loan",
                                                        "description": "Secured loan",
                                                        "symbol": "SE",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "Monthly (every month)",
                                                        "description": "Monthly (every month)",
                                                        "symbol": "M",
                                                        "rank": "199"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "60 Delinq",
                                                        "description": "Late 60 Days",
                                                        "symbol": "2",
                                                        "rank": "104"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "CCCCCCCCCCCCC21CCCCC21CC",
                                                        "startDate": "2021-02-10",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-02-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-01-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-12-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-08-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-07-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-06-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-05-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-04-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-03-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-02-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-01-10",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-12-10",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-11-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-10-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-09-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-08-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-07-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-06-10",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-05-10",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-04-10",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-03-10",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": "MFS_421A1643-37F4-44AB"
                                                }
                                            },
                                            {
                                                "subscriberCode": "2928750",
                                                "highBalance": "525",
                                                "dateReported": "2021-03-31",
                                                "dateOpened": "2019-03-01",
                                                "accountNumber": "736293645",
                                                "dateAccountStatus": "2021-03-01",
                                                "currentBalance": "0",
                                                "creditorName": "SELF\/ATLANTIC CAPITAL",
                                                "position": "12",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Paid",
                                                    "description": "Paid",
                                                    "symbol": "P",
                                                    "rank": "10"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "All Banks",
                                                    "description": "All Banks",
                                                    "symbol": "BBE",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "25",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "2",
                                                    "late30Count": "2",
                                                    "dateLastPayment": "2021-03-10",
                                                    "termMonths": "24",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "25",
                                                    "AccountType": {
                                                        "abbreviation": "Secured loan",
                                                        "description": "Secured loan",
                                                        "symbol": "SE",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "60 Delinq",
                                                        "description": "Late 60 Days",
                                                        "symbol": "2",
                                                        "rank": "104"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UCCCCCCCCCCCCC21CCCCC21CC",
                                                        "startDate": "2021-03-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-03-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-07-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-06-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-05-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-04-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-03-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-01-27",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-12-27",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-07-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-06-28",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-05-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-04-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-03-28",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "401BB42003",
                                                "highBalance": "525",
                                                "dateReported": "2021-03-01",
                                                "dateOpened": "2019-03-01",
                                                "accountNumber": "736293645",
                                                "dateAccountStatus": "2021-03-01",
                                                "currentBalance": "0",
                                                "creditorName": "ATLANTICCA",
                                                "position": "13",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Paid",
                                                    "description": "Paid",
                                                    "symbol": "P",
                                                    "rank": "10"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "All Banks",
                                                    "description": "All Banks",
                                                    "symbol": "BBE",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Closed or paid account\/zero balance",
                                                            "description": "Closed or paid account\/zero balance",
                                                            "symbol": "Q00FA",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Secured",
                                                            "description": "Secured",
                                                            "symbol": "Q00EE",
                                                            "rank": "199"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "24",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "2",
                                                    "late30Count": "2",
                                                    "dateLastPayment": "2021-03-01",
                                                    "termMonths": "24",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "24",
                                                    "AccountType": {
                                                        "abbreviation": "Secured loan",
                                                        "description": "Secured loan",
                                                        "symbol": "SE",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "60 Delinq",
                                                        "description": "Late 60 Days",
                                                        "symbol": "2",
                                                        "rank": "104"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUU21UUUUU21UU",
                                                        "startDate": "2021-02-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-02-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-03-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-02-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-01-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-12-01",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-06-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2019-05-01",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-03-01",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ATLANTIC CAP BKSELFLENDR",
                                            "telephone": "8778830999",
                                            "subscriberCode": "02GS2001",
                                            "CreditAddress": {
                                                "city": "AUSTIN ",
                                                "stateCode": "TX",
                                                "unparsedStreet": "515 CONGRESS AVE SUITE 2200 ",
                                                "postalCode": "78701"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Full Service Banks",
                                                "description": "Full Service Banks",
                                                "symbol": "BO",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "736293645"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Delinquency"
                                    }
                                },
                                "Derogatory": {
                                    "17": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0908N664",
                                                "highBalance": "1656",
                                                "dateVerified": "2017-05-06",
                                                "dateReported": "2017-05-06",
                                                "dateOpened": "2011-12-29",
                                                "accountNumber": "6646540006081",
                                                "dateAccountStatus": "2016-03-15",
                                                "currentBalance": "0",
                                                "creditorName": "WELLS FARGO",
                                                "position": "16",
                                                "dateClosed": "2016-03-15",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank",
                                                    "description": "Bank",
                                                    "symbol": "B",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Unk",
                                                    "description": "Unknown",
                                                    "symbol": "U",
                                                    "rank": "10000"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Chapter 7 bankruptcy",
                                                        "description": "Chapter 7 bankruptcy",
                                                        "symbol": "T00CBL",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "0",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2016-05-11",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "0",
                                                    "AccountType": {
                                                        "abbreviation": "Credit Card",
                                                        "description": "Credit Card",
                                                        "symbol": "CC",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Unk",
                                                        "description": "Unknown",
                                                        "symbol": "U",
                                                        "rank": "10000"
                                                    },
                                                    "PayStatusHistory": "",
                                                    "CreditLimit": "1200"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": "MFS_421A1643-37F4-44AB"
                                                },
                                                "Utilization": "0%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "WELLS FARGO CARD SERVICE",
                                            "telephone": "8004624720",
                                            "subscriberCode": "0908N664",
                                            "CreditAddress": {
                                                "city": "DES MOINES ",
                                                "stateCode": "IA",
                                                "unparsedStreet": "PO BOX 14517 ",
                                                "postalCode": "50306"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Bank Credit Cards",
                                                "description": "Bank Credit Cards",
                                                "symbol": "BC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "6646540006081"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Derogatory"
                                    }
                                }
                            },
                            "AutoLoan": {
                                "ChargeOff": {
                                    "16": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "1918788",
                                                "highBalance": "30180",
                                                "dateReported": "2017-05-06",
                                                "dateOpened": "2015-02-01",
                                                "accountNumber": "84729472974924",
                                                "dateAccountStatus": "2017-05-01",
                                                "currentBalance": "0",
                                                "creditorName": "ALLY FINANCIAL",
                                                "position": "15",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Joint",
                                                    "description": "Joint",
                                                    "symbol": "J",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Auto Financing",
                                                    "description": "Auto Financing",
                                                    "symbol": "FA",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                            "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                            "symbol": "E0020",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                            "description": "Unpaid balance reported as a loss by credit grantor.",
                                                            "symbol": "XS097",
                                                            "rank": "10000"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "description": "Debt included in or discharged through Bankruptcy Chapter 7,11, or 12.",
                                                            "symbol": "XC067",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "23",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "1",
                                                    "late30Count": "2",
                                                    "termMonths": "75",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "23",
                                                    "AccountType": {
                                                        "abbreviation": "Auto Loan",
                                                        "description": "Auto Loan",
                                                        "symbol": "AU",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "991U21UCCCCCCCUUUUUUUUC",
                                                        "startDate": "2017-05-06",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2017-05-06",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2017-04-06",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2017-03-05",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2017-02-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2017-01-05",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2016-12-05",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2016-11-06",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2016-10-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-09-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-08-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-07-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-06-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-05-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-04-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2016-03-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2016-02-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2016-01-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-12-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-11-05",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-10-06",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-09-06",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-08-06",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2015-07-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2015-06-06",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ALLY FINANCIAL",
                                            "telephone": "8002004622",
                                            "subscriberCode": "1918788",
                                            "CreditAddress": {
                                                "city": "DETROIT",
                                                "stateCode": "MI",
                                                "unparsedStreet": "200 RENAISSANCE CTR # B0",
                                                "postalCode": "48243"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "84729472974924"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "18": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0600631",
                                                "highBalance": "24118",
                                                "dateReported": "2021-11-10",
                                                "dateOpened": "2018-02-01",
                                                "accountNumber": "746394720490",
                                                "dateAccountStatus": "2021-11-01",
                                                "currentBalance": "0",
                                                "creditorName": "CONSUMER PORTFOLIO SVC",
                                                "position": "17",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Auto Financing",
                                                    "description": "Auto Financing",
                                                    "symbol": "FA",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Purchased by a another lender.",
                                                            "description": "Purchased by a another lender.",
                                                            "symbol": "E0040",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Unpaid balance reported as a loss by credit grantor.",
                                                            "description": "Unpaid balance reported as a loss by credit grantor.",
                                                            "symbol": "XS097",
                                                            "rank": "10000"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "Sold to: JEFFERSON CAPITAL",
                                                        "RemarkCode": {
                                                            "abbreviation": "",
                                                            "description": "",
                                                            "symbol": "",
                                                            "rank": "100000"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "46",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "1",
                                                    "late60Count": "1",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2018-04-13",
                                                    "termMonths": "72",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "46",
                                                    "AccountType": {
                                                        "abbreviation": "Auto Loan",
                                                        "description": "Auto Loan",
                                                        "symbol": "AU",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "Coll\/Chargeoff",
                                                        "description": "Collection\/Chargeoff",
                                                        "symbol": "9",
                                                        "rank": "2"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "9UUUUUUUUUU99999999999999",
                                                        "startDate": "2021-11-10",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-11-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2021-10-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-10",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-11-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-10-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-09-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-08-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-07-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-06-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-05-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-04-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-03-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-02-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2020-01-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2019-12-10",
                                                                "status": "9"
                                                            },
                                                            {
                                                                "date": "2019-11-10",
                                                                "status": "9"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "CONSUMER PORTFOLIO SVC",
                                            "telephone": "BYMAILONLY",
                                            "subscriberCode": "0600631",
                                            "CreditAddress": {
                                                "city": "IRVINE",
                                                "stateCode": "CA",
                                                "unparsedStreet": "PO BOX 57071",
                                                "postalCode": "92619"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "746394720490"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    }
                                }
                            }
                        },
                        "Open": {
                            "Other": {
                                "ChargeOff": {
                                    "2": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02ELW001",
                                                "highBalance": "391",
                                                "dateVerified": "2022-06-29",
                                                "dateReported": "2022-06-29",
                                                "dateOpened": "2021-06-28",
                                                "accountNumber": "B76398266N1",
                                                "dateAccountStatus": "2022-06-29",
                                                "currentBalance": "509",
                                                "creditorName": "ALDOUS",
                                                "position": "23",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Collection Services",
                                                    "description": "Collection Services",
                                                    "symbol": "Y",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Account information disputed by consumer, meets FCRA requirements",
                                                        "description": "Account information disputed by consumer, meets FCRA requirements",
                                                        "symbol": "T00AID",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "05 FITNESS PROJECT HOUSTON NORTH",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": "MFS_88F25AE4-1CFA-40AB"
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ALDOUS AND ASSOCIATES",
                                            "telephone": "8012725281",
                                            "subscriberCode": "02ELW001",
                                            "CreditAddress": {
                                                "city": "HOLLADAY ",
                                                "stateCode": "UT",
                                                "unparsedStreet": "PO BOX 171374 ",
                                                "postalCode": "84117"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "D85797262M1"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "3": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02ELW001",
                                                "highBalance": "607",
                                                "dateVerified": "2022-06-29",
                                                "dateReported": "2022-06-29",
                                                "dateOpened": "2017-09-20",
                                                "accountNumber": "B83740274H1",
                                                "dateAccountStatus": "2022-06-29",
                                                "currentBalance": "789",
                                                "creditorName": "ALDOUS",
                                                "position": "24",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Collection Services",
                                                    "description": "Collection Services",
                                                    "symbol": "Y",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Placed for collection",
                                                        "description": "Placed for collection",
                                                        "symbol": "T00CLA",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "05 GOLD S GYM HOUSTON NORTH",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": "MFS_88F25AE4-1CFA-40AB"
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ALDOUS AND ASSOCIATES",
                                            "telephone": "8012725281",
                                            "subscriberCode": "02ELW001",
                                            "CreditAddress": {
                                                "city": "HOLLADAY ",
                                                "stateCode": "UT",
                                                "unparsedStreet": "PO BOX 171374 ",
                                                "postalCode": "84117"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "D85797262M1"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "4": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02ELW001",
                                                "highBalance": "1375",
                                                "dateVerified": "2022-06-29",
                                                "dateReported": "2022-06-29",
                                                "dateOpened": "2017-09-20",
                                                "accountNumber": "D85797262M1",
                                                "dateAccountStatus": "2022-06-29",
                                                "currentBalance": "1787",
                                                "creditorName": "ALDOUS",
                                                "position": "25",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Collection Services",
                                                    "description": "Collection Services",
                                                    "symbol": "Y",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Placed for collection",
                                                        "description": "Placed for collection",
                                                        "symbol": "T00CLA",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "05 GOLDS GYM HOUSTON CYPRESS LA",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": "MFS_88F25AE4-1CFA-40AB"
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ALDOUS AND ASSOCIATES",
                                            "telephone": "8012725281",
                                            "subscriberCode": "02ELW001",
                                            "CreditAddress": {
                                                "city": "HOLLADAY ",
                                                "stateCode": "UT",
                                                "unparsedStreet": "PO BOX 171374 ",
                                                "postalCode": "84117"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-04",
                                                "Reference": "MFS_88F25AE4-1CFA-40AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "D85797262M1"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    }
                                },
                                "Delinq": {
                                    "38": {
                                        "accountTypeDescription": "Revolving Account",
                                        "accountTypeSymbol": "R",
                                        "accountTypeAbbreviation": "Revolving",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "2925066",
                                                "highBalance": "1560",
                                                "dateReported": "2021-12-06",
                                                "dateOpened": "2021-02-01",
                                                "accountNumber": "834729362937639",
                                                "dateAccountStatus": "2021-11-01",
                                                "currentBalance": "1444",
                                                "creditorName": "TOMOCREDIT INC",
                                                "position": "44",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Credit Card - Finance Company",
                                                    "description": "Credit Card - Finance Company",
                                                    "symbol": "1F",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "**CONSUMER STATEMENT** ACCOUNT WAS PAID BEFORE BEING TURNED OVER TO A COLLECTION AGENCY.",
                                                    "RemarkCode": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "10",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "2",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2021-08-15",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "1444",
                                                    "worstPatStatusCount": "10",
                                                    "AccountType": {
                                                        "abbreviation": "Credit Card",
                                                        "description": "Credit Card",
                                                        "symbol": "CC",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "60 Delinq",
                                                        "description": "Late 60 Days",
                                                        "symbol": "2",
                                                        "rank": "104"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "221CCCCCCC",
                                                        "startDate": "2021-12-06",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2021-12-06",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-11-06",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-10-06",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-09-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-08-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-07-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-06-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-05-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-04-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-03-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-02-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-01-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-12-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-10-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-09-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-08-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-07-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-06-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-05-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-04-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-03-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-02-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-01-06",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "2000"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "72.20%"
                                            },
                                            {
                                                "subscriberCode": "163FZ06207",
                                                "highBalance": "0",
                                                "dateReported": "2022-03-01",
                                                "dateOpened": "2021-02-01",
                                                "accountNumber": "834729362937639",
                                                "dateAccountStatus": "2021-09-01",
                                                "currentBalance": "1444",
                                                "creditorName": "TOMOCREDIT",
                                                "position": "45",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Miscellaneous Finance",
                                                    "description": "Miscellaneous Finance",
                                                    "symbol": "FZ",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "60 Delinq",
                                                    "description": "Late 60 Days",
                                                    "symbol": "2",
                                                    "rank": "104"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Amount in H\/C column is credit limit",
                                                        "description": "Amount in H\/C column is credit limit",
                                                        "symbol": "Q00AZ",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "10",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "3",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2021-09-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "1444",
                                                    "worstPatStatusCount": "10",
                                                    "AccountType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Revolving",
                                                        "description": "Revolving Account",
                                                        "symbol": "R",
                                                        "rank": "50"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "60 Delinq",
                                                        "description": "Late 60 Days",
                                                        "symbol": "2",
                                                        "rank": "104"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "22U21UUUUUUUU",
                                                        "startDate": "2022-02-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-02-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2022-01-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-12-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-12-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-07-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-06-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-05-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-04-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-03-01",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "2000"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                },
                                                "Utilization": "72.20%"
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "TOMOCREDIT INC",
                                            "telephone": "2028581034",
                                            "subscriberCode": "2925066",
                                            "CreditAddress": {
                                                "city": "SAN FRANCISCO",
                                                "stateCode": "CA",
                                                "unparsedStreet": "535 MISSION ST FL 14",
                                                "postalCode": "94105"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "834729362937639"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Delinquency"
                                    }
                                }
                            },
                            "Educational": {
                                "Delinq": {
                                    "29": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "1132610",
                                                "highBalance": "47496",
                                                "dateReported": "2022-08-31",
                                                "dateOpened": "2009-09-01",
                                                "accountNumber": "15362871281",
                                                "dateAccountStatus": "2016-10-01",
                                                "currentBalance": "62491",
                                                "creditorName": "US DEPT OF ED\/GLELSI",
                                                "position": "39",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Student Loans",
                                                    "description": "Student Loans",
                                                    "symbol": "EL",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "symbol": "E0020",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "87",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "2",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2022-08-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "87",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "CCCCCCCCUUUUUUUUUUUUCCCCC",
                                                        "startDate": "2022-08-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-08-31",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-07-31",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-06-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-05-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "668FZ67126",
                                                "highBalance": "47496",
                                                "dateReported": "2022-08-01",
                                                "dateOpened": "2009-09-01",
                                                "accountNumber": "15362871281",
                                                "dateAccountStatus": "2022-08-01",
                                                "currentBalance": "62491",
                                                "creditorName": "USD\/GLELSI",
                                                "position": "40",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account disputed",
                                                    "description": "Account disputed",
                                                    "symbol": "T",
                                                    "rank": "198"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Miscellaneous Finance",
                                                    "description": "Miscellaneous Finance",
                                                    "symbol": "FZ",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Consumer disputes after resolution",
                                                            "description": "Consumer disputes after resolution",
                                                            "symbol": "Q00IQ",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Student loan",
                                                            "description": "Student loan",
                                                            "symbol": "Q00BU",
                                                            "rank": "199"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "99",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "2",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2022-08-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "99",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                        "startDate": "2022-07-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "US DEPT OF ED\/GLELSI",
                                            "telephone": "8002364300",
                                            "subscriberCode": "1132610",
                                            "CreditAddress": {
                                                "city": "MADISON",
                                                "stateCode": "WI",
                                                "unparsedStreet": "PO BOX 7860",
                                                "postalCode": "53707"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "",
                                                "description": "",
                                                "symbol": "",
                                                "rank": "100000"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "Experian",
                                                    "description": "Experian",
                                                    "symbol": "EXP",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": ""
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "87927492345"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Delinquency"
                                    },
                                    "35": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0368N4TP",
                                                "highBalance": "4897",
                                                "dateVerified": "2022-08-31",
                                                "dateReported": "2022-08-31",
                                                "dateOpened": "2008-12-17",
                                                "accountNumber": "87927492345",
                                                "dateAccountStatus": "2022-08-31",
                                                "currentBalance": "6935",
                                                "creditorName": "USDOE\/GLELSI",
                                                "position": "41",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Education\/Employment",
                                                    "description": "Education\/Employment",
                                                    "symbol": "E",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "48",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2022-08-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "48",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "CCCCCCCUUUUUUUUUUUUCCCCCCCCCUCUUUUUUUUUUUC",
                                                        "startDate": "2022-07-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-07-31",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-06-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-05-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-07-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-06-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-05-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-04-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-08-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-04-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-02-27",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": "MFS_421A1643-37F4-44AB"
                                                }
                                            },
                                            {
                                                "subscriberCode": "1132610",
                                                "highBalance": "4897",
                                                "dateReported": "2022-08-31",
                                                "dateOpened": "2008-12-01",
                                                "accountNumber": "87927492345",
                                                "dateAccountStatus": "2016-09-01",
                                                "currentBalance": "6935",
                                                "creditorName": "US DEPT OF ED\/GLELSI",
                                                "position": "42",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Student Loans",
                                                    "description": "Student Loans",
                                                    "symbol": "EL",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "88",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "2",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2022-08-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "88",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "CCCCCCCCUUUUUUUUUUUUCCCCC",
                                                        "startDate": "2022-08-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-08-31",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-07-31",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-06-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-05-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "668FZ65280",
                                                "highBalance": "4897",
                                                "dateReported": "2022-08-01",
                                                "dateOpened": "2008-12-01",
                                                "accountNumber": "87927492345",
                                                "dateAccountStatus": "2022-08-01",
                                                "currentBalance": "6935",
                                                "creditorName": "USD\/GLELSI",
                                                "position": "43",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Miscellaneous Finance",
                                                    "description": "Miscellaneous Finance",
                                                    "symbol": "FZ",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Student loan",
                                                        "description": "Student loan",
                                                        "symbol": "Q00BU",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "99",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "2",
                                                    "late60Count": "0",
                                                    "late30Count": "0",
                                                    "dateLastPayment": "2022-08-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "99",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUUUUUUUUUUUUUUUUUUUU",
                                                        "startDate": "2022-07-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "US DEPT OF EDUCATION\/GLE",
                                            "telephone": "8002364300",
                                            "subscriberCode": "0368N4TP",
                                            "CreditAddress": {
                                                "city": "MADISON ",
                                                "stateCode": "WI",
                                                "unparsedStreet": "2401 INTERNATIONAL LANE POB 7859 ",
                                                "postalCode": "53704"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "87927492345"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Delinquency"
                                    }
                                },
                                "Derogatory": {
                                    "30": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0494T94D",
                                                "highBalance": "21857",
                                                "dateVerified": "2022-05-31",
                                                "dateReported": "2022-05-31",
                                                "dateOpened": "2007-08-01",
                                                "accountNumber": "64864379283A00001",
                                                "dateAccountStatus": "2022-05-31",
                                                "currentBalance": "26319",
                                                "creditorName": "AES\/NCT",
                                                "position": "127",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Joint",
                                                    "description": "Joint",
                                                    "symbol": "J",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Education\/Employment",
                                                    "description": "Education\/Employment",
                                                    "symbol": "E",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Dispute resolved; customer disagrees",
                                                        "description": "Dispute resolved; customer disagrees",
                                                        "symbol": "T00DRC",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "48",
                                                    "monthlyPayment": "291",
                                                    "late90Count": "2",
                                                    "late60Count": "2",
                                                    "late30Count": "5",
                                                    "dateLastPayment": "2022-05-18",
                                                    "termMonths": "240",
                                                    "collateral": "",
                                                    "amountPastDue": "830",
                                                    "worstPatStatusCount": "48",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "Monthly (every month)",
                                                        "description": "Monthly (every month)",
                                                        "symbol": "M",
                                                        "rank": "199"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "21C1CCCCC4321CUUUUUUCUUUUUUUUC11CCCCCCCCCCCCCCCC",
                                                        "startDate": "2022-04-30",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "4"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-04-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-03-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2019-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-10-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-09-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2019-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-07-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-06-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-05-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-04-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-03-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2019-01-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-07-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-06-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2018-05-28",
                                                                "status": "C"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-03",
                                                    "Reference": "MFS_BE90D669-1FE5-4587"
                                                }
                                            },
                                            {
                                                "subscriberCode": "8997791",
                                                "highBalance": "21857",
                                                "dateReported": "2022-05-31",
                                                "dateOpened": "2007-08-01",
                                                "accountNumber": "64864379283A00001",
                                                "dateAccountStatus": "2022-05-01",
                                                "currentBalance": "26319",
                                                "creditorName": "AES\/NCT",
                                                "position": "128",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Joint",
                                                    "description": "Joint",
                                                    "symbol": "J",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Student Loans",
                                                    "description": "Student Loans",
                                                    "symbol": "EL",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "description": "Subscriber reports dispute resolved - consumer disagrees.",
                                                        "symbol": "E0020",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "99",
                                                    "monthlyPayment": "291",
                                                    "late90Count": "3",
                                                    "late60Count": "2",
                                                    "late30Count": "5",
                                                    "dateLastPayment": "2022-05-18",
                                                    "termMonths": "240",
                                                    "collateral": "",
                                                    "amountPastDue": "830",
                                                    "worstPatStatusCount": "99",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "321C1CCCCC4321CUUUUUUCUUU",
                                                        "startDate": "2022-05-31",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-05-31",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2022-04-30",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2022-03-30",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2022-02-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-27",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-12-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-11-27",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-10-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-09-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-07-28",
                                                                "status": "4"
                                                            },
                                                            {
                                                                "date": "2021-06-28",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2021-05-28",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-04-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-03-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-02-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-27",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-28",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2020-07-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-28",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-03",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "496FZ06166",
                                                "highBalance": "21857",
                                                "dateReported": "2022-05-01",
                                                "dateOpened": "2007-08-01",
                                                "accountNumber": "64864379283A00001",
                                                "dateAccountStatus": "2022-03-01",
                                                "currentBalance": "26319",
                                                "creditorName": "AES\/NCTR",
                                                "position": "129",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Joint",
                                                    "description": "Joint",
                                                    "symbol": "J",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account disputed",
                                                    "description": "Account disputed",
                                                    "symbol": "T",
                                                    "rank": "198"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Miscellaneous Finance",
                                                    "description": "Miscellaneous Finance",
                                                    "symbol": "FZ",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "90 Delinq",
                                                    "description": "Late 90 Days",
                                                    "symbol": "3",
                                                    "rank": "103"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Consumer disputes after resolution",
                                                            "description": "Consumer disputes after resolution",
                                                            "symbol": "Q00IQ",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Student loan",
                                                            "description": "Student loan",
                                                            "symbol": "Q00BU",
                                                            "rank": "199"
                                                        }
                                                    }
                                                ],
                                                "GrantedTrade": {
                                                    "monthsReviewed": "99",
                                                    "monthlyPayment": "291",
                                                    "late90Count": "2",
                                                    "late60Count": "2",
                                                    "late30Count": "5",
                                                    "dateLastPayment": "2022-03-01",
                                                    "termMonths": "0",
                                                    "collateral": "",
                                                    "amountPastDue": "830",
                                                    "worstPatStatusCount": "99",
                                                    "AccountType": {
                                                        "abbreviation": "Educational",
                                                        "description": "Educational",
                                                        "symbol": "ST",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "120 Delinq",
                                                        "description": "Late 120 Days",
                                                        "symbol": "4",
                                                        "rank": "102"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "21U1UUUUU4321UUUUUUUUUUU",
                                                        "startDate": "2022-04-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-04-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2022-02-28",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2022-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-31",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "4"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "3"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "2"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2020-05-01",
                                                                "status": "U"
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-07-04",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "AES\/NCT",
                                            "telephone": "8002330557",
                                            "subscriberCode": "0494T94D",
                                            "CreditAddress": {
                                                "city": "HARRISBURG ",
                                                "stateCode": "PA",
                                                "unparsedStreet": "POB 61047 ",
                                                "postalCode": "17106"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Student Loans",
                                                "description": "Student Loans",
                                                "symbol": "EL",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-07-03",
                                                "Reference": "MFS_BE90D669-1FE5-4587"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "64864379283A00001"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Derogatory"
                                    }
                                }
                            }
                        },
                        "Mixed": {
                            "Other": {
                                "Delinq": {
                                    "20": {
                                        "accountTypeDescription": "Installment Account",
                                        "accountTypeSymbol": "I",
                                        "accountTypeAbbreviation": "Installment",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "02FCE002",
                                                "highBalance": "1663",
                                                "dateVerified": "2022-05-18",
                                                "dateReported": "2022-05-18",
                                                "dateOpened": "2021-05-25",
                                                "accountNumber": "76483753",
                                                "dateAccountStatus": "2022-05-18",
                                                "currentBalance": "0",
                                                "creditorName": "SBNASELFLNDR",
                                                "position": "19",
                                                "dateClosed": "2022-05-18",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "50"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Bank",
                                                    "description": "Bank",
                                                    "symbol": "B",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Closed",
                                                        "description": "Closed",
                                                        "symbol": "T00CLO",
                                                        "rank": "199"
                                                    }
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "10",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2022-05-18",
                                                    "termMonths": "12",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "10",
                                                    "AccountType": {
                                                        "abbreviation": "Secured loan",
                                                        "description": "Secured loan",
                                                        "symbol": "SE",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "Monthly (every month)",
                                                        "description": "Monthly (every month)",
                                                        "symbol": "M",
                                                        "rank": "199"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "30 Delinq",
                                                        "description": "Late 30 Days",
                                                        "symbol": "1",
                                                        "rank": "105"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUCC1CCC",
                                                        "startDate": "2022-04-18",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-04-18",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-03-18",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-17",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-17",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-12-17",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-11-17",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-10-18",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-09-18",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-08-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-07-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-06-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-05-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-04-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-03-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-02-17",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-01-17",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-12-17",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-17",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-10-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-09-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-08-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-07-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-06-18",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-05-18",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": "MFS_421A1643-37F4-44AB"
                                                }
                                            },
                                            {
                                                "subscriberCode": "1188380",
                                                "highBalance": "1663",
                                                "dateReported": "2022-06-06",
                                                "dateOpened": "2021-05-01",
                                                "accountNumber": "76483753",
                                                "dateAccountStatus": "2022-06-01",
                                                "currentBalance": "0",
                                                "creditorName": "SBNASELFLNDR",
                                                "position": "20",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "60"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "All Banks",
                                                    "description": "All Banks",
                                                    "symbol": "BBE",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "30 Delinq",
                                                    "description": "Late 30 Days",
                                                    "symbol": "1",
                                                    "rank": "105"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "14",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "3",
                                                    "dateLastPayment": "2022-05-18",
                                                    "termMonths": "12",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "14",
                                                    "AccountType": {
                                                        "abbreviation": "Secured loan",
                                                        "description": "Secured loan",
                                                        "symbol": "SE",
                                                        "rank": "50"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "30 Delinq",
                                                        "description": "Late 30 Days",
                                                        "symbol": "1",
                                                        "rank": "105"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "1C1CCCC1CCCCCC",
                                                        "startDate": "2022-06-06",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-06-06",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2022-05-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-04-06",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2022-03-05",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-02-05",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2022-01-05",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-12-05",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-11-06",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-10-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-09-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-08-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-07-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-06-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-05-06",
                                                                "status": "C"
                                                            },
                                                            {
                                                                "date": "2021-04-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-03-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-02-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-01-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-12-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-05",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-10-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-09-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-08-06",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-07-06",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "436BB00879",
                                                "highBalance": "1663",
                                                "dateReported": "2022-06-01",
                                                "dateOpened": "2021-05-01",
                                                "accountNumber": "76483753",
                                                "dateAccountStatus": "2022-04-01",
                                                "currentBalance": "0",
                                                "creditorName": "SBNASLFLDR",
                                                "position": "21",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Paid",
                                                    "description": "Paid",
                                                    "symbol": "P",
                                                    "rank": "10"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "All Banks",
                                                    "description": "All Banks",
                                                    "symbol": "BBE",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Current",
                                                    "description": "Current",
                                                    "symbol": "C",
                                                    "rank": "110"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "GrantedTrade": {
                                                    "monthsReviewed": "11",
                                                    "monthlyPayment": "0",
                                                    "late90Count": "0",
                                                    "late60Count": "0",
                                                    "late30Count": "1",
                                                    "dateLastPayment": "2022-04-01",
                                                    "termMonths": "12",
                                                    "collateral": "",
                                                    "amountPastDue": "0",
                                                    "worstPatStatusCount": "11",
                                                    "AccountType": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "CreditType": {
                                                        "abbreviation": "Installment",
                                                        "description": "Installment Account",
                                                        "symbol": "I",
                                                        "rank": "20"
                                                    },
                                                    "PaymentFrequency": {
                                                        "abbreviation": "",
                                                        "description": "",
                                                        "symbol": "",
                                                        "rank": "100000"
                                                    },
                                                    "TermType": {
                                                        "abbreviation": "Provided",
                                                        "description": "Provided",
                                                        "symbol": "P",
                                                        "rank": "199"
                                                    },
                                                    "WorstPayStatus": {
                                                        "abbreviation": "30 Delinq",
                                                        "description": "Late 30 Days",
                                                        "symbol": "1",
                                                        "rank": "105"
                                                    },
                                                    "PayStatusHistory": {
                                                        "status": "UUUUUU1UUUUUU",
                                                        "startDate": "2022-05-01",
                                                        "MonthlyPayStatus": [
                                                            {
                                                                "date": "2022-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-04-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-02-28",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2022-01-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-12-31",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-30",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-11-01",
                                                                "status": "1"
                                                            },
                                                            {
                                                                "date": "2021-10-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-09-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-08-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-07-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-06-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-05-01",
                                                                "status": "U"
                                                            },
                                                            {
                                                                "date": "2021-04-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-02-28",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2021-01-31",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-12-31",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-30",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-11-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-10-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-09-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-08-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-07-01",
                                                                "status": " "
                                                            },
                                                            {
                                                                "date": "2020-06-01",
                                                                "status": " "
                                                            }
                                                        ]
                                                    },
                                                    "CreditLimit": "0"
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-09-23",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "SUNRISE BANK SELF LENDER",
                                            "telephone": "6052502620",
                                            "subscriberCode": "02FCE002",
                                            "CreditAddress": {
                                                "city": "AUSTIN ",
                                                "stateCode": "TX",
                                                "unparsedStreet": "515 CONGRESS AVE, SUITE 2200 C\/O SELF FINANCIAL, INC. ",
                                                "postalCode": "78701"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Miscellaneous Banks",
                                                "description": "Miscellaneous Banks",
                                                "symbol": "BZ",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-09-23",
                                                "Reference": "MFS_421A1643-37F4-44AB"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "76483753"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "Delinquency"
                                    }
                                },
                                "ChargeOff": {
                                    "36": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0204K003",
                                                "highBalance": "128",
                                                "dateVerified": "2022-09-25",
                                                "dateReported": "2022-09-25",
                                                "dateOpened": "2022-05-16",
                                                "accountNumber": "946662930283",
                                                "dateAccountStatus": "2022-09-25",
                                                "currentBalance": "128",
                                                "creditorName": "MED DATA SYS",
                                                "position": "18",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Collection Services",
                                                    "description": "Collection Services",
                                                    "symbol": "Y",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Placed for collection",
                                                        "description": "Placed for collection",
                                                        "symbol": "T00CLA",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "KENNESTONE HOSPITAL",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-10-17",
                                                    "Reference": "MFS_73EEBD7E-1756-49F1"
                                                }
                                            },
                                            {
                                                "subscriberCode": "1982731",
                                                "highBalance": "128",
                                                "dateReported": "2022-09-25",
                                                "dateOpened": "2022-05-01",
                                                "accountNumber": "946662930283",
                                                "dateAccountStatus": "2022-05-01",
                                                "currentBalance": "128",
                                                "creditorName": "MEDICAL DATA SYSTEMS I",
                                                "position": "19",
                                                "bureau": "Experian",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "KENNESTONE HOSPITAL",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Experian",
                                                        "description": "Experian",
                                                        "symbol": "EXP",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-10-17",
                                                    "Reference": ""
                                                }
                                            },
                                            {
                                                "subscriberCode": "835YC00000",
                                                "highBalance": "128",
                                                "dateReported": "2022-08-01",
                                                "dateOpened": "2022-05-01",
                                                "accountNumber": "946662930283",
                                                "dateAccountStatus": "2022-08-01",
                                                "currentBalance": "128",
                                                "creditorName": "",
                                                "position": "20",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Medical",
                                                            "description": "Medical",
                                                            "symbol": "Q00GS",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Subject has not satisfied debt.",
                                                            "description": "Subject has not satisfied debt.",
                                                            "symbol": "QC0D",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "CollectionTrade": {
                                                    "originalCreditor": "",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-10-17",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "MEDICAL DATA SYSTEMS INC",
                                            "telephone": "8003156050",
                                            "subscriberCode": "0204K003",
                                            "CreditAddress": {
                                                "city": "SEBRING ",
                                                "stateCode": "FL",
                                                "unparsedStreet": "1532 LAKEVIEW DR ",
                                                "postalCode": "33870"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-10-17",
                                                "Reference": "MFS_73EEBD7E-1756-49F1"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "946662930283"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    },
                                    "37": {
                                        "accountTypeDescription": "Collection Account",
                                        "accountTypeSymbol": "Y",
                                        "accountTypeAbbreviation": "Collection",
                                        "Tradeline": [
                                            {
                                                "subscriberCode": "0925M001",
                                                "highBalance": "99",
                                                "dateVerified": "2022-10-04",
                                                "dateReported": "2022-10-04",
                                                "dateOpened": "2020-09-29",
                                                "accountNumber": "7569044",
                                                "dateAccountStatus": "2022-10-04",
                                                "currentBalance": "150",
                                                "creditorName": "ARMADA COR",
                                                "position": "42",
                                                "bureau": "TransUnion",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Collection Services",
                                                    "description": "Collection Services",
                                                    "symbol": "Y",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Open",
                                                    "description": "Open",
                                                    "symbol": "O",
                                                    "rank": "199"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "Remark": {
                                                    "customRemark": "",
                                                    "RemarkCode": {
                                                        "abbreviation": "Placed for collection",
                                                        "description": "Placed for collection",
                                                        "symbol": "T00CLA",
                                                        "rank": "199"
                                                    }
                                                },
                                                "CollectionTrade": {
                                                    "originalCreditor": "HOLA DENTAL CHEYENNE",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "TransUnion",
                                                        "description": "TransUnion",
                                                        "symbol": "TUC",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-11-01",
                                                    "Reference": "MFS_14356E72-A030-494F"
                                                }
                                            },
                                            {
                                                "subscriberCode": "712YC00000",
                                                "highBalance": "99",
                                                "dateReported": "2022-10-01",
                                                "dateOpened": "2020-09-01",
                                                "accountNumber": "7569044",
                                                "dateAccountStatus": "2022-10-01",
                                                "currentBalance": "150",
                                                "creditorName": "",
                                                "position": "43",
                                                "bureau": "Equifax",
                                                "AccountCondition": {
                                                    "abbreviation": "Derog",
                                                    "description": "Derogatory",
                                                    "symbol": "F",
                                                    "rank": "20"
                                                },
                                                "AccountDesignator": {
                                                    "abbreviation": "Individual",
                                                    "description": "Individual",
                                                    "symbol": "I",
                                                    "rank": "199"
                                                },
                                                "DisputeFlag": {
                                                    "abbreviation": "Account not disputed",
                                                    "description": "Account not disputed",
                                                    "symbol": "F",
                                                    "rank": "199"
                                                },
                                                "IndustryCode": {
                                                    "abbreviation": "Other Collection Agencies",
                                                    "description": "Other Collection Agencies",
                                                    "symbol": "YC",
                                                    "rank": "199"
                                                },
                                                "OpenClosed": {
                                                    "abbreviation": "Closed",
                                                    "description": "Closed",
                                                    "symbol": "C",
                                                    "rank": "198"
                                                },
                                                "PayStatus": {
                                                    "abbreviation": "Coll\/Chargeoff",
                                                    "description": "Collection\/Chargeoff",
                                                    "symbol": "9",
                                                    "rank": "2"
                                                },
                                                "VerificationIndicator": {
                                                    "abbreviation": "",
                                                    "description": "",
                                                    "symbol": "",
                                                    "rank": "100000"
                                                },
                                                "Remark": [
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Medical",
                                                            "description": "Medical",
                                                            "symbol": "Q00GS",
                                                            "rank": "199"
                                                        }
                                                    },
                                                    {
                                                        "customRemark": "",
                                                        "RemarkCode": {
                                                            "abbreviation": "Subject has not satisfied debt.",
                                                            "description": "Subject has not satisfied debt.",
                                                            "symbol": "QC0D",
                                                            "rank": "10000"
                                                        }
                                                    }
                                                ],
                                                "CollectionTrade": {
                                                    "originalCreditor": "",
                                                    "creditType": {
                                                        "abbreviation": "Collection",
                                                        "description": "Collection Account",
                                                        "symbol": "Y",
                                                        "rank": "5"
                                                    }
                                                },
                                                "Source": {
                                                    "BorrowerKey": "",
                                                    "Bureau": {
                                                        "abbreviation": "Equifax",
                                                        "description": "Equifax",
                                                        "symbol": "EQF",
                                                        "rank": "1"
                                                    },
                                                    "InquiryDate": "2022-11-01",
                                                    "Reference": ""
                                                }
                                            }
                                        ],
                                        "Subscriber": {
                                            "name": "ARMADA CORPORATION",
                                            "telephone": "8009492372",
                                            "subscriberCode": "0925M001",
                                            "CreditAddress": {
                                                "city": "EAST WENATCHEE ",
                                                "stateCode": "WA",
                                                "unparsedStreet": "93 EASTMONT AVE SUITE #100 ",
                                                "postalCode": "98802"
                                            },
                                            "IndustryCode": {
                                                "abbreviation": "Other Collection Agencies",
                                                "description": "Other Collection Agencies",
                                                "symbol": "YC",
                                                "rank": "199"
                                            },
                                            "Source": {
                                                "BorrowerKey": "",
                                                "Bureau": {
                                                    "abbreviation": "TransUnion",
                                                    "description": "TransUnion",
                                                    "symbol": "TUC",
                                                    "rank": "1"
                                                },
                                                "InquiryDate": "2022-11-01",
                                                "Reference": "MFS_14356E72-A030-494F"
                                            },
                                            "inquiryType": "Bad",
                                            "accountID": "7569044"
                                        },
                                        "accountStatus": "Negative",
                                        "accountSeverity": "ChargeOff"
                                    }
                                }
                            }
                        }
                    }
                },
                "AccountTradeLineCount": {
                    "Positive": {
                        "Open": {
                            "count": 10,
                            "Other": {
                                "count": 6
                            },
                            "AutoLoan": {
                                "count": 1
                            },
                            "Educational": {
                                "count": 3
                            }
                        },
                        "count": 16,
                        "Closed": {
                            "count": 6,
                            "Mortgage": {
                                "count": 1
                            },
                            "Other": {
                                "count": 4
                            },
                            "Educational": {
                                "count": 1
                            }
                        }
                    },
                    "Negative": {
                        "Closed": {
                            "Mortgage": {
                                "ChargeOff": {
                                    "count": 1
                                },
                                "count": 1
                            },
                            "count": 13,
                            "Other": {
                                "ChargeOff": {
                                    "count": 8
                                },
                                "count": 10,
                                "Delinq": {
                                    "count": 1
                                },
                                "Derogatory": {
                                    "count": 1
                                }
                            },
                            "AutoLoan": {
                                "ChargeOff": {
                                    "count": 2
                                },
                                "count": 2
                            }
                        },
                        "count": 23,
                        "Open": {
                            "Other": {
                                "ChargeOff": {
                                    "count": 3
                                },
                                "count": 4,
                                "Delinq": {
                                    "count": 1
                                }
                            },
                            "count": 7,
                            "Educational": {
                                "Delinq": {
                                    "count": 2
                                },
                                "count": 3,
                                "Derogatory": {
                                    "count": 1
                                }
                            }
                        },
                        "Mixed": {
                            "Other": {
                                "Delinq": {
                                    "count": 1
                                },
                                "count": 3,
                                "ChargeOff": {
                                    "count": 2
                                }
                            },
                            "count": 3
                        }
                    }
                },
                "TotalAccCount": 39,
                "creditorsArray": [
                    {
                        "ID": "3452FSF4RS",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "KIKOFF LEND",
                            "dateOpened": "2022-02-01"
                        },
                        "Equifax": {
                            "name": "KIKOFFLEND",
                            "dateOpened": "2022-02-01"
                        }
                    },
                    {
                        "ID": "8376492642",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "FREEDOM MTG",
                            "dateOpened": "2018-08-31"
                        },
                        "Experian": {
                            "name": "FREEDOM MORTGAGE CORP",
                            "dateOpened": "2018-08-01"
                        },
                        "Equifax": {
                            "name": "FREEDOM MT",
                            "dateOpened": "2018-08-01"
                        }
                    },
                    {
                        "ID": "B76398266N1",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "ALDOUS",
                            "dateOpened": "2021-06-28"
                        }
                    },
                    {
                        "ID": "B83740274H1",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "ALDOUS",
                            "dateOpened": "2017-09-20"
                        }
                    },
                    {
                        "ID": "D85797262M1",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "ALDOUS",
                            "dateOpened": "2017-09-20"
                        }
                    },
                    {
                        "ID": "867309003826135005",
                        "condition": "Bad",
                        "Experian": {
                            "name": "PROCOLLECT,INC",
                            "dateOpened": "2019-05-01"
                        },
                        "Equifax": {
                            "name": "",
                            "dateOpened": "2019-05-01"
                        }
                    },
                    {
                        "ID": "89826352",
                        "condition": "Bad",
                        "Experian": {
                            "name": "CONVERGENT OUTSOURCING",
                            "dateOpened": "2022-03-01"
                        },
                        "Equifax": {
                            "name": "",
                            "dateOpened": "2022-03-01"
                        }
                    },
                    {
                        "ID": "972819381739123",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "SEZZLE",
                            "dateOpened": "2021-04-06"
                        },
                        "Experian": {
                            "name": "SEZZLE INC",
                            "dateOpened": "2021-04-01"
                        }
                    },
                    {
                        "ID": "8739287291732",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "PACIFICUNION",
                            "dateOpened": "2018-08-31"
                        },
                        "Experian": {
                            "name": "PACIFIC UNION FINANCIA",
                            "dateOpened": "2018-08-01"
                        },
                        "Equifax": {
                            "name": "PACUF",
                            "dateOpened": "2018-08-01"
                        }
                    },
                    {
                        "ID": "673926492644",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "CAPITAL ONE",
                            "dateOpened": "2020-01-23"
                        },
                        "Experian": {
                            "name": "CAPITAL ONE",
                            "dateOpened": "2020-01-01"
                        }
                    },
                    {
                        "ID": "7635286294394",
                        "condition": "Bad",
                        "Experian": {
                            "name": "CITICARDS CBNA",
                            "dateOpened": "2017-04-01"
                        }
                    },
                    {
                        "ID": "878271629281",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "BIGHTON RENT",
                            "dateOpened": "2021-08-01"
                        },
                        "Equifax": {
                            "name": "BRIGHTONRENT",
                            "dateOpened": "2021-08-01"
                        }
                    },
                    {
                        "ID": "983627386482",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "CHIME-STRIDE",
                            "dateOpened": "2020-11-30"
                        },
                        "Experian": {
                            "name": "CHIME\/STRIDE BANK NA",
                            "dateOpened": "2020-11-01"
                        },
                        "Equifax": {
                            "name": "CHIMEF\/STR",
                            "dateOpened": "2020-11-01"
                        }
                    },
                    {
                        "ID": "DDGAUKDYALDOL345LDD",
                        "condition": "Good",
                        "Experian": {
                            "name": "RENT SELF-REPORTED",
                            "dateOpened": ""
                        }
                    },
                    {
                        "ID": "736293645",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "ATLCAPBKSELF",
                            "dateOpened": "2019-03-28"
                        },
                        "Experian": {
                            "name": "SELF\/ATLANTIC CAPITAL",
                            "dateOpened": "2019-03-01"
                        },
                        "Equifax": {
                            "name": "ATLANTICCA",
                            "dateOpened": "2019-03-01"
                        }
                    },
                    {
                        "ID": "84372930094736547",
                        "condition": "Bad",
                        "Experian": {
                            "name": "ACCEPTANCE NOW",
                            "dateOpened": "2019-03-01"
                        }
                    },
                    {
                        "ID": "84729472974924",
                        "condition": "Bad",
                        "Experian": {
                            "name": "ALLY FINANCIAL",
                            "dateOpened": "2015-02-01"
                        }
                    },
                    {
                        "ID": "6646540006081",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "WELLS FARGO",
                            "dateOpened": "2011-12-29"
                        }
                    },
                    {
                        "ID": "746394720490",
                        "condition": "Bad",
                        "Experian": {
                            "name": "CONSUMER PORTFOLIO SVC",
                            "dateOpened": "2018-02-01"
                        }
                    },
                    {
                        "ID": "98800000003936927",
                        "condition": "Bad",
                        "Experian": {
                            "name": "A+ LOANS",
                            "dateOpened": "2019-02-01"
                        }
                    },
                    {
                        "ID": "76483753",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "SBNASELFLNDR",
                            "dateOpened": "2021-05-25"
                        },
                        "Experian": {
                            "name": "SBNASELFLNDR",
                            "dateOpened": "2021-05-01"
                        },
                        "Equifax": {
                            "name": "SBNASLFLDR",
                            "dateOpened": "2021-05-01"
                        }
                    },
                    {
                        "ID": "8543271930201630",
                        "condition": "Bad",
                        "Experian": {
                            "name": "GREEN DOT BANK",
                            "dateOpened": "2016-08-01"
                        }
                    },
                    {
                        "ID": "CSHRLED45A",
                        "condition": "Good",
                        "Experian": {
                            "name": "KIKOFF LENDING LLC",
                            "dateOpened": "2021-04-01"
                        },
                        "Equifax": {
                            "name": "KIKOFFLEND",
                            "dateOpened": "2021-04-01"
                        }
                    },
                    {
                        "ID": "04500034562723",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "ACEPTANCENOW",
                            "dateOpened": "2018-11-23"
                        },
                        "Experian": {
                            "name": "ACCEPTANCE NOW",
                            "dateOpened": "2018-11-01"
                        },
                        "Equifax": {
                            "name": "ACCPTNOW",
                            "dateOpened": "2018-11-01"
                        }
                    },
                    {
                        "ID": "9834598271",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "SELFINC\/LEAD",
                            "dateOpened": "2020-03-18"
                        },
                        "Experian": {
                            "name": "SELF FINANCIAL\/LEAD BA",
                            "dateOpened": "2020-03-01"
                        },
                        "Equifax": {
                            "name": "SELF\/LEADB",
                            "dateOpened": "2020-03-01"
                        }
                    },
                    {
                        "ID": "726946298734",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "BRIDGECREST",
                            "dateOpened": "2022-03-09"
                        },
                        "Experian": {
                            "name": "BRIDGECREST",
                            "dateOpened": "2022-03-01"
                        },
                        "Equifax": {
                            "name": "BRIDGCREST",
                            "dateOpened": "2022-03-01"
                        }
                    },
                    {
                        "ID": "657873625183722",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "WEBBNK\/FSTR",
                            "dateOpened": "2016-06-06"
                        },
                        "Experian": {
                            "name": "WEBBANK\/FINGERHUT FRES",
                            "dateOpened": "2016-06-01"
                        },
                        "Equifax": {
                            "name": "FHUT\/WEBBK",
                            "dateOpened": "2016-06-01"
                        }
                    },
                    {
                        "ID": "785636992105648",
                        "condition": "Bad",
                        "Experian": {
                            "name": "WEBBANK\/FINGERHUT",
                            "dateOpened": "2016-06-01"
                        }
                    },
                    {
                        "ID": "AADHKSH281630DFT564",
                        "condition": "Good",
                        "Experian": {
                            "name": "TELECOM SELF-REPORTED",
                            "dateOpened": ""
                        }
                    },
                    {
                        "ID": "15362871281",
                        "condition": "Bad",
                        "Experian": {
                            "name": "US DEPT OF ED\/GLELSI",
                            "dateOpened": "2009-09-01"
                        },
                        "Equifax": {
                            "name": "USD\/GLELSI",
                            "dateOpened": "2009-09-01"
                        }
                    },
                    {
                        "ID": "64864379283A00001",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "AES\/NCT",
                            "dateOpened": "2007-08-01"
                        },
                        "Experian": {
                            "name": "AES\/NCT",
                            "dateOpened": "2007-08-01"
                        },
                        "Equifax": {
                            "name": "AES\/NCTR",
                            "dateOpened": "2007-08-01"
                        }
                    },
                    {
                        "ID": "873450347833428",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "FEDLOAN",
                            "dateOpened": "2014-08-26"
                        },
                        "Equifax": {
                            "name": "FEDLOAN",
                            "dateOpened": "2014-08-01"
                        }
                    },
                    {
                        "ID": "873450347833428",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "FEDLOAN",
                            "dateOpened": "2016-08-19"
                        },
                        "Experian": {
                            "name": "FED LOAN SERV",
                            "dateOpened": "2016-08-01"
                        },
                        "Equifax": {
                            "name": "FEDLOAN",
                            "dateOpened": "2016-08-01"
                        }
                    },
                    {
                        "ID": "873450347833428",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "FEDLOAN",
                            "dateOpened": "2020-08-17"
                        },
                        "Experian": {
                            "name": "FED LOAN SERV",
                            "dateOpened": "2020-08-01"
                        },
                        "Equifax": {
                            "name": "FEDLOAN",
                            "dateOpened": "2020-08-01"
                        }
                    },
                    {
                        "ID": "873450347833428",
                        "condition": "Good",
                        "TransUnion": {
                            "name": "FEDLOAN",
                            "dateOpened": "2016-08-19"
                        },
                        "Experian": {
                            "name": "FED LOAN SERV",
                            "dateOpened": "2016-08-01"
                        },
                        "Equifax": {
                            "name": "FEDLOAN",
                            "dateOpened": "2016-08-01"
                        }
                    },
                    {
                        "ID": "87927492345",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "USDOE\/GLELSI",
                            "dateOpened": "2008-12-17"
                        },
                        "Experian": {
                            "name": "US DEPT OF ED\/GLELSI",
                            "dateOpened": "2008-12-01"
                        },
                        "Equifax": {
                            "name": "USD\/GLELSI",
                            "dateOpened": "2008-12-01"
                        }
                    },
                    {
                        "ID": "946662930283",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "MED DATA SYS",
                            "dateOpened": "2022-05-16"
                        },
                        "Experian": {
                            "name": "MEDICAL DATA SYSTEMS I",
                            "dateOpened": "2022-05-01"
                        },
                        "Equifax": {
                            "name": "",
                            "dateOpened": "2022-05-01"
                        }
                    },
                    {
                        "ID": "7569044",
                        "condition": "Bad",
                        "TransUnion": {
                            "name": "ARMADA COR",
                            "dateOpened": "2020-09-29"
                        },
                        "Equifax": {
                            "name": "",
                            "dateOpened": "2020-09-01"
                        }
                    },
                    {
                        "ID": "834729362937639",
                        "condition": "Bad",
                        "Experian": {
                            "name": "TOMOCREDIT INC",
                            "dateOpened": "2021-02-01"
                        },
                        "Equifax": {
                            "name": "TOMOCREDIT",
                            "dateOpened": "2021-02-01"
                        }
                    }
                ],
                "InquiryPartition": [
                    [
                        {
                            "inquiryDate": "2022-03-13",
                            "subscriberName": "BRIDGECREST FORMERLY DRI",
                            "subscriberNumber": "01SFX002",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Bank Credit Cards",
                                "description": "Bank Credit Cards",
                                "symbol": "BC",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "BRIDGECREST FORMERLY DRI",
                                "telephone": "8026433864",
                                "subscriberCode": "01SFX002",
                                "CreditAddress": {
                                    "city": "PHOENIX ",
                                    "stateCode": "AZ",
                                    "unparsedStreet": "PO BOX 29018 ",
                                    "postalCode": "85038"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Auto Financing",
                                    "description": "Auto Financing",
                                    "symbol": "FA",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                },
                                "inquiryType": "Good",
                                "accountID": "726946298734"
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-02-28",
                            "subscriberName": "KIKOFF LENDING LLC",
                            "subscriberNumber": "02H42001",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Bank Credit Cards",
                                "description": "Bank Credit Cards",
                                "symbol": "BC",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "KIKOFF LENDING LLC",
                                "telephone": "4153614040",
                                "subscriberCode": "02H42001",
                                "CreditAddress": {
                                    "city": "SAN FRANCISCO ",
                                    "stateCode": "CA",
                                    "unparsedStreet": "75 BROADWAY SUITE 202 ",
                                    "postalCode": "94111"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Miscellaneous Finance",
                                    "description": "Miscellaneous Finance",
                                    "symbol": "FZ",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                },
                                "inquiryType": "Good",
                                "accountID": "3452FSF4RS"
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-09-05",
                            "subscriberName": "DISCOVER FINANCIAL SER",
                            "subscriberNumber": "B6",
                            "bureau": "Experian",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "Bank Credit Cards",
                                "description": "Bank Credit Cards",
                                "symbol": "BC",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-02",
                            "subscriberName": "BK OF AMER",
                            "subscriberNumber": "06199555",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Bank Credit Cards",
                                "description": "Bank Credit Cards",
                                "symbol": "BC",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "BANK OF AMERICA",
                                "telephone": "8004212110",
                                "subscriberCode": "06199555",
                                "CreditAddress": {
                                    "city": "EL PASO ",
                                    "stateCode": "TX",
                                    "unparsedStreet": "PO BOX 982238 ",
                                    "postalCode": "79998"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Bank",
                                    "description": "Bank",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-02",
                            "subscriberName": "TRUIST",
                            "subscriberNumber": "456BB09024",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-02",
                            "subscriberName": "TRUIST",
                            "subscriberNumber": "456BB12441",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-08-15",
                            "subscriberName": "LIGHTSTREAM",
                            "subscriberNumber": "06525583",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Installment Loans",
                                "description": "Installment Loans",
                                "symbol": "BI",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "SUNTRUST DBA LIGHTSTREAM",
                                "telephone": "8007868787",
                                "subscriberCode": "06525583",
                                "CreditAddress": {
                                    "city": "SAN DIEGO ",
                                    "stateCode": "CA",
                                    "unparsedStreet": "600 W BROADWAY SUITE 2000 ",
                                    "postalCode": "92101"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Bank",
                                    "description": "Bank",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-05-18",
                            "subscriberName": "SYNCB\/CC",
                            "subscriberNumber": "04877646",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Sales Financing",
                                "description": "Sales Financing",
                                "symbol": "FF",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "SYNCB\/CARE CREDIT",
                                "telephone": "8009242927",
                                "subscriberCode": "04877646",
                                "CreditAddress": {
                                    "city": "DAYTON ",
                                    "stateCode": "OH",
                                    "unparsedStreet": "PO BOX 8726 ",
                                    "postalCode": "45401"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Finance\/Personal",
                                    "description": "Finance\/Personal",
                                    "symbol": "F",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-13",
                            "subscriberName": "CREDIT PLUS",
                            "subscriberNumber": "00049997",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Credit Bureaus\/Mortgage Processing",
                                "description": "Credit Bureaus\/Mortgage Processing",
                                "symbol": "ZM",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "CREDIT PLUS",
                                "telephone": "8002583488",
                                "subscriberCode": "00049997",
                                "CreditAddress": {
                                    "city": "SALISBURY ",
                                    "stateCode": "MD",
                                    "unparsedStreet": "31550 WINTERPLACE ",
                                    "postalCode": "21804"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Miscellaneous",
                                    "description": "Miscellaneous",
                                    "symbol": "Z",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-13",
                            "subscriberName": "XACTUS-CP\/ASSURANCE FI",
                            "subscriberNumber": "B6",
                            "bureau": "Experian",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "Mortgage Companies - Finance",
                                "description": "Mortgage Companies - Finance",
                                "symbol": "FM",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-06-13",
                            "subscriberName": "XACTUS",
                            "subscriberNumber": "801ZB00982",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2020-09-17",
                            "subscriberName": "BRIDGECREST",
                            "subscriberNumber": "01SFX002",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "Subscriber": {
                                "name": "BRIDGECREST FORMERLY DRI",
                                "telephone": "8026433864",
                                "subscriberCode": "01SFX002",
                                "CreditAddress": {
                                    "city": "PHOENIX ",
                                    "stateCode": "AZ",
                                    "unparsedStreet": "PO BOX 29018 ",
                                    "postalCode": "85038"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Auto Financing",
                                    "description": "Auto Financing",
                                    "symbol": "FA",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                },
                                "inquiryType": "Good",
                                "accountID": "726946298734"
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-09-22",
                            "subscriberName": "PANORAMA MOR",
                            "subscriberNumber": "06335039",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Mortgage Companies - Credit Union",
                                "description": "Mortgage Companies - Credit Union",
                                "symbol": "QM",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "CREDIT PLUS\/PANORAMA MOR",
                                "telephone": "7025885430",
                                "subscriberCode": "06335039",
                                "CreditAddress": {
                                    "city": "LAS VEGAS ",
                                    "stateCode": "NV",
                                    "unparsedStreet": "350 S RAMPART BLVD STE 310 ",
                                    "postalCode": "89145"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Credit Union",
                                    "description": "Credit Union",
                                    "symbol": "Q",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-09-22",
                            "subscriberName": "XACTUS-CP\/PANORAMA MOR",
                            "subscriberNumber": "B6",
                            "bureau": "Experian",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "Mortgage Companies - Finance",
                                "description": "Mortgage Companies - Finance",
                                "symbol": "FM",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-09-22",
                            "subscriberName": "XACTUS",
                            "subscriberNumber": "243ZB01899",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-07-08",
                            "subscriberName": "CORELOGIC",
                            "subscriberNumber": "02964510",
                            "bureau": "TransUnion",
                            "inquiryType": "I",
                            "IndustryCode": {
                                "abbreviation": "Bank - Mortgage Loans",
                                "description": "Bank - Mortgage Loans",
                                "symbol": "BM",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "TransUnion",
                                    "description": "TransUnion",
                                    "symbol": "TUC",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": "MFS_421A1643-37F4-44AB"
                            },
                            "Subscriber": {
                                "name": "CREDCO\/BAC 5",
                                "telephone": "8004476192",
                                "subscriberCode": "02964510",
                                "CreditAddress": {
                                    "city": "PASADENA ",
                                    "stateCode": "CA",
                                    "unparsedStreet": "35 N LAKE AVE ",
                                    "postalCode": "91101"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Bank",
                                    "description": "Bank",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-07-08",
                            "subscriberName": "CORELOGIC CREDCO LLC",
                            "subscriberNumber": "B6",
                            "bureau": "Experian",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "Mortgage Reporters",
                                "description": "Mortgage Reporters",
                                "symbol": "FR",
                                "rank": "199"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Experian",
                                    "description": "Experian",
                                    "symbol": "EXP",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        },
                        {
                            "inquiryDate": "2022-07-08",
                            "subscriberName": "CORELOGIC",
                            "subscriberNumber": "181ZB16539",
                            "bureau": "Equifax",
                            "inquiryType": "",
                            "IndustryCode": {
                                "abbreviation": "",
                                "description": "",
                                "symbol": "",
                                "rank": "100000"
                            },
                            "Source": {
                                "BorrowerKey": "",
                                "Bureau": {
                                    "abbreviation": "Equifax",
                                    "description": "Equifax",
                                    "symbol": "EQF",
                                    "rank": "1"
                                },
                                "InquiryDate": "2022-09-23",
                                "Reference": ""
                            },
                            "message": "This inquiry is categorized as 'Bad' because it is older than 24 months and may not be associated with an active or positive account."
                        }
                    ]
                ],
                "PulblicRecordPartition": [
                    {
                        "PublicRecord": [
                            {
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2021-06-17",
                                "referenceNumber": "2154606",
                                "subscriberCode": "0508601Z",
                                "bureau": "TransUnion",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Miscellaneous",
                                    "description": "Miscellaneous",
                                    "symbol": "Z",
                                    "rank": "199"
                                },
                                "Status": {
                                    "abbreviation": "Dismissed",
                                    "description": "Dismissed",
                                    "symbol": "8",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 13 Bankruptcy",
                                    "description": "Chapter 13 Bankruptcy",
                                    "symbol": "4",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "dateResolved": "2021-12-30",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            {
                                "courtName": "US BKPT CT GA ATLANTA",
                                "dateFiled": "2021-06-17",
                                "referenceNumber": "2154606PB",
                                "subscriberCode": "8000",
                                "bureau": "Experian",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "",
                                    "description": "",
                                    "symbol": "",
                                    "rank": "100000"
                                },
                                "Status": {
                                    "abbreviation": "Dismissed",
                                    "description": "Dismissed",
                                    "symbol": "8",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 13 Bankruptcy",
                                    "description": "Chapter 13 Bankruptcy",
                                    "symbol": "4",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "dateResolved": "2021-12-30",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "Experian",
                                        "description": "Experian",
                                        "symbol": "EXP",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": ""
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2021-01-21",
                                "referenceNumber": "2150547",
                                "subscriberCode": "0508601Z",
                                "bureau": "TransUnion",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Miscellaneous",
                                    "description": "Miscellaneous",
                                    "symbol": "Z",
                                    "rank": "199"
                                },
                                "Status": {
                                    "abbreviation": "Dismissed",
                                    "description": "Dismissed",
                                    "symbol": "8",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 13 Bankruptcy",
                                    "description": "Chapter 13 Bankruptcy",
                                    "symbol": "4",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "dateResolved": "2021-06-03",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "TransUnion",
                                        "description": "TransUnion",
                                        "symbol": "TUC",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": "MFS_421A1643-37F4-44AB"
                                }
                            },
                            {
                                "courtName": "US BKPT CT GA ATLANTA",
                                "dateFiled": "2021-01-21",
                                "referenceNumber": "2150547PB",
                                "subscriberCode": "8000",
                                "bureau": "Experian",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "",
                                    "description": "",
                                    "symbol": "",
                                    "rank": "100000"
                                },
                                "Status": {
                                    "abbreviation": "Dismissed",
                                    "description": "Dismissed",
                                    "symbol": "8",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 13 Bankruptcy",
                                    "description": "Chapter 13 Bankruptcy",
                                    "symbol": "4",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "dateResolved": "2021-06-03",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "Experian",
                                        "description": "Experian",
                                        "symbol": "EXP",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": ""
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "courtName": "US BKPT CT GA ATLANTA",
                                "dateFiled": "2017-05-06",
                                "referenceNumber": "1758283LRC",
                                "subscriberCode": "8000",
                                "bureau": "Experian",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "",
                                    "description": "",
                                    "symbol": "",
                                    "rank": "100000"
                                },
                                "Status": {
                                    "abbreviation": "Discharged",
                                    "description": "Discharged",
                                    "symbol": "1",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 7 Bankruptcy",
                                    "description": "Chapter 7 Bankruptcy",
                                    "symbol": "1",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "dateResolved": "2017-10-10",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "Experian",
                                        "description": "Experian",
                                        "symbol": "EXP",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": ""
                                }
                            },
                            {
                                "courtName": "Federal",
                                "dateFiled": "2017-05-01",
                                "referenceNumber": "1758283-DSP-10\/17-VER-05\/22",
                                "subscriberCode": "401VF00077",
                                "bureau": "Equifax",
                                "AccountDesignator": {
                                    "abbreviation": "Individual",
                                    "description": "Individual",
                                    "symbol": "I",
                                    "rank": "199"
                                },
                                "Classification": {
                                    "abbreviation": "Bankruptcy",
                                    "description": "Bankruptcy",
                                    "symbol": "B",
                                    "rank": "199"
                                },
                                "IndustryCode": {
                                    "abbreviation": "Federal",
                                    "description": "Federal",
                                    "symbol": "VF",
                                    "rank": "199"
                                },
                                "Status": {
                                    "abbreviation": "Discharged",
                                    "description": "Discharged",
                                    "symbol": "1",
                                    "rank": "199"
                                },
                                "Type": {
                                    "abbreviation": "Chapter 7 Bankruptcy",
                                    "description": "Chapter 7 Bankruptcy",
                                    "symbol": "1",
                                    "rank": "199"
                                },
                                "Bankruptcy": {
                                    "courtNumber": "",
                                    "division": "",
                                    "assetAmount": "0",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0",
                                    "trustee": "",
                                    "company": "",
                                    "thirdParty": ""
                                },
                                "Source": {
                                    "BorrowerKey": "",
                                    "Bureau": {
                                        "abbreviation": "Equifax",
                                        "description": "Equifax",
                                        "symbol": "EQF",
                                        "rank": "1"
                                    },
                                    "InquiryDate": "2022-09-23",
                                    "Reference": ""
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_C8C8B549-234E-4711",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2018-12-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-06-07",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "04887436",
                                "referenceNumber": "1874321",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT VA NORFOLK",
                                "dateFiled": "2018-12-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-06-07",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "5204",
                                "referenceNumber": "1874321FJS",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2018-12-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "832VF00013",
                                "referenceNumber": "1874321-DSP-06\/21-VER-01\/24",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_9E3E6BEF-ED5F-448F",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-08"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2017-10-16",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2018-05-02",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05105335",
                                "referenceNumber": "1711666",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Remark": {
                                    "RemarkCode": {
                                        "rank": "199",
                                        "symbol": "Q00FW",
                                        "description": "Consumer disputes - reinvestigation in progress",
                                        "abbreviation": "Consumer disputes - reinvestigation in progress"
                                    },
                                    "customRemark": ""
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-08"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2017-10-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "669VF02570",
                                "referenceNumber": "1711666-DSP-05\/18",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_3322368C-477B-4515",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2016-12-29",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-04-04",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0512324J",
                                "referenceNumber": "1680413",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT TX HOUSTON",
                                "dateFiled": "2016-12-29",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-04-04",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "4234",
                                "referenceNumber": "1680413MI",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2016-12-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "605VF49449",
                                "referenceNumber": "1680413-DSP-04\/17",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_03F66D85-CB1C-4248",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-28"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2021-02-12",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-09-28",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05000411",
                                "referenceNumber": "2141203",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-28"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BK CT-EAST DIST MIC",
                                "dateFiled": "2021-02-12",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-09-28",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "5500",
                                "referenceNumber": "2141203MLO",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-28"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2021-02-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "168VF00077",
                                "referenceNumber": "2141203-DSP-09\/21",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_A0EDA754-EB54-4A8C",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-08-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2014-12-19",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-04-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05080454",
                                "referenceNumber": "1417919",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-08-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT OH CLEVELAN",
                                "dateFiled": "2014-12-19",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-04-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1056",
                                "referenceNumber": "1417919AIH",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-08-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2014-12-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "645VF09306",
                                "referenceNumber": "1417919-DSP-04\/15-VER-05\/23",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_490C3B0D-A527-4135",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-07"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2015-04-28",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-09-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0508726P",
                                "referenceNumber": "1516683",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-07"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT CA L A",
                                "dateFiled": "2015-04-28",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-09-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1002",
                                "referenceNumber": "1516683RMN",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-07"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2015-04-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "180VF00014",
                                "referenceNumber": "1516683-DSP-09\/15",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_A100A2B4-4284-440A",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-06"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2022-11-15",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-03-30",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05000411",
                                "referenceNumber": "2248976",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-06"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BK CT-EAST DIST MIC",
                                "dateFiled": "2022-11-15",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-03-30",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "5500",
                                "referenceNumber": "2248976TJT",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-06"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2022-11-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "168VF00077",
                                "referenceNumber": "2248976-DSP-03\/23",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EXP",
                                    "description": "Experian",
                                    "abbreviation": "Experian"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-01-01"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "8",
                                "description": "Dismissed",
                                "abbreviation": "Dismissed"
                            },
                            "bureau": "Experian",
                            "courtName": "US BKPT CT IL CHICAGO",
                            "dateFiled": "2018-08-06",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "dateResolved": "2018-09-20",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "100000",
                                "symbol": "",
                                "description": "",
                                "abbreviation": ""
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "1000",
                            "referenceNumber": "1822026TAB",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EQF",
                                    "description": "Equifax",
                                    "abbreviation": "Equifax"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-01-01"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "8",
                                "description": "Dismissed",
                                "abbreviation": "Dismissed"
                            },
                            "bureau": "Equifax",
                            "courtName": "Federal",
                            "dateFiled": "2018-08-01",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "199",
                                "symbol": "VF",
                                "description": "Federal",
                                "abbreviation": "Federal"
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "155VF00015",
                            "referenceNumber": "1822026-DSP-09\/18-VER-11\/21",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EXP",
                                    "description": "Experian",
                                    "abbreviation": "Experian"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-01-01"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "8",
                                "description": "Dismissed",
                                "abbreviation": "Dismissed"
                            },
                            "bureau": "Experian",
                            "courtName": "US BKPT CT IL CHICAGO",
                            "dateFiled": "2018-08-06",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "dateResolved": "2018-09-20",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "100000",
                                "symbol": "",
                                "description": "",
                                "abbreviation": ""
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "1000",
                            "referenceNumber": "1822026TAB",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EQF",
                                    "description": "Equifax",
                                    "abbreviation": "Equifax"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-01-01"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "8",
                                "description": "Dismissed",
                                "abbreviation": "Dismissed"
                            },
                            "bureau": "Equifax",
                            "courtName": "Federal",
                            "dateFiled": "2018-08-01",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "199",
                                "symbol": "VF",
                                "description": "Federal",
                                "abbreviation": "Federal"
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "155VF00015",
                            "referenceNumber": "1822026-DSP-09\/18-VER-11\/21",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EXP",
                                    "description": "Experian",
                                    "abbreviation": "Experian"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-03-19"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "8",
                                "description": "Dismissed",
                                "abbreviation": "Dismissed"
                            },
                            "bureau": "Experian",
                            "courtName": "US BKPT CT GA ATLANTA",
                            "dateFiled": "2018-06-15",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "dateResolved": "2018-09-25",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "100000",
                                "symbol": "",
                                "description": "",
                                "abbreviation": ""
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "8000",
                            "referenceNumber": "1860054PB",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_147778B5-036A-417D",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-09-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2018-11-26",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-04-05",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "04841347",
                                "referenceNumber": "1877914",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-09-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT NY WESTBURY",
                                "dateFiled": "2018-11-26",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-04-05",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1011",
                                "referenceNumber": "1877914AST",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2023-09-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2018-11-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "404VF00389",
                                "referenceNumber": "1877914-DSP-04\/19",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_C2DDBFA1-1338-4E89",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-27"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2019-02-23",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2022-02-23",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05060203",
                                "referenceNumber": "1904746",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-27"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT IL CHICAGO",
                                "dateFiled": "2019-02-23",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2022-02-23",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1000",
                                "referenceNumber": "1904746DDC",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-27"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2019-02-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "155VF00015",
                                "referenceNumber": "1904746-DSP-02\/22",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_42D38528-F6DD-43FB",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-09"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2020-09-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-01-07",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05100374",
                                "referenceNumber": "2024404",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-09"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT TN MEMPHIS",
                                "dateFiled": "2020-09-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-01-07",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "2200",
                                "referenceNumber": "2024404JDL",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-09"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2020-09-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "833VF00046",
                                "referenceNumber": "2024404-DSP-01\/21",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_084478AC-61CC-472B",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-18"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2019-07-31",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-12-12",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0512324H",
                                "referenceNumber": "1932528",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-18"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT TX DALLAS",
                                "dateFiled": "2019-07-31",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-12-12",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "4238",
                                "referenceNumber": "1932528BJH",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-18"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2019-07-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "682VF05117",
                                "referenceNumber": "1932528-DSP-12\/19",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_460344E0-FF68-4ECB",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-05"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2023-06-27",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-09-26",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05060203",
                                "referenceNumber": "2308434",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-05"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT IL CHICAGO",
                                "dateFiled": "2023-06-27",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-09-26",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1000",
                                "referenceNumber": "2308434JPC",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_7833F33D-FA22-497A",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2022-08-17",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2022-11-22",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0508735L",
                                "referenceNumber": "2202150",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT CA SAN DIEG",
                                "dateFiled": "2022-08-17",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2022-11-22",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1004",
                                "referenceNumber": "2202150CBL",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2022-08-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "180VF00022",
                                "referenceNumber": "2202150-DSP-11\/22",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_07D12D9A-9CDA-408D",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2015-06-25",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-10-09",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "04850108",
                                "referenceNumber": "1521959",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT NJ TRENTON",
                                "dateFiled": "2015-06-25",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2015-10-09",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "2000",
                                "referenceNumber": "1521959MBK",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2015-06-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "444VF00605",
                                "referenceNumber": "1521959-DSP-10\/15",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_88EAE37B-B45E-4B51",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2019-03-15",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-06-24",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0508726P",
                                "referenceNumber": "1912796",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT CA L A",
                                "dateFiled": "2019-03-15",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2019-06-24",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1002",
                                "referenceNumber": "1912796EMR",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-04"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2019-03-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "180VF00014",
                                "referenceNumber": "1912796-DSP-06\/19",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_91DC654D-08E0-4F65",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2016-05-12",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-08-22",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05100374",
                                "referenceNumber": "1624480",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT TN MEMPHIS",
                                "dateFiled": "2016-05-12",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-08-22",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "2200",
                                "referenceNumber": "1624480JDL",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2016-05-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "833VF00046",
                                "referenceNumber": "1624480-DSP-08\/16",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_DC3A9767-F824-4196",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-26"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2016-07-16",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-11-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0508601Z",
                                "referenceNumber": "1662371",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-26"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT GA ATLANTA",
                                "dateFiled": "2016-07-16",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-11-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "8000",
                                "referenceNumber": "1662371MGD",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-01-26"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2016-07-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "401VF00077",
                                "referenceNumber": "1662371-DSP-11\/16",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_1E02AB5A-7943-4DC9",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2020-03-06",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2020-05-06",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05064313",
                                "referenceNumber": "2013154",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT FL MIAMI",
                                "dateFiled": "2020-03-06",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2020-05-06",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "7000",
                                "referenceNumber": "2013154LMI",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Remark": {
                                    "RemarkCode": {
                                        "rank": "199",
                                        "symbol": "Q00FW",
                                        "description": "Consumer disputes - reinvestigation in progress",
                                        "abbreviation": "Consumer disputes - reinvestigation in progress"
                                    },
                                    "customRemark": ""
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-01"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2020-03-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "402VF01074",
                                "referenceNumber": "2013154-DSP-05\/20",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_478220CF-A76A-4CF2",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-05-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2020-10-26",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-02-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0506113V",
                                "referenceNumber": "2011816",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-05-02"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT AZ PHOENIX",
                                "dateFiled": "2020-10-26",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2021-02-08",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0001",
                                "referenceNumber": "2011816PS",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "J",
                                    "description": "Joint",
                                    "abbreviation": "Joint"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_A1D8F1D5-268D-48D7",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-08"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2017-11-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2018-02-26",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "02C2W001",
                                "referenceNumber": "1725146",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-08"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT MD BALTIMOR",
                                "dateFiled": "2017-11-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2018-02-26",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "5000",
                                "referenceNumber": "1725146DER",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_9F78B436-E4FD-4889",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-21"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2017-08-09",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-11-20",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0508735Q",
                                "referenceNumber": "1725262",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-21"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT CA SACRAMEN",
                                "dateFiled": "2017-08-09",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-11-20",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1003",
                                "referenceNumber": "1725262MSM",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Remark": {
                                    "RemarkCode": {
                                        "rank": "199",
                                        "symbol": "Q00FW",
                                        "description": "Consumer disputes - reinvestigation in progress",
                                        "abbreviation": "Consumer disputes - reinvestigation in progress"
                                    },
                                    "customRemark": ""
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-03-21"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2017-08-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "236VF00092",
                                "referenceNumber": "1725262-DSP-11\/17-VER-03\/23",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": {
                            "Type": {
                                "rank": "199",
                                "symbol": "4",
                                "description": "Chapter 13 Bankruptcy",
                                "abbreviation": "Chapter 13 Bankruptcy"
                            },
                            "Source": {
                                "Bureau": {
                                    "rank": "1",
                                    "symbol": "EXP",
                                    "description": "Experian",
                                    "abbreviation": "Experian"
                                },
                                "Reference": "",
                                "BorrowerKey": "",
                                "InquiryDate": "2024-02-06"
                            },
                            "Status": {
                                "rank": "199",
                                "symbol": "1",
                                "description": "Discharged",
                                "abbreviation": "Discharged"
                            },
                            "bureau": "Experian",
                            "courtName": "US BKPT CT IN HAMMOND",
                            "dateFiled": "2018-09-14",
                            "Bankruptcy": {
                                "company": "",
                                "trustee": "",
                                "division": "",
                                "thirdParty": "",
                                "assetAmount": "0",
                                "courtNumber": "",
                                "dateResolved": "2023-12-07",
                                "exemptAmount": "0",
                                "liabilityAmount": "0"
                            },
                            "IndustryCode": {
                                "rank": "100000",
                                "symbol": "",
                                "description": "",
                                "abbreviation": ""
                            },
                            "Classification": {
                                "rank": "199",
                                "symbol": "B",
                                "description": "Bankruptcy",
                                "abbreviation": "Bankruptcy"
                            },
                            "subscriberCode": "8000",
                            "referenceNumber": "1822453KL",
                            "AccountDesignator": {
                                "rank": "199",
                                "symbol": "I",
                                "description": "Individual",
                                "abbreviation": "Individual"
                            }
                        }
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_6C1720DA-7B88-4E86",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-13"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2015-02-02",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-05-02",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05064306",
                                "referenceNumber": "1511987",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-13"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT FL FT LAUDE",
                                "dateFiled": "2015-02-02",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2016-05-02",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0061",
                                "referenceNumber": "1511987RBR",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-13"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2015-02-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "402VF12828",
                                "referenceNumber": "1511987-DSP-05\/16",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_56957241-DDA4-48DC",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2022-12-30",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-03-09",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05060203",
                                "referenceNumber": "2215009",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT IL CHICAGO",
                                "dateFiled": "2022-12-30",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2023-03-09",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1000",
                                "referenceNumber": "2215009TAB",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-29"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2022-12-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "155VF00015",
                                "referenceNumber": "2215009-DSP-03\/23-VER-03\/24",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_97A4BFDC-E4C1-45A4",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-18"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2017-07-11",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2018-04-11",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05105384",
                                "referenceNumber": "1750883",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-18"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT LA LAKE CHA",
                                "dateFiled": "2017-07-11",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2018-04-11",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "0003",
                                "referenceNumber": "1750883RS",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_4D66CB05-B748-48BA",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2019-05-08",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2020-02-13",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05074186",
                                "referenceNumber": "1930620",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Experian",
                                "courtName": "US BKPT CT NC CHARLOTT",
                                "dateFiled": "2019-05-08",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2020-02-13",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "1048",
                                "referenceNumber": "1930620LTB",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "4",
                                    "description": "Chapter 13 Bankruptcy",
                                    "abbreviation": "Chapter 13 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EQF",
                                        "description": "Equifax",
                                        "abbreviation": "Equifax"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-04-25"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "8",
                                    "description": "Dismissed",
                                    "abbreviation": "Dismissed"
                                },
                                "bureau": "Equifax",
                                "courtName": "Federal",
                                "dateFiled": "2019-05-01",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "VF",
                                    "description": "Federal",
                                    "abbreviation": "Federal"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "805VF85006",
                                "referenceNumber": "1930620-DSP-02\/20",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    },
                    {
                        "PublicRecord": [
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "TUC",
                                        "description": "TransUnion",
                                        "abbreviation": "TransUnion"
                                    },
                                    "Reference": "MFS_6B48A1EC-F246-4A00",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-24"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "TransUnion",
                                "courtName": "U.S. Bankruptcy Court",
                                "dateFiled": "2016-11-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-02-15",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "199",
                                    "symbol": "ZP",
                                    "description": "Public Records",
                                    "abbreviation": "Public Records"
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "05000411",
                                "referenceNumber": "1655278",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            },
                            {
                                "Type": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Chapter 7 Bankruptcy",
                                    "abbreviation": "Chapter 7 Bankruptcy"
                                },
                                "Source": {
                                    "Bureau": {
                                        "rank": "1",
                                        "symbol": "EXP",
                                        "description": "Experian",
                                        "abbreviation": "Experian"
                                    },
                                    "Reference": "",
                                    "BorrowerKey": "",
                                    "InquiryDate": "2024-02-24"
                                },
                                "Status": {
                                    "rank": "199",
                                    "symbol": "1",
                                    "description": "Discharged",
                                    "abbreviation": "Discharged"
                                },
                                "bureau": "Experian",
                                "courtName": "US BK CT-EAST DIST MIC",
                                "dateFiled": "2016-11-10",
                                "Bankruptcy": {
                                    "company": "",
                                    "trustee": "",
                                    "division": "",
                                    "thirdParty": "",
                                    "assetAmount": "0",
                                    "courtNumber": "",
                                    "dateResolved": "2017-02-15",
                                    "exemptAmount": "0",
                                    "liabilityAmount": "0"
                                },
                                "IndustryCode": {
                                    "rank": "100000",
                                    "symbol": "",
                                    "description": "",
                                    "abbreviation": ""
                                },
                                "Classification": {
                                    "rank": "199",
                                    "symbol": "B",
                                    "description": "Bankruptcy",
                                    "abbreviation": "Bankruptcy"
                                },
                                "subscriberCode": "5500",
                                "referenceNumber": "1655278MLO",
                                "AccountDesignator": {
                                    "rank": "199",
                                    "symbol": "I",
                                    "description": "Individual",
                                    "abbreviation": "Individual"
                                }
                            }
                        ]
                    }
                ],
                "Subscriber": [
                    {
                        "name": "FIRST PREMIER BANK",
                        "telephone": "6053573440",
                        "subscriberCode": "00020123",
                        "CreditAddress": {
                            "city": "SIOUX FALLS ",
                            "stateCode": "SD",
                            "unparsedStreet": "3820 N LOUISE AVE ",
                            "postalCode": "57104"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank",
                            "description": "Bank",
                            "symbol": "B",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "CREDIT PLUS",
                        "telephone": "8002583488",
                        "subscriberCode": "00049997",
                        "CreditAddress": {
                            "city": "SALISBURY ",
                            "stateCode": "MD",
                            "unparsedStreet": "31550 WINTERPLACE ",
                            "postalCode": "21804"
                        },
                        "IndustryCode": {
                            "abbreviation": "Miscellaneous",
                            "description": "Miscellaneous",
                            "symbol": "Z",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "CREDIT PLUS\/PANORAMA MOR",
                        "telephone": "7025885430",
                        "subscriberCode": "06335039",
                        "CreditAddress": {
                            "city": "LAS VEGAS ",
                            "stateCode": "NV",
                            "unparsedStreet": "350 S RAMPART BLVD STE 310 ",
                            "postalCode": "89145"
                        },
                        "IndustryCode": {
                            "abbreviation": "Credit Union",
                            "description": "Credit Union",
                            "symbol": "Q",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "FEDLOAN SERVICING",
                        "telephone": "8006992908",
                        "subscriberCode": "02CN2006",
                        "CreditAddress": {
                            "city": "HARRISBURG ",
                            "stateCode": "PA",
                            "unparsedStreet": "POB 60610 ",
                            "postalCode": "17106"
                        },
                        "IndustryCode": {
                            "abbreviation": "Student Loans",
                            "description": "Student Loans",
                            "symbol": "EL",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-07-03",
                            "Reference": "MFS_BE90D669-1FE5-4587"
                        },
                        "inquiryType": "Good",
                        "accountID": "873450347833428"
                    },
                    {
                        "name": "SYNCB\/CARE CREDIT",
                        "telephone": "8009242927",
                        "subscriberCode": "04877646",
                        "CreditAddress": {
                            "city": "DAYTON ",
                            "stateCode": "OH",
                            "unparsedStreet": "PO BOX 8726 ",
                            "postalCode": "45401"
                        },
                        "IndustryCode": {
                            "abbreviation": "Finance\/Personal",
                            "description": "Finance\/Personal",
                            "symbol": "F",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "BANK OF AMERICA",
                        "telephone": "8004212110",
                        "subscriberCode": "06199555",
                        "CreditAddress": {
                            "city": "EL PASO ",
                            "stateCode": "TX",
                            "unparsedStreet": "PO BOX 982238 ",
                            "postalCode": "79998"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank",
                            "description": "Bank",
                            "symbol": "B",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "SUNTRUST DBA LIGHTSTREAM",
                        "telephone": "8007868787",
                        "subscriberCode": "06525583",
                        "CreditAddress": {
                            "city": "SAN DIEGO ",
                            "stateCode": "CA",
                            "unparsedStreet": "600 W BROADWAY SUITE 2000 ",
                            "postalCode": "92101"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank",
                            "description": "Bank",
                            "symbol": "B",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "CREDCO\/BAC 5",
                        "telephone": "8004476192",
                        "subscriberCode": "02964510",
                        "CreditAddress": {
                            "city": "PASADENA ",
                            "stateCode": "CA",
                            "unparsedStreet": "35 N LAKE AVE ",
                            "postalCode": "91101"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank",
                            "description": "Bank",
                            "symbol": "B",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "WELLS FARGO CARD SERVICE",
                        "telephone": "8004624720",
                        "subscriberCode": "0908N664",
                        "CreditAddress": {
                            "city": "DES MOINES ",
                            "stateCode": "IA",
                            "unparsedStreet": "PO BOX 14517 ",
                            "postalCode": "50306"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank Credit Cards",
                            "description": "Bank Credit Cards",
                            "symbol": "BC",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "6646540006081"
                    },
                    {
                        "name": "US DEPT OF EDUCATION\/GLE",
                        "telephone": "8002364300",
                        "subscriberCode": "0368N4TP",
                        "CreditAddress": {
                            "city": "MADISON ",
                            "stateCode": "WI",
                            "unparsedStreet": "2401 INTERNATIONAL LANE POB 7859 ",
                            "postalCode": "53704"
                        },
                        "IndustryCode": {
                            "abbreviation": "Student Loans",
                            "description": "Student Loans",
                            "symbol": "EL",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "87927492345"
                    },
                    {
                        "name": "CHIME - STRIDE BANK",
                        "telephone": "8442446363",
                        "subscriberCode": "02HVP001",
                        "CreditAddress": {
                            "city": "SAN FRANCISCO ",
                            "stateCode": "CA",
                            "unparsedStreet": "PO BOX 417 ",
                            "postalCode": "94104"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank - Mortgage Loans",
                            "description": "Bank - Mortgage Loans",
                            "symbol": "BM",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "983627386482"
                    },
                    {
                        "name": "KIKOFF LENDING LLC",
                        "telephone": "4153614040",
                        "subscriberCode": "02H42001",
                        "CreditAddress": {
                            "city": "SAN FRANCISCO ",
                            "stateCode": "CA",
                            "unparsedStreet": "75 BROADWAY SUITE 202 ",
                            "postalCode": "94111"
                        },
                        "IndustryCode": {
                            "abbreviation": "Miscellaneous Finance",
                            "description": "Miscellaneous Finance",
                            "symbol": "FZ",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "3452FSF4RS"
                    },
                    {
                        "name": "ATLANTIC CAP BKSELFLENDR",
                        "telephone": "8778830999",
                        "subscriberCode": "02GS2001",
                        "CreditAddress": {
                            "city": "AUSTIN ",
                            "stateCode": "TX",
                            "unparsedStreet": "515 CONGRESS AVE SUITE 2200 ",
                            "postalCode": "78701"
                        },
                        "IndustryCode": {
                            "abbreviation": "Full Service Banks",
                            "description": "Full Service Banks",
                            "symbol": "BO",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "736293645"
                    },
                    {
                        "name": "SUNRISE BANK SELF LENDER",
                        "telephone": "6052502620",
                        "subscriberCode": "02FCE002",
                        "CreditAddress": {
                            "city": "AUSTIN ",
                            "stateCode": "TX",
                            "unparsedStreet": "515 CONGRESS AVE, SUITE 2200 C\/O SELF FINANCIAL, INC. ",
                            "postalCode": "78701"
                        },
                        "IndustryCode": {
                            "abbreviation": "Miscellaneous Banks",
                            "description": "Miscellaneous Banks",
                            "symbol": "BZ",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "76483753"
                    },
                    {
                        "name": "BIGHTON RENT",
                        "telephone": "8674598345",
                        "subscriberCode": "09FCR453",
                        "CreditAddress": {
                            "city": "WOODINVILLE ",
                            "stateCode": "WA",
                            "unparsedStreet": "14241 NE WOODINVILLE-DUVALL RD ",
                            "postalCode": "98072"
                        },
                        "IndustryCode": {
                            "abbreviation": "Property Management",
                            "description": "Property Management",
                            "symbol": "RR",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "878271629281"
                    },
                    {
                        "name": "ACCEPTANCENOW",
                        "telephone": "8002752696",
                        "subscriberCode": "02E4W001",
                        "CreditAddress": {
                            "city": "PLANO ",
                            "stateCode": "TX",
                            "unparsedStreet": "5501 HEADQUARTERS DRIVE ",
                            "postalCode": "75024"
                        },
                        "IndustryCode": {
                            "abbreviation": "Miscellaneous Finance",
                            "description": "Miscellaneous Finance",
                            "symbol": "FZ",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "04500034562723"
                    },
                    {
                        "name": "WEBBANK\/FRESHSTART",
                        "telephone": "8667340342",
                        "subscriberCode": "02CSN003",
                        "CreditAddress": {
                            "city": "EDEN PRAIRIE ",
                            "stateCode": "MN",
                            "unparsedStreet": "13300 PIONEER TRAIL ",
                            "postalCode": "55347"
                        },
                        "IndustryCode": {
                            "abbreviation": "Variety Store",
                            "description": "Variety Store",
                            "symbol": "DV",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "657873625183722"
                    },
                    {
                        "name": "SELF FINANCIAL INC \/ LEA",
                        "telephone": "8778830999",
                        "subscriberCode": "02ANW004",
                        "CreditAddress": {
                            "city": "AUSTIN ",
                            "stateCode": "TX",
                            "unparsedStreet": "901 E. 6TH STREET SUITE #400 ",
                            "postalCode": "78702"
                        },
                        "IndustryCode": {
                            "abbreviation": "Sales Financing",
                            "description": "Sales Financing",
                            "symbol": "FF",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "9834598271"
                    },
                    {
                        "name": "BRIDGECREST FORMERLY DRI",
                        "telephone": "8026433864",
                        "subscriberCode": "01SFX002",
                        "CreditAddress": {
                            "city": "PHOENIX ",
                            "stateCode": "AZ",
                            "unparsedStreet": "PO BOX 29018 ",
                            "postalCode": "85038"
                        },
                        "IndustryCode": {
                            "abbreviation": "Auto Financing",
                            "description": "Auto Financing",
                            "symbol": "FA",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Good",
                        "accountID": "726946298734"
                    },
                    {
                        "name": "CAPITAL ONE",
                        "telephone": "8009557070",
                        "subscriberCode": "01DTV001",
                        "CreditAddress": {
                            "city": "SALT LAKE CITY ",
                            "stateCode": "UT",
                            "unparsedStreet": "PO BOX 31293 ",
                            "postalCode": "84131"
                        },
                        "IndustryCode": {
                            "abbreviation": "Bank Credit Cards",
                            "description": "Bank Credit Cards",
                            "symbol": "BC",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "673926492644"
                    },
                    {
                        "name": "USBK COURT NORTHERN GEOR",
                        "telephone": "4042151000",
                        "subscriberCode": "0508601Z",
                        "CreditAddress": {
                            "city": "ATLANTA ",
                            "stateCode": "GA",
                            "unparsedStreet": "75 TED TURNER DRIVE SW # 1340 ",
                            "postalCode": "30303"
                        },
                        "IndustryCode": {
                            "abbreviation": "Public Records",
                            "description": "Public Records",
                            "symbol": "ZP",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": "MFS_421A1643-37F4-44AB"
                        }
                    },
                    {
                        "name": "XACTUS-CP\/PANORAMA MOR",
                        "telephone": "7025885430",
                        "subscriberCode": "1544208",
                        "CreditAddress": {
                            "city": "LAS VEGAS",
                            "stateCode": "NV",
                            "unparsedStreet": "350 S RAMPART BLVD STE 3",
                            "postalCode": "89145"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        }
                    },
                    {
                        "name": "XACTUS-CP\/ASSURANCE FI",
                        "telephone": "2254482680",
                        "subscriberCode": "2919141",
                        "CreditAddress": {
                            "city": "BATON ROUGE",
                            "stateCode": "LA",
                            "unparsedStreet": "9029 JEFFERSON HWY STE 1",
                            "postalCode": "70809"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        }
                    },
                    {
                        "name": "WEBBANK\/FINGERHUT FRES",
                        "telephone": "",
                        "subscriberCode": "2244980",
                        "CreditAddress": {
                            "city": "SAINT CLOUD",
                            "stateCode": "MN",
                            "unparsedStreet": "6250 RIDGEWOOD RD",
                            "postalCode": "56303"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "657873625183722"
                    },
                    {
                        "name": "WEBBANK\/FINGERHUT",
                        "telephone": "",
                        "subscriberCode": "2244970",
                        "CreditAddress": {
                            "city": "SAINT CLOUD",
                            "stateCode": "MN",
                            "unparsedStreet": "6250 RIDGEWOOD RD",
                            "postalCode": "56303"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "785636992105648"
                    },
                    {
                        "name": "US DEPT OF ED\/GLELSI",
                        "telephone": "8002364300",
                        "subscriberCode": "1132610",
                        "CreditAddress": {
                            "city": "MADISON",
                            "stateCode": "WI",
                            "unparsedStreet": "PO BOX 7860",
                            "postalCode": "53707"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "87927492345"
                    },
                    {
                        "name": "US BKPT CT GA ATLANTA",
                        "telephone": "BYMAILONLY",
                        "subscriberCode": "1008000",
                        "CreditAddress": {
                            "city": "ATLANTA",
                            "stateCode": "GA",
                            "unparsedStreet": "75 TED TURNER DR SW STE ",
                            "postalCode": "30303"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        }
                    },
                    {
                        "name": "TOMOCREDIT INC",
                        "telephone": "2028581034",
                        "subscriberCode": "2925066",
                        "CreditAddress": {
                            "city": "SAN FRANCISCO",
                            "stateCode": "CA",
                            "unparsedStreet": "535 MISSION ST FL 14",
                            "postalCode": "94105"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "834729362937639"
                    },
                    {
                        "name": "TELECOM SELF-REPORTED",
                        "telephone": "8558912743",
                        "subscriberCode": "2886930",
                        "CreditAddress": {
                            "city": "ALLEN",
                            "stateCode": "TX",
                            "unparsedStreet": "PO BOX 4500",
                            "postalCode": "75013"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "AADHKSH281630DFT564"
                    },
                    {
                        "name": "SELF\/ATLANTIC CAPITAL",
                        "telephone": "4049556050",
                        "subscriberCode": "2928750",
                        "CreditAddress": {
                            "city": "ATLANTA",
                            "stateCode": "GA",
                            "unparsedStreet": "945 E PACES FERRY RD NE",
                            "postalCode": "30326"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "736293645"
                    },
                    {
                        "name": "SELF FINANCIAL\/LEAD BA",
                        "telephone": "8668459545",
                        "subscriberCode": "2932264",
                        "CreditAddress": {
                            "city": "KANSAS CITY",
                            "stateCode": "MO",
                            "unparsedStreet": "1801 MAIN ST",
                            "postalCode": "64108"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "9834598271"
                    },
                    {
                        "name": "SBNASELFLNDR",
                        "telephone": "6512655600",
                        "subscriberCode": "1188380",
                        "CreditAddress": {
                            "city": "AUSTIN",
                            "stateCode": "TX",
                            "unparsedStreet": "901 E 6TH ST STE 400",
                            "postalCode": "78702"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "76483753"
                    },
                    {
                        "name": "RENT SELF-REPORTED",
                        "telephone": "8558912743",
                        "subscriberCode": "2886940",
                        "CreditAddress": {
                            "city": "ALLEN",
                            "stateCode": "TX",
                            "unparsedStreet": "PO BOX 4500",
                            "postalCode": "75013"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "DDGAUKDYALDOL345LDD"
                    },
                    {
                        "name": "AES\/NCT",
                        "telephone": "8002330557",
                        "subscriberCode": "0494T94D",
                        "CreditAddress": {
                            "city": "HARRISBURG ",
                            "stateCode": "PA",
                            "unparsedStreet": "POB 61047 ",
                            "postalCode": "17106"
                        },
                        "IndustryCode": {
                            "abbreviation": "Student Loans",
                            "description": "Student Loans",
                            "symbol": "EL",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-07-03",
                            "Reference": "MFS_BE90D669-1FE5-4587"
                        },
                        "inquiryType": "Bad",
                        "accountID": "64864379283A00001"
                    },
                    {
                        "name": "KIKOFF LENDING LLC",
                        "telephone": "4153614040",
                        "subscriberCode": "2919349",
                        "CreditAddress": {
                            "city": "SAN FRANCISCO",
                            "stateCode": "CA",
                            "unparsedStreet": "75 BROADWAY STE 226",
                            "postalCode": "94111"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "CSHRLED45A"
                    },
                    {
                        "name": "GREEN DOT BANK",
                        "telephone": "6094540337",
                        "subscriberCode": "1453090",
                        "CreditAddress": {
                            "city": "PASADENA",
                            "stateCode": "CA",
                            "unparsedStreet": "PO BOX 5100",
                            "postalCode": "91117"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "8543271930201630"
                    },
                    {
                        "name": "DISCOVER FINANCIAL SER",
                        "telephone": "BYMAILONLY",
                        "subscriberCode": "1224590",
                        "CreditAddress": {
                            "city": "NEW CASTLE",
                            "stateCode": "DE",
                            "unparsedStreet": "12 READS WAY",
                            "postalCode": "19720"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        }
                    },
                    {
                        "name": "CORELOGIC CREDCO LLC",
                        "telephone": "8006372422",
                        "subscriberCode": "1727750",
                        "CreditAddress": {
                            "city": "SAN DIEGO",
                            "stateCode": "CA",
                            "unparsedStreet": "PO BOX 509124",
                            "postalCode": "92150"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        }
                    },
                    {
                        "name": "CONSUMER PORTFOLIO SVC",
                        "telephone": "BYMAILONLY",
                        "subscriberCode": "0600631",
                        "CreditAddress": {
                            "city": "IRVINE",
                            "stateCode": "CA",
                            "unparsedStreet": "PO BOX 57071",
                            "postalCode": "92619"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "746394720490"
                    },
                    {
                        "name": "CITICARDS CBNA",
                        "telephone": "8009505114",
                        "subscriberCode": "1240000",
                        "CreditAddress": {
                            "city": "SIOUX FALLS",
                            "stateCode": "SD",
                            "unparsedStreet": "PO BOX 6241",
                            "postalCode": "57117"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "7635286294394"
                    },
                    {
                        "name": "CHIME\/STRIDE BANK NA",
                        "telephone": "5802333535",
                        "subscriberCode": "2918527",
                        "CreditAddress": {
                            "city": "ENID",
                            "stateCode": "OK",
                            "unparsedStreet": "324 W BROADWAY AVE",
                            "postalCode": "73701"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "983627386482"
                    },
                    {
                        "name": "CAPITAL ONE",
                        "telephone": "8009557070",
                        "subscriberCode": "1270246",
                        "CreditAddress": {
                            "city": "SALT LAKE CITY",
                            "stateCode": "UT",
                            "unparsedStreet": "PO BOX 31293",
                            "postalCode": "84131"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "673926492644"
                    },
                    {
                        "name": "BRIDGECREST",
                        "telephone": "4808135200",
                        "subscriberCode": "8602240",
                        "CreditAddress": {
                            "city": "MESA",
                            "stateCode": "AZ",
                            "unparsedStreet": "7300 E HAMPTON AVE",
                            "postalCode": "85209"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "726946298734"
                    },
                    {
                        "name": "ALLY FINANCIAL",
                        "telephone": "8002004622",
                        "subscriberCode": "1918788",
                        "CreditAddress": {
                            "city": "DETROIT",
                            "stateCode": "MI",
                            "unparsedStreet": "200 RENAISSANCE CTR # B0",
                            "postalCode": "48243"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "84729472974924"
                    },
                    {
                        "name": "ALDOUS AND ASSOCIATES",
                        "telephone": "8012725281",
                        "subscriberCode": "02ELW001",
                        "CreditAddress": {
                            "city": "HOLLADAY ",
                            "stateCode": "UT",
                            "unparsedStreet": "PO BOX 171374 ",
                            "postalCode": "84117"
                        },
                        "IndustryCode": {
                            "abbreviation": "Other Collection Agencies",
                            "description": "Other Collection Agencies",
                            "symbol": "YC",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-07-04",
                            "Reference": "MFS_88F25AE4-1CFA-40AB"
                        },
                        "inquiryType": "Bad",
                        "accountID": "D85797262M1"
                    },
                    {
                        "name": "PROCOLLECT,INC",
                        "telephone": "2143417788",
                        "subscriberCode": "2980920",
                        "CreditAddress": {
                            "city": "DALLAS",
                            "stateCode": "TX",
                            "unparsedStreet": "12170 ABRAMS RD STE 100",
                            "postalCode": "75243"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-07-04",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "867309003826135005"
                    },
                    {
                        "name": "ARMADA CORPORATION",
                        "telephone": "8009492372",
                        "subscriberCode": "0925M001",
                        "CreditAddress": {
                            "city": "EAST WENATCHEE ",
                            "stateCode": "WA",
                            "unparsedStreet": "93 EASTMONT AVE SUITE #100 ",
                            "postalCode": "98802"
                        },
                        "IndustryCode": {
                            "abbreviation": "Other Collection Agencies",
                            "description": "Other Collection Agencies",
                            "symbol": "YC",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-11-01",
                            "Reference": "MFS_14356E72-A030-494F"
                        },
                        "inquiryType": "Bad",
                        "accountID": "7569044"
                    },
                    {
                        "name": "MEDICAL DATA SYSTEMS INC",
                        "telephone": "8003156050",
                        "subscriberCode": "0204K003",
                        "CreditAddress": {
                            "city": "SEBRING ",
                            "stateCode": "FL",
                            "unparsedStreet": "1532 LAKEVIEW DR ",
                            "postalCode": "33870"
                        },
                        "IndustryCode": {
                            "abbreviation": "Other Collection Agencies",
                            "description": "Other Collection Agencies",
                            "symbol": "YC",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-10-17",
                            "Reference": "MFS_73EEBD7E-1756-49F1"
                        },
                        "inquiryType": "Bad",
                        "accountID": "946662930283"
                    },
                    {
                        "name": "MEDICAL DATA SYSTEMS I",
                        "telephone": "8003156050",
                        "subscriberCode": "1982731",
                        "CreditAddress": {
                            "city": "SEBRING",
                            "stateCode": "FL",
                            "unparsedStreet": "128 W CENTER AVE FL 2",
                            "postalCode": "33870"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-10-17",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "946662930283"
                    },
                    {
                        "name": "FREEDOM MORTGAGE",
                        "telephone": "8663692012",
                        "subscriberCode": "02C82001",
                        "CreditAddress": {
                            "city": "INDIANAPOLIS ",
                            "stateCode": "IN",
                            "unparsedStreet": "P.O. BOX 50485 ",
                            "postalCode": "46250"
                        },
                        "IndustryCode": {
                            "abbreviation": "Mortgage Companies - Finance",
                            "description": "Mortgage Companies - Finance",
                            "symbol": "FM",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-06-02",
                            "Reference": "MFS_0794EC06-F586-46AF"
                        },
                        "inquiryType": "Bad",
                        "accountID": "8376492642"
                    },
                    {
                        "name": "PACIFIC UNION FINANCIAL",
                        "telephone": "8884802432",
                        "subscriberCode": "02EEV001",
                        "CreditAddress": {
                            "city": "HOUSTON ",
                            "stateCode": "TX",
                            "unparsedStreet": "350 HIGHLAND ",
                            "postalCode": "77067"
                        },
                        "IndustryCode": {
                            "abbreviation": "Mortgage Companies - Credit Union",
                            "description": "Mortgage Companies - Credit Union",
                            "symbol": "QM",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-06-02",
                            "Reference": "MFS_0794EC06-F586-46AF"
                        },
                        "inquiryType": "Good",
                        "accountID": "8739287291732"
                    },
                    {
                        "name": "SEZZLE INC",
                        "telephone": "8885401867",
                        "subscriberCode": "02HF4001",
                        "CreditAddress": {
                            "city": "MINNEAPOLIS ",
                            "stateCode": "MN",
                            "unparsedStreet": "251 1ST AVE ",
                            "postalCode": "55401"
                        },
                        "IndustryCode": {
                            "abbreviation": "Miscellaneous Finance",
                            "description": "Miscellaneous Finance",
                            "symbol": "FZ",
                            "rank": "199"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "TransUnion",
                                "description": "TransUnion",
                                "symbol": "TUC",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-08-04",
                            "Reference": "MFS_0A597468-499E-4314"
                        },
                        "inquiryType": "Good",
                        "accountID": "972819381739123"
                    },
                    {
                        "name": "CONVERGENT OUTSOURCING",
                        "telephone": "8888712279",
                        "subscriberCode": "0980304",
                        "CreditAddress": {
                            "city": "RENTON",
                            "stateCode": "WA",
                            "unparsedStreet": "800 SW 39TH ST",
                            "postalCode": "98057"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-07-04",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "89826352"
                    },
                    {
                        "name": "ACCEPTANCE NOW",
                        "telephone": "8886722411",
                        "subscriberCode": "9306706",
                        "CreditAddress": {
                            "city": "PLANO",
                            "stateCode": "TX",
                            "unparsedStreet": "5501 HEADQUARTERS DR",
                            "postalCode": "75024"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Good",
                        "accountID": "R0601004500034562723"
                    },
                    {
                        "name": "A+ LOANS",
                        "telephone": "6787209006",
                        "subscriberCode": "1689430",
                        "CreditAddress": {
                            "city": "ATLANTA",
                            "stateCode": "GA",
                            "unparsedStreet": "1352 LAKEWOOD AVE SE",
                            "postalCode": "30315"
                        },
                        "IndustryCode": {
                            "abbreviation": "",
                            "description": "",
                            "symbol": "",
                            "rank": "100000"
                        },
                        "Source": {
                            "BorrowerKey": "",
                            "Bureau": {
                                "abbreviation": "Experian",
                                "description": "Experian",
                                "symbol": "EXP",
                                "rank": "1"
                            },
                            "InquiryDate": "2022-09-23",
                            "Reference": ""
                        },
                        "inquiryType": "Bad",
                        "accountID": "98800000003936927"
                    }
                ],
                "Summary": {
                    "TradelineSummary": {
                        "Experian": {
                            "TotalAccounts": "21",
                            "OpenAccounts": "9",
                            "CloseAccounts": "12",
                            "DelinquentAccounts": "2",
                            "DerogatoryAccounts": "8",
                            "TotalBalances": "128150",
                            "TotalMonthlyPayments": "2025"
                        },
                        "Equifax": {
                            "TotalAccounts": "13",
                            "OpenAccounts": "8",
                            "CloseAccounts": "5",
                            "DelinquentAccounts": "1",
                            "DerogatoryAccounts": "0",
                            "TotalBalances": "120115",
                            "TotalMonthlyPayments": "1175"
                        },
                        "TransUnion": {
                            "TotalAccounts": "12",
                            "OpenAccounts": "4",
                            "CloseAccounts": "8",
                            "DelinquentAccounts": "0",
                            "DerogatoryAccounts": "2",
                            "TotalBalances": "56755",
                            "TotalMonthlyPayments": "1173"
                        },
                        "Merge": {
                            "TotalAccounts": "24",
                            "OpenAccounts": "4",
                            "CloseAccounts": "8",
                            "DelinquentAccounts": "2",
                            "DerogatoryAccounts": "9",
                            "TotalBalances": "128210",
                            "TotalMonthlyPayments": "2035"
                        }
                    },
                    "InquirySummary": {
                        "Experian": {
                            "NumberInLast2Years": "4"
                        },
                        "Equifax": {
                            "NumberInLast2Years": "5"
                        },
                        "TransUnion": {
                            "NumberInLast2Years": "8"
                        },
                        "Merge": {
                            "NumberInLast2Years": "17"
                        }
                    },
                    "PublicRecordSummary": {
                        "Experian": {
                            "NumberOfRecords": "3"
                        },
                        "Equifax": {
                            "NumberOfRecords": "1"
                        },
                        "TransUnion": {
                            "NumberOfRecords": "2"
                        },
                        "Merge": {
                            "NumberOfRecords": "3"
                        }
                    }
                },
                "ReportDaysOld": "642"
            }
          }
        },
        {
          "id": "3-2",
          "title": "Get member epic pro report html",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/3B/epic/report.html",
          "description": "Get member epic pro report html",
          "queryParams": [
            { "name": "username", "required": true, "description": "Email address of the member." },
            { "name": "password", "required": true, "description": "Password of the member to login of member site." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
            // { "name": "secretKey", "required": true, "description": "The secret key for additional authorization." },
          ],
          "request": {
            "username": "example@example.com",
            "password": "123456"
          },
          "response": {
            "success": true,
            "data" : {
                "html": "<html>\r\n<head>\r\n<meta content=\"width=device-width, initial-scale=1.0\" name=\"viewport\" />\r\n\r\n<!--<link href=\"http://localhost:8000/css/jquery.qtip.min.css\" rel=\"stylesheet\">-->\r\n<!--<link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\" integrity=\"sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u\" crossorigin=\"anonymous\">-->\r\n<link rel=\"stylesheet\""
            }
          }
        }
      ]
    },
    {
      "id": "4",
      "title": "Enrollement Steps",
      // "method": "POST",
      // "url": "/v1/signup/create",
      "description": "Enrollement steps to member enrollement",
      "subApis": [
        {
          "id": "4-1",
          "title": "Start Enrollment",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/enroll/start",
          "description": "This endpoint is used to start the enrollment process by sending the required user information.",
          "queryParams": [
            { "name": "sponsorCode", "required": false, "description": "Sponsor code for the enrollment." },
            { "name": "aid", "required": true, "description": "User's AID." },
            { "name": "firstName", "required": true, "description": "User's first name." },
            { "name": "lastName", "required": true, "description": "User's last name." },
            { "name": "email", "required": true, "description": "User's email address." },
            { "name": "password", "required": true, "description": "User's password." },
            { "name": "mobile", "required": true, "description": "User's mobile number." },
            { "name": "streetAddress", "required": true, "description": "User's street address." },
            { "name": "zip", "required": true, "description": "User's zip code." },
            { "name": "city", "required": true, "description": "User's city." },
            { "name": "state", "required": true, "description": "User's state." },
            { "name": "ssn", "required": true, "description": "User's social security number." },
            { "name": "dob", "required": true, "description": "User's date of birth." },
            { "name": "pid", "required": true, "description": "User's PID." },
            { "name": "blackboxCode", "required": true, "description": "Blackbox code retrieved using the provided javascript files." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." }
          ],
          "request": {
            "sponsorCode": "",
            "aid":"seo",
            "firstName":"test",
            "lastName":"test",
            "email":"test@yopmail.com",
            "password":"12345",
            "mobile":"1234567890",
            "streetAddress":"123 Main",
            "zip":"12345",
            "city":"Bothell",
            "state":"CA",
            "ssn":"555555555",
            "dob":"07/02/1985",
            "pid":"00017",
            "blackboxCode":"uieicnnnnnnn....."  
          },
          "response": {
            "success": true,
            "data": {
              "step": "Start Enroll",
              "next-step": "ID Verification",
              "message": "Member has been created succesfully",
              "tracking_token": "1ec6d862-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
              "customer_token": "9d92c117-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
              "id_questions": {
                "referenceNumber": "12345678",
                "question1": {
                  "name": "CITIES_ASSOC_WITH",
                  "displayName": "Which of these cities are you associated with?",
                  "type": "IDMA",
                  "questionId": 48991498,
                  "choiceList": {
                    "choice": [
                      {
                        "key": "3079312488",
                        "display": "King’s Landing"
                      },
                      {
                        "key": "3079312490",
                        "display": "Hogsmeade"
                      },
                      {
                        "key": "3079312492",
                        "display": "Whoville"
                      },
                      {
                        "key": "3079312494",
                        "display": "Bedrock"
                      },
                      {
                        "key": "3079312496",
                        "display": "None of the above"
                      }
                    ]
                  }
                },
                "question2": {
                  "name": "NOT_CREDIT_BUREAU",
                  "displayName": "Which company is NOT a credit bureau?",
                  "type": "IDMA",
                  "questionId": 48991500,
                  "choiceList": {
                    "choice": [
                      {
                        "key": "3079312498",
                        "display": "Experian"
                      },
                      {
                        "key": "3079312500",
                        "display": "Monsters Inc"
                      },
                      {
                        "key": "3079312502",
                        "display": "Equifax"
                      },
                      {
                        "key": "3079312504",
                        "display": "TransUnion"
                      },
                      {
                        "key": "3079312506",
                        "display": "None of the above"
                      }
                    ]
                  }
                },
                "question3": {
                  "name": "INVENTED_INTERNET",
                  "displayName": "Who invented the internet?",
                  "type": "IDMA",
                  "questionId": 48991502,
                  "choiceList": {
                    "choice": [
                      {
                        "key": "3079312508",
                        "display": "J. C. R. Licklider"
                      },
                      {
                        "key": "3079312510",
                        "display": "George Clooney"
                      },
                      {
                        "key": "3079312512",
                        "display": "Al Gore"
                      },
                      {
                        "key": "3079312514",
                        "display": "Howard Stark"
                      },
                      {
                        "key": "3079312516",
                        "display": "None of the above"
                      }
                    ]
                  }
                },
                "response": "QUESTIONS",
              }
            }
          }
        },
        {
          "id": "4-2",
          "title": "ID Verification",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/enroll/idverification",
          "description": "This endpoint allows the user to enroll in ID verification by providing the necessary information and tokens.",
          "queryParams": [
            { "name": "trackingToken", "required": true, "description": "A token used for tracking" },
            { "name": "customerToken", "required": true, "description": "Token identifying the customer." },
            { "name": "referenceNumber", "required": true, "description": "Reference number for the enrollment." },
            { "name": "answers", "required": false, "description": "(if userInput provided): Object containing answers to verification questions." },
            { "name": "userInput", "required": false, "description": "(if answers provided) User input for verification." },
            { "name": "blackboxCode", "required": true, "description": "Code for blackbox verification." },
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
          ],
          "request": {
            "trackingToken":"1ec6d862-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
            "customerToken":"9d92c117-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
            "referenceNumber":"12345678",
            "answers":{
                "answer1":"3079312488",
                "answer2":"3079312498",
                "answer3":"3079312508"
            },
            "userInput":"",
            "blackboxCode":"uieicnnnnnnn....."
          },
          "response": {
            "success": true,
            "data": {
              "currentstep": 2,
              "nextstep": 3,
              "idQuestions": {
                "referenceNumber": "123456789",
                "question1": {
                  "name": "IDM_Choice",
                  "displayName": "Please select your preferred method of Authentication  (standard text message and voice rates apply)*",
                  "type": "IDMA",
                  "questionId": 86001532,
                  "choiceList": {
                    "choice": [
                      {
                        "key": "3255857942",
                        "display": "Deliver passcode via Text Message"
                      },
                      {
                        "key": "3255857944",
                        "display": "Deliver passcode via Voice Call"
                      },
                      {
                        "key": "3255857946",
                        "display": "Security Questions"
                      }
                    ]
                  }
                },
                "response": "QUESTIONS"
              },
              "trackingToken": "a8cef07d-b25b-4667-8e9a-...",
              "customerToken": "afb95867-6bc2-40c8-a0c4-..."
            }
          }
        },
        {
          "id": "4-3",
          "title": "Update Credit Card",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/enroll/updatecard",
          "description": "The Update Card Enrollment endpoint is used to update the credit card details for a customer's enrollment.",
          "queryParams": [
            { "name": "trackingToken", "required": true, "description": "A token used for tracking" },
            { "name": "customerToken", "required": true, "description": "Token identifying the customer." },
            { "name": "creditCard", "required": true, "description": "The new credit card number." },
            { "name": "name", "required": true, "description": "The name on the credit card." },
            { "name": "cvv", "required": true, "description": "The CVV number of the new credit card." },
            { "name": "cardMonth", "required": true, "description": "The expiration month of the new credit card." },
            { "name": "cardYear", "required": true, "description": "The expiration year of the new credit card." },
            { "name": "isConfirmedTerms", "required": true, "description": "Indicates whether the terms and conditions are confirmed." },
            { "name": "billAddress", "required": true, "description": "The billing address for the credit card." },
            { "name": "billzip", "required": true, "description": "The billing ZIP code." },
            { "name": "billcity", "required": true, "description": "The billing city." },
            { "name": "billstate", "required": true, "description": "The billing state." }
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
          ],
          "request": {
            "trackingToken" : "1ec6d862-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
            "customerToken" : "9d92c117-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
            "creditCard":"4599542298931650",
            "name":"Donald",
            "cvv":"123",
            "cardMonth":"07",
            "cardYear":"2025",
            "isConfirmedTerms":"true",
            "billAddress":"6939 W GEORGE ST",
            "billzip":"98011",
            "billcity":"Bothell",
            "billstate":"WA"
          },
          "response": {
            "success": true,
            "data" : {
              "step": "Update Credit Card",
              "next-step": "Update Security Questions",
              "message": "Card Details updated",
              "tracking_token": "1ec6d862-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
              "customer_token": "9d92c117-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
              "password": "0000000001krEvvkGZrBjPMRTNOzZktIMWcn12yncltV6J9ziwBXs=",
              "offers": {
                "offer_days": 7,
                "offer_price": "$29.95",
                "offer_has_fee": "$1.00",
                "hide_affiliates": 1,
                "free_3": "Yes"
              },
              "security_questions": [
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 1,
                  "question": "What was your high school mascot?"
                },
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 2,
                  "question": "What was your first grade teacher's last name?"
                },
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 3,
                  "question": "What was the make and model of your first car?"
                },
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 4,
                  "question": "What is your mother's middle name?"
                },
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 5,
                  "question": "What is your father's middle name?"
                },
                {
                  "updateDate": "2012-06-22T15:29:38.000+00:00",
                  "securityQuestionId": 6,
                  "question": "What city were you born in?"
                },
                {
                  "updateDate": "2012-06-22T15:29:39.000+00:00",
                  "securityQuestionId": 7,
                  "question": "What is your grandmother's first name (on your mother's side)?"
                },
                {
                  "updateDate": "2012-06-22T15:29:39.000+00:00",
                  "securityQuestionId": 8,
                  "question": "What is your grandfather's first name (on your father's side)?"
                }
              ]
            }
          }
        },
        {
          "id": "4-4",
          "title": "Update Security Questions",
          "method": "POST",
          "url": `${config.API_URL}` + "/api/auth/enroll/securityquestions",
          "description": "This API endpoint allows the user to enroll security questions by providing the email, password, security question ID, and security question answer.",
          "queryParams": [
            { "name": "email", "required": true, "description": "The email of the user." },
            { "name": "password", "required": true, "description": "The password of the user." },
            { "name": "securityQuestionId", "required": true, "description": "The ID of the security question." },
            { "name": "securityQuestionAnswer", "required": true, "description": "The answer to the security question." }
          ],
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
          ],
          "request": {
            "email":"example@example.com",
            "password":"0000000001krEvvkGZrBjPMRTNOzZktIMWcn12yncltV6J9ziwBXs=",
            "securityQuestionId":"2",
            "securityQuestionAnswer":"ABC"
          },
          "response": {
           "success": true,
            "data": {
              "step": "Update Security Questions",
              "message": "Enrollment process has been completed successfully",
              "username": "usertest4@yopmail.com",
              "password": "mfsn12345"
            }
          }
        }
      ]
    },
    {
    "id": "5",
        "title": "Logout",
        "method": "POST",
        "url": `${config.API_URL}` + "/api/auth/logout",
        "description": "The logout API ensures the access token is invalidated.",
          "headers": [
            { "name": "Authorization", "required": true, "description": "Bearer token for authentication." },
          ],
        "response": {
            "success": true,
            "data": {
                "message": "Successfully logged out"
            }
        }
    }
  ];
  const [selectedApi, setSelectedApi] = useState(apiData[0] || null);
  const createUser = () => {
    var check = checkAdminoRAffiliate();
    if (check === true) {
      var userRole = JSON.parse(localStorage.getItem('user')).roles_id;
      var roleId = userRole == 3 ? 11 : 14 ;
      navigate(`/createuser?roleId=${roleId}`);
    }
  }

  const changeApiAccess = async() => {
    var check = checkAdminoRAffiliate();
    if (check === true) {
        setIsLoading(true);
        const apiUrl = '/change-api-access-of-users';
        const args = {
            usersApiAccess: JSON.stringify(usersApiAccess)
        }
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        console.log("res:"+res);
        if (res) {
            if (res.success == true) {
                setIsLoading(false);
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                });
                getApiUser();
            }
            else {
                setIsLoading(false)
                swal({
                    title: "Failed",
                    text: res.message,
                    icon: "error",
                    button: "Ok",
                })
            }

        } 
    }
  }

  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem('user'));
    if (loginUser.roles_id === 3 || loginUser.roles_id === 9) {
        getApiUser();
    } else {
        navigate('/login');
    }

  }, [])

  const getApiUser = async () => {

    setIsLoading(true)
    const apiUrl = '/fetch-api-user';
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
      if(res.success == true){
        setData(res.data);
        const access = res.data.map(user => ({
            userId: user.id,
            apiAccess: user.api_access == 1
        }));
        console.log("access:" +JSON.stringify(access));
        setUsersApiAccess(access);
      }
    }
    setIsLoading(false);
  }

  const handleChangeAccess = (userId) => {
        const access = usersApiAccess;
        const updatedAccess = usersApiAccess.map(user =>
            user.userId === userId ? { ...user, apiAccess: !user.apiAccess } : user
        );
        setUsersApiAccess(updatedAccess);
        console.log("access:" + JSON.stringify(updatedAccess));
  }

  const handleClose = () => {
    setOpen(false);
  };

  const editUser = (id,companyId) => {
    var check = checkAdminoRAffiliate();
    if(check === true) {
      const loginUser = JSON.parse(localStorage.getItem('user'));
        navigate('/edituser/' + id + '?source=automation');
    }
  }

  const changeUserStatus = async (id, role, operation,companyId) => {
    
    var check = checkAdminoRAffiliate();
    if(check === true) {
      if (operation == "disable") {
        setOperation("disabled");
      } else {
        setOperation("active");
      }
      setDisableUserId(id);
      
      setOpen(true);
    }
  }

  const csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    fileName: 'Software API Users',
    headers: ['Name', 'Role','Email', 'Phone No.'],
  };
  const csvExporter = new ExportToCsv(csvOptions);
  const handleExportRows  = (rows) => {
    
    if(localStorage.getItem("admin") != null) {
      navigate('/login');
      return false;
    }
    const exportedData = rows.map((row) => {
      return {
        name: row.original.name || "N/A",
        name: row.original.role ? row.original.role.role_name : "N/A",
        email: row.original.email || "N/A",
        phone: formatPhoneNumber(row.original.phone_no) || "N/A",
      };
    });
    
      // Convert data to CSV format
      const csvContent = convertToCSV(exportedData);
  
      // Create a Blob object from the CSV data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  
      // Create a download link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const loginUser = JSON.parse(localStorage.getItem('user'));
      
      link.download = loginUser.roles_id == 9 ? (csvOptions.fileName + '.csv') : "API Users.csv";
  
      // Append the link to the document body
      document.body.appendChild(link);
  
      // Programmatically click the link to trigger the file download
      link.click();
  
      // Clean up the temporary URL and remove the link from the document
      URL.revokeObjectURL(link.href);
      link.remove();
    };
  
    const convertToCSV = (data) => {
      const headers = csvOptions.headers.join(',') + '\n';
  
      const rows = data.map((row) => {
        return Object.values(row).map((value) => {
          // Handle any necessary formatting or escaping of values
          // For simplicity, we assume all values are already properly formatted
  
          // Wrap the value with double quotes if it contains a comma
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
  
          return value;
        }).join(',');
      }).join('\n');
  
      return headers + rows;
    };

  const enableDisableUser = async () => {
    handleClose();
    var check = checkAdminoRAffiliate();
    if(check === true){
      const apiUrl = '/user-softdelete';
      const args = {
        id: disableUserId,
        requestType: operation,
      }
  
      const res = await dispatch(postData({ apiUrl, args })).unwrap();
      if (res) {
        if (res.success === true) {
          swal({
            title: "Success",
            text: res.message,
            icon: "success",
            button: "Ok",
          })
        } else {
          swal({
            title: "Failed",
            text: res.message,
            icon: "error",
            button: "Ok",
          })
        }
      }
      getApiUser();
    }
   
  }

  const columns = useMemo(
    //column definitions...
    () => [
      {
        accessorFn: (data) => `${data.name ? data.name : 'N/A'}`,
        id: 'Name',
        header: 'Name',
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Typography>{row.original.name ? row.original.name : 'N/A'}</Typography>
        ),
      },
      {
        accessorFn: (data) => `${data.name ? data.name : 'N/A'}`,
        id: 'role',
        header: 'Role',
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Typography>{row.original.role ? row.original.role.role_name : 'N/A'}</Typography>
        ),
      },
      {
        accessorFn: (data) => `${data.email ? data.email : ''}`,
        id: 'Email',
        header: 'Email',
        size: 50,
        Cell: ({ renderedCellValue, row }) =>
          <Box className="datatable">
            <>{row.original.email ? row.original.email : 'N/A'}</>
          </Box>,
      },
      {
        accessorFn: (data) => `${data.phone_no ? data.phone_no ? data.phone_no : '' : ''}`,
        id: 'Phone No',
        header: 'Phone No',
        size: 50,
        Cell: ({ renderedCellValue, row }) => (<>{row.original.phone_no ? formatPhoneNumber(row.original.phone_no) : 'N/A' }</>),
      },
      {
        accessorFn: (row) => `${row.id}`,
        id: 'actions',
        header: 'Actions',
        size: 150,
        Cell: ({ renderedCellValue, row }) => (
          <Box>
            {
             
                row.original.is_active ?
                  <>
                  <Stack direction="row" alignItems="center">
                  { user.id != row.original.id ? 
                    <Tooltip title="Edit User" arrow><EditOutlinedIcon onClick={() => {editUser(renderedCellValue,row.original.company_master_id)}} /></Tooltip>
                    : '' }
                    {/* <Tooltip title={usersApiAccess.some(user => user.userId === row.original.id && user.apiAccess) ? "Remove Api Access" : "Add Api Access"} arrow> 
                        <Checkbox
                                    checked={usersApiAccess.some(user => user.userId === row.original.id && user.apiAccess)}
                                    onChange={() => handleChangeAccess(row.original.id)}
                                  /></Tooltip> */}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                      <Tooltip title="Remove Api Access" ><Typography variant="subtitle1" gutterBottom>
                        <b>Off</b>
                      </Typography></Tooltip>
                      <Switch
                        checked={Boolean(row.original.api_access)}
                        onChange={() =>
                          handleChangeSwitch(row.original.id, row.original.api_access ? 0 : 1)
                        }
                        inputProps={{ 'aria-label': 'Switch API Access' }}
                      />
                      <Tooltip title="Add Api Access"><Typography variant="subtitle1" gutterBottom>
                        <b>On</b>
                      </Typography></Tooltip>
                    
                    </Stack>
                  </> 
                : ''
            }
          </Box>
        ),

      },
    ]
  );
  return (
    <>
       {isLoading ? <Loader /> : <></>}
       <div>
       {user.roles_id == 3 || user.roles_id == 9 ? ( 
        <>
       {/* <Card variant="outlined" size="lg">
        <CardOverflow 
          sx={{
            bgcolor: '#F6FAFF',
            borderColor: '#F6FAFF',
            padding: '1%',
          }}
        >
        </CardOverflow>
        <CardContent>
          {generated === false && data1.length === 0 ? (
            <>
              <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }}>
                <Typography sx={{ textAlign: "center" }}><b>MyFreeScoreNow APIs help you to automate your platform to fetch relevant information and data about your clients. </b></Typography>
              </Grid>
              <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} sx={{ justifyContent: "center" }}>
                <Typography sx={{ textAlign: "center" }}><b>Using MyFreeScoreNow APIs requires a unique client key to establish your identity. This key can be generated here. Note that the key is displayed only once for security purposes and you must download and store the same at a safe location.</b></Typography>
              </Grid>
              <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} sx={{ justifyContent: "center" }}>
                <Typography sx={{ textAlign: "center" }}><b>The API documentation provides details about the MyFreeScoreNow APIs.</b></Typography>
              </Grid>
              <Grid container item lg={12} md={12} sm={12} xs={12} mb={3} mt={2} sx={{ justifyContent: "center" }}>
                <Button variant="contained" color="success" sx={{ minWidth: 250, textAlign: "center" }} onClick={generatePrivateKey}>
                  Generate Client Key
                </Button>
              </Grid>
            </>
          ) : (
            ''
          )}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Client Key</StyledTableCell>
                <StyledTableCell>Created At</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data1 && data1.length > 0 && data1.map((row) => (
                <TableRow key={row.id}>
                  <StyledTableCell>{row.key_id}</StyledTableCell>
                  <StyledTableCell>{Moment(row.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY hh:mm') + " Hrs" || "N/A"}</StyledTableCell>
                  <StyledTableCell>{row.status === 1 ? "Active" : "Deactivated"}</StyledTableCell>
                  <StyledTableCell>
                    <Tooltip title="Delete Client Key" arrow>
                      <DeleteIcon color={'error'} sx={{ marginRight: '15px' }} onClick={() => { handleDeleteKey(`${row.id}`) }} />
                    </Tooltip>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {generated === false ? (
          <Grid container item lg={12} md={12} xs={12} sm={12} mt={2} sx={{ justifyContent: "center" }}>
            <Typography sx={{ textAlign: "center" }}><b>* You can generate only one client key.</b></Typography>
          </Grid>
        ) : ''}
          </CardContent>
        </Card> */}

        {/* First Popup Start */}
        <React.Fragment>
          <BootstrapDialog onClick={handleClickClose4} aria-labelledby="customized-dialog-title" open={open4} fullWidth={fullWidth}>
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              <Grid container item lg={12} md={12} sm={12} xs={12}>
                <Typography level="h4">Client Key {company ? 'for ' + company.company_name : "N/A"}</Typography>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container item lg={12} md={12} sm={12} xs={12}>
                {isKeyGenerated === true && (
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" onClose={() => setIsKeyGenerated(false)}>
                      Client Key & Client Secret has been generated successfully.
                    </Alert>
                  </Stack>
                )}
              </Grid>
              <Grid>
                {alertVisible === true && (
                  <Stack sx={{ width: '100%' }} spacing={2} mt={1}>
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" onClose={() => setAlertVisible(false)}>
                      Downloaded successfully.
                    </Alert>
                  </Stack>
                )}
              </Grid>
              <Grid>
                {emailSuccess && (
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                      Email sent successfully.
                    </Alert>
                  </Stack>
                )}
              </Grid>
              <Grid item container xs={12} mt={2}>
                <TextField
                  variant="outlined"
                  name="keyId"
                  fullWidth
                  label="Client Key"
                  margin="dense"
                  size="large"
                  value={secretKeydata.seceretId}
                  disabled
                  InputProps={{
                    readOnly: true,
                    inputProps: {
                      style: {
                        userSelect: 'none', // Disable text selection
                      },
                      onCopy: (event) => {
                        event.preventDefault(); // Prevent copying
                      },
                    },
                  }}
                />
              </Grid>
              <Grid container item md={12} lg={12} xs={12} sm={12}>
                <TextField
                  variant="outlined"
                  name="keySecret"
                  fullWidth
                  label="Client Secret"
                  margin="dense"
                  size="large"
                  value={secretKeydata.seceretKey}
                  disabled
                  InputProps={{
                    readOnly: true,
                    inputProps: {
                      style: {
                        userSelect: 'none', // Disable text selection
                      },
                      onCopy: (event) => {
                        event.preventDefault(); // Prevent copying
                      },
                    },
                  }}
                />
              </Grid>
              <Grid container item md={12} lg={12} xs={12} sm={12} mb={2}>
                <Typography><b>* This Client Secret can only be downloaded once to keep your account secure.</b></Typography>
              </Grid>
              <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ textAlign: "center" }}>
                <a onClick={handleExportRows1} style={{ color: "rgb(48, 151, 209)", cursor: "pointer", fontSize: "1.2rem" }}>
                  Download Client Key Details
                </a>
                <Typography><b>OR</b></Typography>
                {emailSuccess ? (
                  <a style={{ color: "grey", cursor: "pointer", fontSize: "1.2rem" }}>Email Sent</a>
                ) : (
                  <a onClick={handleEmail} style={{ color: "rgb(48, 151, 209)", cursor: "pointer", fontSize: "1.2rem" }}>
                    Email
                  </a>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ width: "100%", justifyContent: "center" }}>
                <Button variant="contained" onClick={() => handleClickOpen1()} sx={{ minWidth: 100 }}>
                  OK
                </Button>
              </Grid>
            </DialogActions>
          </BootstrapDialog>
        </React.Fragment>
        {/* {user.roles_id == 3 ?
        <>
            <Card  variant="outlined" sx={{boxShadow: "0 0px 4px 0 rgba(0, 0, 0, 0.2), 0 0px 6px 0 rgba(0, 0, 0, 0.19)"}}>
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{display:"flex", justifyContent: "space-between" }}
                    
                  >
                    <Grid item lg={8} md={8} sm={8} xs={12}>
                      <Typography level="h5" color="primary">
                        Access to API Softwares
                      </Typography>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12} style={{ textAlign: "right" }}>
                          <Button
                          variant="contained"
                          color="primary"
                          sx={{ marginTop: 2 ,minWidth:250}}
                          onClick={handleOpenPopup}
                        >
                          Open Software Selection
                        </Button>
                      </Grid>
                        <Grid>
                          {aselectedSoftware.join(", ")}
                        </Grid>
                      </Grid>
                      

                    <Modal open={isPopupOpen} onClose={handleClosePopup}>
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "20px",
                        maxWidth: "400px",
                        margin: "50px auto",
                        borderRadius: "8px",
                      }}
                    >
                      {Array.isArray(software) ? (
                        <>
                          <Typography variant="h6" gutterBottom>
                            Select Software
                          </Typography>
                          {popupSelections.length > 0 && (
                            <div style={{ marginBottom: "10px" }}>
                            </div>
                          )}

                          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {software.map((item, index) => (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    checked={popupSelections1.includes(item.link_name)}
                                    onChange={() => handlePopupSelectionChange(item.link_name)}
                                  />
                                }
                                label={item.software_name}
                              />
                            ))}
                          </div>

                          <div style={{ marginTop: "20px", textAlign: "right" }}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleClosePopup}
                              sx={{ marginRight: 1 }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleSaveSelections}
                            >
                              Save
                            </Button>
                          </div>
                        </>
                      ) : (
                        <Typography>No software data available</Typography>
                      )}
                    </div>
                    </Modal>
                </Card>
        </>
        : ''
        } */}
       
        </>) : ( '' ) }
        </div>
        <Card  variant="outlined" sx={{boxShadow: "0 0px 4px 0 rgba(0, 0, 0, 0.2), 0 0px 6px 0 rgba(0, 0, 0, 0.19)",marginTop:"2%"}}>
                <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ display: "flex" , justifyContent:"space-between"}}>
                  <Grid item lg={6} md={6} xs={6} sm={6} >
                  <Typography level="h5" color="primary"> {user.roles_id == 9 ?  "SOFTWARE" : "" } API Access To Users</Typography>
                    </Grid>
                    <Grid item lg={6} md={6} xs={6} sm={6} mt={2} sx={{  textAlign: "right" }}>
                      <Button color="primary" variant="contained" onClick={createUser} sx={{marginBottom:1,minWidth:250 }}>
                      Create User
                    </Button>
                    </Grid>
                </Grid>
              <MaterialReactTable
                columns={columns}
                data={data}
                globalFilterFn="customSearchFilterFn"//custom search function
                enableColumnFilterModes
                enableRowSelection={false}
                getRowId={(data) => data.id}
                // onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ columnVisibility }} //pass our managed row selection state to the table to use
                initialState={{ showColumnFilters: false, density: 'compact' }}
                onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                enableColumnFilters={config.DatatableColumnFilter}
                positionToolbarAlertBanner="bottom"
                enableDensityToggle={false}
                muiTableHeadCellProps={{
                  //simple styling with the `sx` prop, works just like a style prop in this example
                  sx: {
                    backgroundColor: "#F6FAFF",
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box
                    sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                  >
                    <Button
                      sx={{ bgColor: "#2A68B3" }}
                      disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                      onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                      className='export'
                    >
                      CSV
                    </Button>
                  </Box>
                )}
              /> 
            
            </Card>
          <div style={{ display: "flex", fontFamily: "Arial, sans-serif", marginTop: "20px" }}>
            {/* Sidebar */}
            <div
              style={{
                width: "25%",
                borderRight: "1px solid #ddd",
                padding: "20px",
                background: "#F6FAFF",
              }}
            >
              <h3>API Reference</h3>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {apiData
                    .filter((item) => {
                        if (loginUser1.roles_id === 9) {
                            return ![4].includes(parseInt(item.id)); 
                        }
                        return true;
                    })
                    .map((item) => (
                  <li key={item.id} style={{ marginBottom: "10px" }}>
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        padding: "10px 0",
                        color: selectedApi?.id === item.id ? "#007bff" : "#000",
                        cursor: "pointer",
                        fontWeight: selectedApi?.id === item.id ? "bold" : "normal",
                        textAlign: "left",
                        width: "100%",
                      }}
                      onClick={() => setSelectedApi(item)}
                    >
                      {item.title}
                    </button>
                    {item.subApis && (
                      <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                        {item.subApis.map((subItem) => (
                          <li key={subItem.id}>
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                padding: "5px 0",
                                color: selectedApi?.id === subItem.id ? "#007bff" : "#000",
                                cursor: "pointer",
                                textAlign: "left",
                                fontSize: "14px",
                              }}
                              onClick={() => setSelectedApi(subItem)}
                            >
                              {subItem.title}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* API Details */}
            <div style={{ width: "75%", padding: "20px", marginTop : "24px" }}>
              {selectedApi ? (
                <>
                  <h2>{selectedApi.title}</h2>
                  <p>
                    <strong>{selectedApi.method}</strong> <code>{selectedApi.url}</code>
                  </p>
                  <p>{selectedApi.description}</p>

                  {selectedApi.queryParams && (
                    <>
                      <h4>Query Parameters</h4>
                      <ul>
                        {selectedApi.queryParams.map((param) => (
                          <li key={param.name}>
                            <code>{param.name}</code>{" "}
                            <span style={{ color: param.required ? "red" : "green" }}>
                              {param.required ? "required" : "optional"}
                            </span>{" "}
                            — {param.description}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}

                  {selectedApi.id === "4-1" ? (
                    <div id="generate-blackbox-code">

                      <h3>Step 1: Include JavaScript Files</h3>
                      <p>Include the provided <code>config.js</code> and <code>loader_only.js</code> JavaScript files on your signup page in the following order:</p>

                      <h4>1.a. Add <code>config.js</code></h4>
                      <pre style={{
                          background: "#f8f9fa",
                          padding: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          maxHeight: "300px", // Limit the height for scroll
                          overflow: "auto", // Add scroll if content overflows
                          whiteSpace: "pre-wrap", // Wrap long lines for better readability
                          wordWrap: "break-word", // Break words at the end of line
                          margin: 0 // Ensure no extra space on top/bottom
                        }}
                      >
                        <code>
                          {`
                            window.io_global_object_name = "IGLOO";
                            window.IGLOO = window.IGLOO || {
                              "enable_flash" : false,
                              "bbout_element_id" : "ioBlackBox",  // this can be changed to store in a different hidden field (or removed to use a different collection method)
                              "loader" : {
                                "subkey"  : "i07bAlexpwOuUoOhI2Z81QL0xKnFrxmVSbWC7Ar-XH4",
                                "version" : "general5"
                              }
                            };
                          `}
                        </code>
                      </pre>

                      <h4>1.b. Add <code>loader_only.js</code></h4>
                      <pre style={{
                          background: "#f8f9fa",
                          padding: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          maxHeight: "300px",
                          overflow: "auto",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}>
                        <code>
                          {`
                  (function B() {
                              function v(e, a) {
                                  var b = {},
                                      c;
                                  for (c = e.length - 1; - 1 < c; c--) 0 < c ? b[c] = function() {
                                      var d = c;
                                      return function() {
                                          return w(e[d], b[d + 1], a)
                                      }
                                  }() : w(e[c], b[c + 1], a)
                              }
                              function w(e, n, k) {
                                  var c = document.createElement("script"),
                                      f, g, l;
                                  l = A(a[k] && a[k].staticVer && a[k].staticVer + "/" || e[1]);
                                  e[0] = e[0].replace("##version##", l);
                                  f = e[0].split("?")[0].split("/");
                                  g = f[f.length - 1].split(".")[0];
                                  u.test(e[1]) && l !== e[1] && d("loader: Overriding configured version with staticVer.");
                                  c.setAttribute("src", e[0]);
                                  c && c.addEventListener ?
                                      c.addEventListener("error", function() {
                                          b[k + "_" + g + "_load_failure"] = "true"
                                      }) : c.attachEvent && c.attachEvent("onerror", function() {
                                          b[k + "_" + g + "_load_failure"] = "true"
                                      });
                                  n && (c.onload = n);
                                  document.getElementsByTagName("head")[0].appendChild(c)
                              }
                              function d(e) {
                                  if ("function" === typeof a.trace_handler) try {
                                      a.trace_handler(e)
                                  } catch (b) {}
                              }
                              function f(b, a) {
                                  var d = null !== b && void 0 !== b;
                                  return !d || "1" !== b.toString() && "true" !== b.toString().toLowerCase() ? !d || "0" !== b.toString() && "false" !== b.toString().toLowerCase() ? "boolean" ===
                                      typeof a ? a : !1 : !1 : !0
                              }
                              function A(a) {
                                  d("********** version before replace: " + a + " **********");
                                  d('localNamespace[ "url_dots_to_dashes" ]: ' + b.url_dots_to_dashes);
                                  d("numericVersionPattern.test( output ): " + u.test(a));
                                  b.url_dots_to_dashes && u.test(a) && (a = a.replace(/\./g, "-"));
                                  d("version after replace: " + a);
                                  return a
                              }
                              var g = window,
                                  x = g.io_global_object_name || "IGLOO",
                                  a = g[x] = g[x] || {},
                                  b = a.loader = a.loader || {},
                                  y = [],
                                  z = [],
                                  u = /^[0-9]{1,3}(\.[0-9]{1,3}){2}\/$/;
                              if (b.loaderMain) return d("loader: Loader script has already run, try reducing the number of places it's being included."),
                                  !1;
                              b.loaderMain = B;
                              b.loaderVer = "5.2.2";
                              (function() {
                                  var e = f(b.tp, !0),
                                      n = f(b.fp_static, !0),
                                      k = f(b.fp_dyn, !0),
                                      c = f(b.enable_legacy_compatibility),
                                      u = f(b.tp_split),
                                      v = b.tp_host && b.tp_host.replace(/\/+$/, "") || "https://mpsnare.iesnare.com",
                                      l = b.fp_static_override_uri,
                                      m = void 0 !== b.uri_hook ? b.uri_hook + "/" : "/iojs/",
                                      p = (b.version || "versionOrAliasIsRequired") + "/",
                                      w = b.subkey ? g.encodeURIComponent(b.subkey) + "/" : "",
                                      x = b.tp_resource || "wdp.js",
                                      q = b.tp_host ? "&tp_host=" + g.encodeURIComponent(b.tp_host) : "",
                                      C = l ? "&fp_static_uri=" +
                                      g.encodeURIComponent(l) : "",
                                      r, t, h;
                                  b.tp_host = v;
                                  r = f(a.enable_flash, !0);
                                  t = a.io && a.io.enable_flash;
                                  h = a.fp && a.fp.enable_flash;
                                  t = void 0 !== t && null !== t ? f(t, !0) : r;
                                  void 0 !== h && null !== h ? h = f(h, !0) : t = r;
                                  r = t ? "&flash=true" : "&flash=false";
                                  h = h ? "&flash=true" : "&flash=false";
                                  q = "?loaderVer=" + b.loaderVer + "&compat=" + c + "&tp=" + e + "&tp_split=" + u + q + "&fp_static=" + n + "&fp_dyn=" + k + C;
                                  e || n || d("loader: Not currently configured to load fp_static or tp script(s).");
                                  a.fp && a.fp.staticVer && a.fp.staticVer + "/" !== p && (p = A(a.fp.staticVer + "/"),
                                      d("loader: Configured version replaced with that from pre-loaded static script."));
                                  n || a.fp && a.fp.staticMain ? (m = (m + "##version##" + w).replace(/\/\//g, "/"), n && (a.fp && a.fp.staticMain ? c && !a.fp.preCompatMain && d("loader: enable_legacy_compatibility on, but included static does not have the compat wrapper.") : l ? y.push([l, ""]) : y.push([m + "static_wdp.js" + q + h, p])), !k || a.fp && a.fp.dynMain ? a.fp && a.fp.dynMain && d("loader: First party dynamic script has already been loaded, disable fp_dyn or make sure you're not manually including the dynamic file separately.") :
                                      y.push([m + "dyn_wdp.js" + q + h, p])) : f(b.fp_dyn) && d("loader: Invalid Config, first party dynamic script set to load without static.");
                                  e && (a.io && a.io.staticMain ? d("loader: Third party script has already been loaded.") : (m = v + "/##version##" + w, u ? (z.push([m + "static_wdp.js" + q + r, p]), z.push([m + "dyn_wdp.js" + q + r, p]), b.tp_resource && d("loader: Invalid Config: both tp_resource and tp_split set. Ignoring tp_resource.")) : z.push([m + x + q + r, p])))
                              })();
                              v(y, "fp");
                              v(z, "io")
                          })();
                          `}
                        </code>
                      </pre>

                      <h3>Step 2: Retrieve the Blackbox Data</h3>
                      <p>After loading the scripts, use the following method to retrieve the blackbox data:</p>
                      <pre>
                        <code>
                          {`
                  var blackbox_info = window.IGLOO.getBlackbox();
                          `}
                        </code>
                      </pre>
                      <p>The retrieved data will be a JSON object in the following format:</p>
                      <pre>
                        <code>
                          {`
                  {
                    "blackbox": "blackbox_value",
                    "finished": true
                  }
                          `}
                        </code>
                      </pre>
                      <ul>
                        <li><strong>blackbox:</strong> The updated blackbox value.</li>
                        <li><strong>finished:</strong> A Boolean indicating whether all data collection methods have completed.</li>
                      </ul>

                      <h3>Step 3: Pass the Blackbox Code in Your API Request</h3>
                      <p>Use the following code to pass the blackbox code as part of the request body:</p>
                      <pre>
                        <code>
                          {`
                  var blackboxCode = blackbox_info.blackbox;
                          `}
                        </code>
                      </pre>
                      <p>Include the <code>blackboxCode</code> in your API request body:</p>

                      <h4>Sample Request</h4>
                      <pre>
                        <code>
                          {`
                  POST /api/example
                  Content-Type: application/json

                  {
                    "blackboxCode": "blackbox_value",
                    "otherParameter": "exampleValue"
                  }
                          `}
                        </code>
                      </pre>

                    </div>
                  ) : null}


                  {selectedApi.headers && (
                    <>
                      <h4>Headers</h4>
                      <ul>
                        {selectedApi.headers.map((header) => (
                          <li key={header.name}>
                            <code>{header.name}</code>{" "}
                            <span style={{ color: header.required ? "red" : "green" }}>
                              {header.required ? "required" : "optional"}
                            </span>{" "}
                            — {header.description}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}

                  {selectedApi.request && (
                    <>
                      <h4>Request</h4>
                      <pre
                        style={{
                          background: "#f8f9fa",
                          padding: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          maxHeight: "300px",
                          overflow: "auto",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                      >
                        {JSON.stringify(selectedApi.request, null, 2)}
                      </pre>
                    </>
                  )}
                {selectedApi.response && (
                    <>
                  <h4>Response</h4>
                  <pre
                    style={{
                      background: "#f8f9fa",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      maxHeight: "300px",
                      overflow: "auto",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                  >
                    {JSON.stringify(
                      truncateLongStrings(selectedApi.response), // Truncate long strings
                      null,
                      2
                    )}
                  </pre>
                    </>
                  )}
                </>
              ) : (
                <p>Select an API from the sidebar to view details.</p>
              )}
            </div>
          </div>


      <BootstrapDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Typography level="h3">{operation == "disabled" ? "Deactivate" : "Activate"} User</Typography>
        </BootstrapDialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "black" }}>
            Are you sure you want to {operation == "disabled" ? "deactivate" : "activate"} this user?</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button variant="contained" color="primary" sx={{ minWidth: 150 }} onClick={() => { handleClose() }}>
            No
          </Button>
          <Button variant="contained" color='success' sx={{ minWidth: 150 }} onClick={() => { enableDisableUser(); }}>
            Yes
          </Button>
        </DialogActions>
      </BootstrapDialog>

      {/* second popup start here */}
      <Dialog
                open={open1}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setOpen1(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="responsive-dialog-title"
                fullWidth={fullWidth}
                maxWidth={'sm'}
            >
                <DialogTitle id="responsive-dialog-title">
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                        <Typography level="h4">Alert</Typography>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Typography> This Client Secret can only be downloaded once to keep your account secure.
                            This is the last time we still show you the Client Secret.</Typography>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"
                                onClick={() => setOpen1(false)}
                                sx={{ minWidth: 250 }}>
                                CANCEL
                            </Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained" color="success" sx={{ minWidth: 250 }}
                                onClick={handleOk}
                            >
                                OK
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {/* second popup end here */}

            {/* third popup start here */}
            <Dialog
                open={open2}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setOpen2(false);
                    }
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="responsive-dialog-title"
                fullWidth={fullWidth}
                maxWidth={'sm'} >
                <DialogTitle id="responsive-dialog-title">
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={1}>
                        <Typography level="h4">Confirm and deactivate current key</Typography>
                    </Grid>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClickClose2}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }} >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Typography level="h6"><b>This is required to get a new key.</b></Typography>
                    </Grid>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={selectedOption}
                                onChange={handleRadioChange}
                                name="radio-buttons-group">
                                <FormControlLabel value="immediate" control={<Radio />} label="Deactivate old key immediately" />
                                <FormControlLabel value="24hours" control={<Radio />} label="Deactivate old key in 24 hours" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"
                                onClick={() => setOpen2(false)}
                                sx={{ minWidth: 250 }}>
                                CANCEL
                            </Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained" color="success" sx={{ minWidth: 250 }} onClick={handleConfirmDeactivate} disabled={isBtnDisable}>
                                Confirm and Deactivate
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {/* third popup end here */}

            <Dialog
                open={deleteOpen}
                onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    setDeleteOpen(false)
                }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
			>
                <DialogTitle id="alert-dialog-title">Delete Client Key</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this client key?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button autoFocus variant="contained" sx={{ minWidth: 100 }} onClick={closeDeleteKey} >
                    Cancel
                </Button>
                <Button autoFocus style={{ backgroundColor: 'red', color: 'white', minWidth: 100 }} onClick={deleteKey}>
                    Delete
                </Button>
                </DialogActions>
			    </Dialog>

                <Dialog
                    open={APIAccessOpen}
                    onClose={(_, reason) => {
                        if (reason !== "backdropClick") {
                            NotificationHandleClose();
                        }
                    }}
                    fullWidth={fullWidth}
                    maxWidth={'sm'}
                >
                    <DialogTitle variant="h6" color='primary'>Change API Access</DialogTitle>
                    <DialogContent>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            {
                                APIAccessFlag ? 
                                <>
                                    If you disable this, you will not access API.
                                </>
                                : 
                                <>
                                Continue to access API.
                                </>
                               
                            }

                            <br/><br/>
                            Are you sure, you want continue ?

                            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={2} mt={1}>
                            
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button variant="contained" onClick={NotificationHandleClose} sx={{ minWidth: 200, backgroundColor: "#2A68B3", color: "white" }} color="primary">
                                        No
                                    </Button>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <Button variant="contained" onClick={changeAPIAccessStatus} sx={{ minWidth: 200, backgroundColor: "#76C044", color: "white" }} color="success">
                                        Yes
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
    </>
  );

}


export default ApiUser;